<template>
    <div style="position: relative;" v-if="startViewVisible == true" :style="{width: windowInnerWidth, height: windowInnerHeight, background: `url(${publicPath}static/images/title_ground.png)`}">

        <StartTitleView
            :loadingPercent="100"
            :onlyPercent="false"
            @clickStartBtn="clickStartLoadBtn"
        />

        <div class="interaction-ui-upperRight" style="z-index: 22;">
            <div class="icon-part" @click="clearCache">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-broom" />
                </div>
                <span class="icon-span" tkey="清除緩存">{{i18n.tkey("lang_clear_cache")}}</span>
            </div>

            <div class="icon-part" @click="langSelectVisible = true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-language" />
                </div>
                <span class="icon-span" tkey="語言">{{i18n.tkey("lang_lang")}}</span>
            </div>

            <div class="icon-part" @click="clickAudio" v-show="userInfoRef.openSound === true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-volume-xmark" />
                </div>
                <span class="icon-span" tkey="靜音">{{i18n.tkey("lang_mute")}}</span>
            </div>

            <div class="icon-part" @click="clickAudio" v-show="userInfoRef.openSound === false">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-volume-high" />
                </div>
                <span class="icon-span" tkey="開啟聲音">{{i18n.tkey("lang_open_sound")}}</span>
            </div>
        </div>

        <!--        <countrySelect v-if="selectCountryVisible == true" @save-complete="selectCountryCallback" />-->

        <div class="coutry-select-render" v-if="selectCountryVisible == true">
            <earthView @clickRegion="selectCountryCallback" :showCloseBtn="false" />
        </div>

        <languageSelect v-if="langSelectVisible == true" @save-complete="langSelectVisible = false" />

        <el-dialog
            v-model="islandSelectVisible"
            :title="i18n.tkey('lang_toggle_island')"
            :width="isMobile == true?'95%':'50%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
        >
            <IslandSelect
                :autoJump="false"
                @selectCallback="selectIslandCallback"
            />
        </el-dialog>


    </div>

    <div style="position: relative" :style="{width: windowInnerWidth, height: windowInnerHeight}"  v-if="startViewVisible == false">
        <video
            style="display: none"
            id="video"
            webkit-playsinline
            playsinline
            loop
            v-if="null != videoDomSrc"
        >
            <source :src="videoDomSrc">
        </video>

        <div style="text-align: center" id="three">

        </div>

        <div class="shopopee-chat-view" :class="shopopeeChatStatus === 'hide' ? 'shopopee-chat-view-retract' : 'shopopee-chat-view-extend'" v-show="shopopeeChatVisible === true">
            <div style="position: relative; width: 100%; height: calc(100% - 50px);margin-top: 50px;">
                <phoneDemo
                    ref="shopopeePhone"
                    @exec-command-complete="phoneCommandCallback"
                    @login-complete="loginCallback"
                    @goShopPosition="goShopPosition"
                    @goThreeGuide="goThreeGuide"
                    @clickAudio="clickAudio"
                    @newShop="clickNewShop"
                    @returnShopopee="clickReturnShopopee"
                    :class="shopopeeChatStatus === 'hide' ? 'hide-phone' : 'show-phone'"
                />

                <div class="close-div" :class="shopopeeChatStatus === 'hide' ? 'close-div-hide' : 'close-div-show'" @click="hideShopopeeChatBox">
                    <font-awesome-icon icon="fa-solid fa-xmark" />
                </div>
            </div>
        </div>

        <!--    开始页面    -->
        <StartTitleView
            :loadingPercent="loadingPercent"
            :onlyPercent="true"
            @clickStartBtn="clickTitleStart"
            v-if="titleViewVisible === true"
        />

        <!--    加载页面    -->
        <LoadingWithPlane
            v-if="loadingCarViewVisible === true"
        />

        <!--    下方的操作栏    -->
        <BottomInteraction
            :bottomUIObj="bottomUIObj"
            @clickIcon="clickInteractionCallback"
            v-show="bottomInteractionUiVisible === true"
        />

        <!--    询问框    -->
        <ConfirmComponent
            v-show="confirmVisible === true"
            :confirmText="confirmText"
            @clickSure="sureConfirm"
            @clickCancel="closeConfirm"
        />

        <!--    聊天框    -->
        <MsgBox
            :chatPersonName="chatPersonName"
            :chatMsgText="chatMsgText"
            @clickMsgBox="clickPersonChat"
            v-show="chatVisible === true"
        />

        <!--    名片框    -->
        <CardBox
            :imgSrc="currCardSrc"
            @clickImg="goCardHref"
            @clickRequest="goCardRequest"
            @clickClose="closeCardBox"
            v-show="cardVisible === true"
        />

        <!--        區域傳送選擇框         -->
        <div class="select-area-box" v-show="selectAreaVisible === true">
            <div class="select-area-div">
                <ul class="select-ul">
                    <li class="title-part">
                        {{i18n.tkey("lang_select_area_door_num_pls")}}
                    </li>

                    <li class="content-part">
                        <ul class="select-input-part">
                            <li>
                                <el-select v-model="selectAreaNum" class="m-2" :placeholder="i18n.tkey('lang_area_num')" size="large">
                                    <el-option
                                        v-for="n in lastPageNum"
                                        :key="n"
                                        :label="n"
                                        :value="n"
                                    />
                                </el-select>
                            </li>

                            <li>
                                &nbsp;&nbsp;-&nbsp;&nbsp;
                            </li>

                            <li>
                                <el-select v-model="selectDoorNum" class="m-2" :placeholder="i18n.tkey('lang_doornum_option_text')" size="large" clearable>
                                    <el-option
                                        v-for="i in 40"
                                        :key="i"
                                        :label="i"
                                        :value="i"
                                    />
                                </el-select>
                            </li>
                        </ul>
                    </li>

                    <li class="btns-part">
                        <div class="operation-box">
                            <confirmButton type="success" @click="goSelectArea">
                                {{i18n.tkey("lang_sure")}}
                            </confirmButton>

                            <confirmButton type="danger" @click="closeSelectArea">
                                {{i18n.tkey("lang_cancel")}}
                            </confirmButton>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!--    右上角的操作欄    -->
        <div class="interaction-ui-upperRight" v-show="upperRightUiVisible === true">
<!--        聊天按鈕
            <div class="icon-part" @click="goChatView" v-show="userInfoRef.memberStatus === -1">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-comments" />
                </div>
                <span class="icon-span" tkey="聊天">{{i18n.tkey("lang_chat_text")}}</span>
            </div>-->

            <div class="icon-part" @click="goTaxi" v-show="taxiObj != null" >
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-taxi" />
                </div>
                <span class="icon-span" tkey="的士">{{i18n.tkey("lang_taxi")}}</span>
            </div>

            <!--            <div class="icon-part" @click="ReportAnimation()" v-show="userInfoRef.addinfo6 == -1" >-->
            <!--                <div class="icon-text">-->
            <!--                    <font-awesome-icon icon="fa-solid fa-user-astronaut" />-->
            <!--                </div>-->
            <!--                <span class="icon-span" tkey="營運員">{{i18n.tkey("lang_Operator_3d")}}</span>-->
            <!--            </div>-->

            <div class="icon-part" @click="goLogin" v-show="userInfoRef.memberStatus === 0">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-mobile-screen-button" />
                </div>
                <span class="icon-span" tkey="登錄">{{i18n.tkey("lang_login")}}</span>
            </div>

            <div class="icon-part" @click="goAccountView" v-show="userInfoRef.memberStatus === -1">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-mobile-screen-button" />
                </div>
                <span class="icon-span" tkey="我的手機">{{i18n.tkey("lang_my_phone")}}</span>
            </div>

            <div class="icon-part" @click="clickAudio" v-show="userInfoRef.openSound === true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-volume-xmark" />
                </div>
                <span class="icon-span" tkey="靜音">{{i18n.tkey("lang_mute")}}</span>
            </div>

            <div class="icon-part" @click="clickAudio" v-show="userInfoRef.openSound === false">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-volume-high" />
                </div>
                <span class="icon-span" tkey="開啟聲音">{{i18n.tkey("lang_open_sound")}}</span>
            </div>

        </div>

        <!--    右上角的静音欄    -->
        <div class="interaction-ui-upperRight" v-show="upperRightUiVisibleForAnimation === true">
            <div class="icon-part" @click="skipAnimation">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-forward" />
                </div>
                <span class="icon-span" tkey="跳過">{{i18n.tkey("lang_skip")}}</span>
            </div>

            <div class="icon-part" @click="clickAudio" v-show="userInfoRef.openSound === true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-volume-xmark" />
                </div>
                <span class="icon-span" tkey="靜音">{{i18n.tkey("lang_mute")}}</span>
            </div>

            <div class="icon-part" @click="clickAudio" v-show="userInfoRef.openSound === false">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-volume-high" />
                </div>
                <span class="icon-span" tkey="開啟聲音">{{i18n.tkey("lang_open_sound")}}</span>
            </div>

        </div>

        <div
            class="interaction-searchInput-upperRight"
            v-show="upperRightUiVisible === true"
            style="display: flex;align-items: center;justify-content: center;"
        >
            <ShopopeeTVImg
                :shake="imgShakeFlag"
                @click="clickSearchInput"
            />
            &nbsp;<el-button type="danger" style ="padding: 0px;width: 42px;height: 42px;background-color: #ff0000;text-shadow: 2px 2px 4px #000000;border: 2px solid #b93939;" @click="click2dSearch" >
            <span style="text-shadow: 1px 1px 2px #000000;font-size: large;font-weight: bold;">2D</span>
          </el-button>
            <SearchStyleButton
                style="padding-right: 20px"
                @click="clickMaterialSearch"
            />
        </div>

        <!--    左上角的操作欄    -->
        <div class="interaction-ui-upperRight interaction-ui-upperLeft" v-show="upperRightUiVisible === true">

            <div class="icon-part" @click="langSelectVisible = true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-language" />
                </div>
                <span class="icon-span" tkey="語言">{{i18n.tkey("lang_lang")}}</span>
            </div>

            <div class="icon-part" v-show="!userInfoRef.vp" @click="userInfoRef.vp = true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-user-slash" />
                </div>
                <span class="icon-span" tkey="開啟"></span>
            </div>

            <div class="icon-part" v-show="userInfoRef.vp" @click="userInfoRef.vp = false">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-user-astronaut" />
                </div>
                <span class="icon-span" tkey="關閉"></span>
            </div>

            <div class="icon-part" style="position: relative;" @click="selectCountryVisible = true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-location-dot" />
                </div>
                <span class="icon-span" tkey="地區切換">{{i18n.tkey("lang_region_toggle")}}</span>
                <div class="over-width-btn" >
                    <span style="font-size: 20px;"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>
                    &nbsp;
                    <span>{{regionName}}</span>
                    <span>&nbsp;-&nbsp;{{userInfoRef.currPage}}</span>
                </div>

            </div>

        </div>

        <!--        新手引導組件          -->
        <ThreeGuideComponent v-if="guideViewVisible === true" @guide-complete="closeGuideView"/>

        <!--    上方的產品展示欄    -->
        <div class="show-material-ui-upper" v-if="productDisplayViewVisible">
            <threeShopMaterialGroup @clickMaterialBtn="goShopMaterialList" :materialList="showMaterialList" :titleText="showMaterialTitle"/>

            <div class="close-material-box-btn" @click="productDisplayViewVisible = false">
                <font-awesome-icon icon="fa-solid fa-xmark" />
            </div>
        </div>

        <ThreeRegNumComponent />

        <div ref="operationNipple" v-show="nippleViewVisible" style="display: inline-block; width: 80px; height: 80px; position: absolute; left: 10%; bottom: 165px; opacity: 0">

        </div>

        <el-dialog
            v-model="reportVisible"
            :title="i18n.tkey('lang_report_data_1')"
            :width="isMobile == true?'95%':'50%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <reportCharts />
        </el-dialog>

        <el-dialog
            v-model="hallVisible"
            :title="i18n.tkey('lang_select_goto_hall')"
            :width="isMobile == true?'95%':'50%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @closed="closeHallDialog"
        >
            <hallSelector :type="hallQueryType" @clickGo="clickGoHall" />
        </el-dialog>

        <languageSelect v-if="langSelectVisible == true" :confirmFlag="true" @save-complete="langSelectVisible = false" />

        <!--        <countrySelect v-if="selectCountryVisible == true" :showCloseBtn="true" @save-complete="selectLoadCountryCallback" @clickClose="selectCountryVisible = false" />-->

        <div class="coutry-select-render" v-if="selectCountryVisible == true">
            <earthView @clickRegion="selectLoadCountryCallback" @clickClose="selectCountryVisible = false" :showCloseBtn="true" />
        </div>

        <el-dialog
            v-model="islandSelectVisible"
            :title="i18n.tkey('lang_toggle_island')"
            :width="isMobile == true?'95%':'50%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="true"
            @close="closeIslandCallback"
        >
            <IslandSelect
                :autoJump="false"
                :saveRegionNum="true"
                @selectCallback="selectChangeIslandCallback"
            />
        </el-dialog>

        <el-dialog
            v-model="shareUrlVisible"
            :title="i18n.tkey('lang_share')"
            :width="isMobile ? '90%' : '800px'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="shareUrl = null"
        >
            <Share3DUrl
                :companycode="shareCompanyCode"
                :url="shareUrl"
                :type="1"
            />
        </el-dialog>

        <el-dialog
            v-model="advVideoVisible"
            :width="isMobile ? '95%' : '60%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @closed="advRecord = null"
        >
            <AdvCompanyViewer
                style="margin-top: -20px"
                :data="advRecord"
            />
        </el-dialog>

        <BlinkEffect
            v-if="blinkEffectVisible"
            @blink-complete="blinkEffectVisible = false"
        />

        <HkDistrictSelector
            class="map-select-box"
            :showClose="true"
            @select-complete="selectHkDistrictCallback"
            @clickClose="mapSelectorVisible = false"
            v-if="mapSelectorVisible"
        />

        <el-dialog
            v-model="chatSelectorVisible"
            :width="isMobile ? '95%' : '60%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="i18n.tkey('lang_select_chat_method')"
            @closed="chatCardId = null"
        >
            <ChatMethodSelector
                :cardId="chatCardId"
                @goShopopeeChat="goChatCallback"
            />
        </el-dialog>

      <el-dialog
          v-model="companySelectorVisible"
          :width="isMobile ? '95%' : '60%'"
          align-center
          destroy-on-close
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="i18n.tkey('lang_select_status_method')"
          @closed="seleteStor = null"
      >
        <storeWebsiteMethodSelector
            :seleteStor="seleteStor"
            @goShopopeeWebsite="gostoreWebsiteCallBack"
        />
      </el-dialog>

        <div
            class="person-editor-box"
            v-if="null != personCardObj"
        >
            <PersonEditor
                :obj="personCardObj"
                @clickClose="closePersonCardCallback"
                @goChat="personCardGoChatCallback"
                @goLogin="personCardGoLoginCallback"
                @goMaterialChat="personCardGoMaterialChatCallback"
            />
        </div>

    </div>

</template>

<script setup>
import {getCurrentInstance, onBeforeUnmount, onMounted, onBeforeMount, ref, toRef, provide, inject, computed, nextTick} from 'vue'
// import { useRouter, useRoute } from 'vue-router'
// import { storeToRefs } from 'pinia'
import nipplejs from "nipplejs"
import { useUserinfo } from '@/stores/userinfo'
import { usePageinfo } from "@/stores/pageinfo";
import phoneDemo from '@/views/phoneDemo.vue'
import ThreeGuideComponent from '@/components/ThreeGuideComponent.vue'
import threeShopMaterialGroup from '@/components/threeShopMaterialGroup.vue'
import ThreeRegNumComponent from '@/components/ThreeRegNumComponent.vue'
import reportCharts from "@/components/shopopee/report/reportCharts";
import confirmButton from "@/components/Shopopee3D/ui/confirmButton"
import countrySelect from "@/components/Shopopee3D/ui/countrySelect"
import hallSelector from "@/components/shopopee/hall/hallSelector"
import languageSelect from "@/components/Shopopee3D/ui/languageSelect"
import earthView from "@/views/earthView"
import IslandSelect from "@/components/Shopopee3D/ui/islandSelect.vue";
import ConfirmComponent from "@/plugins/projectA/ui/confirmComponent.vue";
import LoadingWithPlane from "@/plugins/projectA/ui/loadingWithPlane.vue";
import MsgBox from "@/plugins/projectA/ui/msgBox.vue";
import ShopopeeTVImg from "@/plugins/projectA/ui/shopopeeTVImg.vue";
import SearchStyleButton from "@/plugins/projectA/ui/searchStyleButton.vue";
import BottomInteraction from "@/plugins/projectA/ui/bottomInteraction.vue";
import StartTitleView from "@/plugins/projectA/ui/startTitleView.vue";
import {getCountryObj} from "@/util/countrycode";
import BlinkEffect from "@/components/Shopopee3D/effect/blinkEffect.vue";
//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCommentDots, faComments, faChevronRight, faAddressCard, faStore, faXmark, faDollarSign, faCircleH, faMobileScreenButton, faHelicopter, faCircleInfo, faArrowRightFromBracket, faMagnifyingGlass, faVolumeHigh, faVolumeXmark, faBroom, faUserAstronaut, faLanguage, faLocationDot, faForward, faBasketShopping, faPlaneDeparture, faMountainCity, faTaxi, faBan, faArrowUp, faMap, faArrowUpRightFromSquare, faUserSlash } from '@fortawesome/free-solid-svg-icons'
import { clone } from 'three/examples/jsm/utils/SkeletonUtils';

import * as TWEEN from '@tweenjs/tween.js'

import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader';
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader';
// import Stats from "three/examples/jsm/libs/stats.module";
import {GUI} from 'dat.gui';
import {TeleporterManager } from '@/util/TeleporterManager.js';
import {AudioManager} from '@/util/AudioManager.js';
import {ElMessage} from "element-plus";
import {Search} from '@element-plus/icons-vue';
import myUtil from "@/util/util";
import companyApi from "@/request/companyApi";
import record12Api from "@/request/record12Api";
import cookie from "@/util/cookie";
import record14Api from "@/request/record14Api";
import CardBox from "@/plugins/projectA/ui/cardBox.vue";
import Share3DUrl from "@/components/shopopee/share/share3DUrl.vue";
import AdvDisplayComponent from "@/components/shopopee/promotion/advDisplayComponent.vue";
import AdvCompanyViewer from "@/components/shopopee/adv/advCompanyViewer.vue";
import {CSS3DObject, CSS3DRenderer} from "three/addons/renderers/CSS3DRenderer";
import HkDistrictSelector from "@/components/Shopopee3D/ui/hkDistrictSelector.vue";
import ChatMethodSelector from "@/plugins/projectA/ui/chatMethodSelector.vue";
import StoreWebsiteMethodSelector from "@/plugins/projectA/ui/storeWebsiteMethodSelector.vue";

import {getHKAreaObj} from "@/util/hkDistrictCode";
import cardApi from "@/request/api";
import PersonEditor from "@/components/person/personEditor.vue";
import util from "@/util/util";
import baseUrl from "@/request/base";


const userinfo = useUserinfo()
const userInfoRef = toRef(userinfo)
const pageInfoRef = toRef(usePageinfo())

const i18n = inject("i18n")
const reload = inject("reload");

//导入图标
library.add(faCommentDots, faComments, faChevronRight, faAddressCard, faStore, faXmark, faDollarSign, faCircleH, faMobileScreenButton, faHelicopter, faCircleInfo, faArrowRightFromBracket, faMagnifyingGlass, faVolumeHigh, faVolumeXmark, faBroom, faUserAstronaut, faLanguage, faLocationDot, faForward, faBasketShopping, faPlaneDeparture, faMountainCity, faTaxi, faBan, faArrowUp, faMap, faArrowUpRightFromSquare, faUserSlash)

//创建stats对象
// const stats = new Stats();
//stats.domElement:web页面上输出计算结果,一个div元素，
// document.body.appendChild(stats.domElement);

let { proxy } = getCurrentInstance();
let THREE = proxy.$THREE;
const publicPath = process.env.BASE_URL

// const router = useRouter()
// const route = useRoute()

const props = defineProps(['countrycode', 'rid', 'did', "userFrom", "islandID"])
let rid = null
let did = null

const width = window.innerWidth
const height = window.innerHeight
const windowInnerWidth = ref((window.innerWidth) + "px")
const windowInnerHeight = ref((window.innerHeight) + "px")

const isMobile = ('ontouchstart' in document.documentElement)
//是否顯示開始頁面
const startViewVisible = ref(true)
//是否顯示語言選擇框
const langSelectVisible = ref(false)
//是否顯示選擇地區框
const selectCountryVisible = ref(false)

let mousedownFlag = false
let touchPoint = null
//是否按下搖桿
let nippleFlag = false
//是否开始渲染
let renderFlag = true

//是否可操作
let controlFlag = false
//操作模式
let operateMode = "normal"

const gltfLoader = new GLTFLoader();
const fbxLoader = new FBXLoader();
const dracoLoader = new DRACOLoader();

let animationFrameId

//加载百分比
let loadingPercent = ref(0)
//提示文字
let confirmText = ref("")
//是否提示可见
let confirmVisible = ref(false)
//確定按鈕綁定的方法
let confirmFunc
//取消按鈕綁定的方法
let cancelFunc

//当前显示的对话文字
let chatMsgText = ref("")
//当前对话对方的名字
let chatPersonName = ref("")
//对话框点击方法
let chatClickFunc
//是否对话框可见
let chatVisible = ref(false)
//对话列表
let chatMsgList
//当前对话序号
let chatMsgIndex

//是否显示聊天窗口
let shopopeeChatVisible = ref(false)
let shopopeeChatStatus = ref("hide")

//表報顯示
let reportVisible = ref(false)
//展馆显示
const hallVisible = ref(false)
//島嶼選擇展示
const islandSelectVisible = ref(false)

//店铺列表
let shopObjList = []
//廣告列表
let advList = []
//店铺Group列表
let shopPointList = []
//店铺人流量牌map
const shopTrafficPadMap = {}
//当前区域状态
const regionMap = {
    //歡迎點位
    welcomePoint: null,
    //傳送點旁邊站的人的點位
    transferManPoint_1: null,
    //直升機傳送點旁邊站的人點位
    transferManPoint_2: null,
    //是否来自邀请链接
    fromInvite: false,
    // 是否需要生成向导
    guideFlag: true,
    //向导的withAIObj
    guideWithAIObj: null,
    //向导的车
    guideCarObj: null,
    //记者对象
    reporterObj: null,
    //飞艇对象
    airShipObj: null,
    //飞艇广告牌
    airShipAdvPad: null,
    //是否可以触发广告动画
    airShipAdvVisible: false,
    //广告触发计时器
    airShipAdvTimer: 0,
    //当前广告序号
    airAdvIndex: 0,
    //是否正在播放广告
    airAdvPlayFlag: false,
    currPage: 1,
    lastPage: 1,
    selectShopIndex: null,
    shopMap: {},
}

//最後一個區的區號
const lastPageNum = ref(1)

//传送点坐标
const transmitPoint = new THREE.Vector3(580, 0, 38)
//开始点坐标
const startPoint = new THREE.Vector3(217.1, 0, 30)

//开始点坐标
var videoPoint = new THREE.Vector3(218.75, 0, 100)
//区号mesh
let regionNumPad = []
//汽車的withAIObjList
let carWithAIObjList = []

//名片图片链接
const currCardSrc = ref("")
//是否显示名片框
const cardVisible = ref(false)
//名片id
let cardId

//是否显示标题界面
const titleViewVisible = ref(true)
//是否显示下方的操作栏
const bottomInteractionUiVisible = ref(false)
//是否顯示右上角的操作欄
const upperRightUiVisible = ref(false)
//是否显示右上角的静音区域
const upperRightUiVisibleForAnimation = ref(false)
//是否顯示搖桿
const nippleViewVisible = ref(true)

//是否顯示選擇區域頁面
const selectAreaVisible = ref(false)
//選擇的區號
const selectAreaNum = ref(1)
//選擇的門牌號
const selectDoorNum = ref(null)


//直升機加載切換頁
const loadingCarViewVisible = ref(false)

//是否顯示新手教程
const guideViewVisible = ref(false)

//下方的互动选项
const bottomUIObj = ref({
    // "UUID": {
    //     icon: "fa-solid fa-address-card",
    //     text: "店员",
    //     callback: null
    // }
})

//是否顯示上方的產品展示欄
const productDisplayViewVisible = ref(false)
//產品展示欄展示的產品列表
const showMaterialList = ref([])
//產品展示欄的標題
const showMaterialTitle = ref(i18n.tkey("lang_shop_item_1"))
//展示店鋪的數據對象
const showMaterialShopdata = ref(null)

//startObj 开场动画涉及的模型
let startObj
let startObj2

//传送动画设计的模型
const tpObjMap = {}

//岛列表
const islandList = []

//展馆mesh
let shopopeeHallMesh = null
//展馆mesh
let shopopeeHallMesh2 = null
//展館的附屬Mesh
let shopopeeSubHallMeshList = []

//島的招牌
let islandNamePadMesh = null
//島的列表
let islandDataList = []
//當前島
let currIsland = null

const hallQueryType = ref(0)

//主角活動範圍限制
const MAX_POSITION_X = 578
const MIN_POSITION_X = 126
const MAX_POSITION_Z = 150
const MIN_POSITION_Z = -76

//空氣墻列表
const airWallList = {
    // "plane_ground_wall1": {
    //     MAX_POSITION_X: 267,
    //     MIN_POSITION_X: 225,
    //     MAX_POSITION_Z: 28.5,
    //     MIN_POSITION_Z: 26
    // },
    // "plane_ground_wall2": {
    //     MAX_POSITION_X: 267,
    //     MIN_POSITION_X: 264,
    //     MAX_POSITION_Z: 26,
    //     MIN_POSITION_Z: -76
    // },
    "shopopee_hall_1": {
        MAX_POSITION_X: 258,
        MIN_POSITION_X: 180.5,
        MAX_POSITION_Z: 138,
        MIN_POSITION_Z: 91,
    },
    "shopopee_hall_2": {
        MAX_POSITION_X: 165,
        MIN_POSITION_X: 126,
        MAX_POSITION_Z: 110,
        MIN_POSITION_Z: 46,
    },
    "shop_building_street_1": {
        MAX_POSITION_X: 408,
        MIN_POSITION_X: 285,
        MAX_POSITION_Z: 66.8,
        MIN_POSITION_Z: 54.4,
    },
    "shop_building_street_2": {
        MAX_POSITION_X: 408,
        MIN_POSITION_X: 285,
        MAX_POSITION_Z: 20.64,
        MIN_POSITION_Z: 7.5,
    },
    "shop_building_street_3": {
        MAX_POSITION_X: 557,
        MIN_POSITION_X: 434.2,
        MAX_POSITION_Z: 66.8,
        MIN_POSITION_Z: 54.4,
    },
    "shop_building_street_4": {
        MAX_POSITION_X: 557,
        MIN_POSITION_X: 434.2,
        MAX_POSITION_Z: 20.64,
        MIN_POSITION_Z: 7.5,
    },
}

const shopopeeHallWall = {
    MAX_POSITION_X: 258,
    MIN_POSITION_X: 180.5,
    MAX_POSITION_Z: 138,
    MIN_POSITION_Z: 91,
}

const shopopeeHallWall2= {
    MAX_POSITION_X: 267,
    MIN_POSITION_X: 264,
    MAX_POSITION_Z: 26,
    MIN_POSITION_Z: -76
}

//觸發區域對象
const triggerAreaMap = {
    // "newGuide": {
    //     scope: {
    //         MAX_POSITION_X: 257,
    //         MIN_POSITION_X: 255,
    //         MAX_POSITION_Z: 57.5,
    //         MIN_POSITION_Z: 28.6,
    //     },
    //     alive: false,
    //     timer: 5,
    //     timeLimit: 5,
    //     func: () => {
    //         if (userInfoRef.value.guideCount > 2){
    //             delete triggerAreaMap['newGuide']
    //         }else{
    //             controlFlag = false
    //             guideViewVisible.value = true
    //         }
    //     }
    // }
}

//可交互对象列表
const interactionList = []
//可交互對象映射對象
const interactionObj = {
    // "UUID": [{
    //     mesh: null,
    //     callback: null
    // }]
}
//可点击对象列表
let clickVisibleList = []
//傳送點map
const tpPointsMap = {}

//拥有ai的对象
const WithAIObjSet = {

}

//动作列表
const mixerObj = {

}

//主角模型
let model

//空白材质
const whiteMaterial = new THREE.MeshLambertMaterial({
    color: 0xffffff
})

//步行区域地面材质
const streetMaterial = new THREE.MeshBasicMaterial()
//镜子网格和设置
// const mirrorPlaneGeometry = new THREE.PlaneGeometry(650, 400);
// const mirrorPlaneGeometry2 = new THREE.PlaneGeometry(900, 400);
// const options = {
//
//     clipBias: 0.03,
//     // textureWidth: window.innerWidth * window.devicePixelRatio,
//     // textureHeight: window.innerHeight * window.devicePixelRatio,
//     textureWidth: 128,
//     textureHeight: 128,
//     color: 0x889999,
//     recursion: 1
//
// };

//贴图map
const textureMap = {}
//需要加载的贴图list
const textureNameList = [
    "outfit-classic-03-v2-m-bottom-D.jpg",
    "outfit-classic-03-v2-m-bottom-D_B.jpg",
    "outfit-classic-03-v2-m-bottom-D_G.jpg",
    "outfit-classic-03-v2-m-bottom-D_W.jpg",
    "outfit-classic-03-v2-m-top-D.jpg",
    "outfit-classic-03-v2-m-top-D_B.jpg",
    "outfit-classic-03-v2-m-top-D_W.jpg",
    "outfit-classic-03-v2-m-top-D_G.jpg",
]

const clock = new THREE.Clock();
const FPS = 30; // 指的是 30帧每秒的情况
const singleFrameTime = (1/FPS);
let timeStamp = 0
// let currTimeStamp = 0
let mixerUpdateDelta;

//每次渲染要執行的邏輯方法列表
let funcListObj = {}
//重新加载时需要删除的模型
let clearMeshList = []
//重新加载时需要删除的数据
let clearDataList = [
    // {
    //     "key": "",
    //     "map": {}
    // }
]

//當前執行的動作
let activeAction;
//上一個執行的動作
let previousAction;

//所有動作
let allActions ;

//纹理贴图加载器TextureLoader
const texLoader = new THREE.TextureLoader();
//招牌材质
// const signPlaneTex = texLoader.load(process.env.BASE_URL + '/mytextures/back.png')
// const shopSignMaterial = new THREE.MeshBasicMaterial({ //普通材质
//     color: 0xff5a00,//0xff0000设置材质颜色为红色
//     // map: signPlaneTex,
//     // side: THREE.DoubleSide
// });

//人对象组
const meshGroup = new THREE.Group()
const headGroup = new THREE.Group()

const cameraOptionObj = {
    //默认的第一人稱镜头距离
    defaultFirstCameraDistance: 0.1,
    //默认的第三人稱镜头距离
    defaultThirdCameraDistance: 6,
    //默认的镜头距离
    defaultCameraDistance: 0.1,
    //当前的镜头距离
    currCameraDistance: 0.1,
    //是否改变了镜头距离
    changeCameraDistance: false,
    //默认的镜头高度
    defalutCameraPositionY: 2.5,
    //当前的镜头高度
    currCameraPositionY: 2.5,
    //是否改变了镜头高度
    changeCameraPostionY: false,
    //默認的視點高度
    defaultCameraLookAtPositionY: 2.5,
    //當前的視點高度
    currCameraLookAtPositionY: 2.5,
}


//对话之前的镜头位置
let beforeCameraPosition
//对话之前的镜头旋转
let beforeCameraRotation
//对话之前镜头焦点
let beforeCameraUp
//触发对话的对象
let chatTargetObject

// 3D场景对象Scene
let scene
//渲染器
let render
//2D標籤渲染器
// let label2DRenderer
//3D標籤渲染器
let label3DRenderer
//摄像机
let camera
//天空盒攝像機
let cubeCamera

//相机控制
let controls

//加载过的物件
const loadObj = {}
//是否正在加载fbx模型
let fbxLoadFlag = false
//fbx模型的加载队列
const fbxLoadQueue = []
//是否正在加载glb模型
let glbLoadFlag = false
//glb模型的加载队列
const glbLoadQueue = []

//环境光
let ambient = new THREE.AmbientLight(0xffffff, 1.5);
//太阳光
// const directionalLight = new THREE.DirectionalLight(0xffffff, 2);

//全局环境贴图
let sceneEnvironmentMap
let testEnvMap

let testBox

let teleporterManager

let audioManager
//rotation角度 左右
let rotationNum = Math.PI / -2
//rotation角度 上下
let rotationNumY = 0

//是否在移動
let moveFlag = false
//移動方向
const moveVector3 = new THREE.Vector3()
moveVector3.normalize()
//方向增量
const numVector3 = new THREE.Vector3()
//操作列表
const operationObj = {
    "w": false,
    "d": false,
    "s": false,
    "a": false,
}

//Y轴向量
const yAxis = new THREE.Vector3(0,1,0)

//模型朝向
const faceVector3 = new THREE.Vector3()

//移动速度上限 (秒)
let MAXSPEED = process.env.NODE_ENV === 'production' ? userInfoRef.value.speed : userInfoRef.value.speed;
//当前移动速度
let speed = 0
//移動速度增量 (秒)
const speedAddSize = 0.6
//移動速度減量 (秒)
const speedMinusSize = 1.2
//移动射线
// const moveRaycaster = new THREE.Raycaster()
//移動計時
let moveTimeStamp = 0
//鼠标按下计时
let mouseDownTimeStamp = 0

//动画对象
const animationObjGroup = {}

//預設的路人閒聊內容
const commentTextList = [
    [i18n.tkey("lang_passerby_sentence_1_1"), i18n.tkey("lang_passerby_sentence_1_2")],
    [i18n.tkey("lang_passerby_sentence_2_1"), i18n.tkey("lang_passerby_sentence_2_2")],
    [i18n.tkey("lang_passerby_sentence_3_1"), i18n.tkey("lang_passerby_sentence_3_2")],
    [i18n.tkey("lang_passerby_sentence_4_1")],
    [i18n.tkey("lang_passerby_sentence_5_1")]
]

//展館門口的廣告牌列表
let hallDoorAdvList = []

//傳送時是否播放動畫
let tpAnimationFlag = true

//搖桿對象
let nippleObj = null

//是否顯示分享彈窗
const shareUrlVisible = ref(false)
const shareUrl = ref(null)
const shareType = ref("-1")
const shareCompanyCode = ref(null)

//是否顯示廣告視頻彈窗
const advVideoVisible = ref(false)
const advRecord = ref(null)

//觀光的士對象
const taxiObj = ref(null)

//是否显示闪光特效
const blinkEffectVisible = ref(false)

//是否顯示香港地圖
const mapSelectorVisible = ref(false)

//當前地區的名字
const regionName = computed(() => {
    let name = ""

    if (null != userInfoRef.value.selectCountry){
        const obj = getCountryObj(userInfoRef.value.selectCountry)

        if (null != obj){
            name = obj[userInfoRef.value.lang]
        }

    }

    if (null != userInfoRef.value.areacode){
        const obj = getHKAreaObj(userInfoRef.value.areacode)

        if (null != obj){
            name = obj[userInfoRef.value.lang]
        }

    }

    return name

})

//是否抖动
const imgShakeFlag = ref(true)

//視頻dom的src
const videoDomSrc = ref(publicPath + 'caption.mp4')

//聊天選擇框可見
const chatSelectorVisible = ref(false)


//網站選擇框可見
const companySelectorVisible = ref(false)

//聊天名片id
const chatCardId = ref(null)


//聊天名片id
const seleteStor = ref(null)

//名片列表
let allCardList = []
//选定的名片
const personCardObj = ref(null)

window.onresize = function () {
    // 重置渲染器输出画布canvas尺寸
    render.setSize(window.innerWidth, window.innerHeight);
    // label2DRenderer.setSize(window.innerWidth, window.innerHeight)
    label3DRenderer.setSize(window.innerWidth, window.innerHeight)
    // 全屏情况下：设置观察范围长宽比aspect为窗口宽高比
    camera.aspect = (window.innerWidth) / (window.innerHeight);
    // 渲染器执行render方法的时候会读取相机对象的投影矩阵属性projectionMatrix
    // 但是不会每渲染一帧，就通过相机的属性计算投影矩阵(节约计算资源)
    // 如果相机的一些属性发生了变化，需要执行updateProjectionMatrix ()方法更新相机的投影矩阵
    camera.updateProjectionMatrix();
};

//触摸事件处理
function handleDefaultTouchEvt(evt) {
    // if(!shopopeeChatVisible.value && !selectAreaVisible.value && !reportVisible.value && !hallVisible.value && !startViewVisible.value && !selectCountryVisible.value){
    evt.preventDefault()
    // }
}

//切換動作
function toggleActiveMotion(name){
    activeAction.paused = true
    previousAction = activeAction
    activeAction = allActions[name];
    activeAction.reset().play();

    previousAction.crossFadeTo( activeAction, 0.25 )
}

function toggleActiveMotionObj(obj, name) {
    obj.activeAction.paused = true
    obj.previousAction = obj.activeAction
    obj.activeAction = obj.allActions[name];
    obj.activeAction.reset().play();

    obj.previousAction.crossFadeTo( obj.activeAction, 0.25 )
}

function createMan() {
    let fileName = process.env.BASE_URL + `mymodels/gltf/town2/aman.gltf?r=${proxy.$versionNum}`
    // let fileName = process.env.BASE_URL + "mymodels/fbx/manp.fbx"

    if ( userInfoRef.value.modelSex === 1 ){
        fileName = process.env.BASE_URL + `mymodels/gltf/town2/agirl.gltf?r=${proxy.$versionNum}`
    }

    // if (null != userInfoRef.value.memmale && null == userInfoRef.value.modelSex){
    if (null != userInfoRef.value.memmale){
        if (userInfoRef.value.memmale == 0){
            fileName = process.env.BASE_URL + `mymodels/gltf/town2/aman.gltf?r=${proxy.$versionNum}`
            userInfoRef.value.modelSex = 0
        }else{
            fileName = process.env.BASE_URL + `mymodels/gltf/town2/agirl.gltf?r=${proxy.$versionNum}`
            userInfoRef.value.modelSex = 1
        }
    }

    loadLeadModel(fileName, true)

}

function loadLeadModel(fileName, initFlag = false) {
    gltfLoader.load(fileName, (gltf) => {
        // fbx.children[1].material.shininess = 0
        // const material = new THREE.MeshLambertMaterial({})
        // material.copy(fbx.children[1].material)
        // fbx.children[1].material = material

        model = gltf.scene;
        testBox = model
        //放大縮小
        let box3 = new THREE.Box3()
        let obj = new THREE.Vector3()
        let scaleNum
        box3.setFromObject(model)
        box3.getSize(obj)

        if (fileName.indexOf("aman") != -1){
            scaleNum = 0.48 / obj.getComponent(1)
        }else{
            scaleNum = 0.38 / obj.getComponent(1)
        }

        let vector = new THREE.Vector3(scaleNum, scaleNum, scaleNum);
        model.scale.multiply(vector);

        box3.setFromObject(model)
        box3.getSize(obj)

        model.position.x = 0
        model.position.y = 0
        model.position.z = 0

        meshGroup.add( model );

        model.traverse( function ( object ) {

            if ( object.isMesh ) {
                // object.castShadow = true;

                object.material.emissive = new THREE.Color(1,1,1);
                object.material.emissiveIntensity = 1;
                object.material.emissiveMap = object.material.map;
            }

            if (object.name === "ashangshen"){
                object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
            }

            if (object.name === "asjiao"){
                object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
                // const material = new THREE.MeshLambertMaterial()
                // material.copy(object.material)
                // object.material = material
                // object.material.color = new THREE.Color(0, 0, 1)
                // object.material.shininess = 0
            }

            if (object.name === "astui"){
                object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
            }

            if (object.name === "toufa"){
                const material = new THREE.MeshLambertMaterial()
                material.copy(object.material)
                object.material = material
            }
        } );

        //动作
        const mixer = new THREE.AnimationMixer( model );
        mixerObj[meshGroup.id] = mixer
        //注册动作播放方法
        funcListObj['updateMixerByTime'] = updateMixerByTime

        allActions = {};

        let animations = gltf.animations;

        //遍歷所有動作
        for ( let i = 0; i !== animations.length; ++ i ) {
            //動作
            const clip = animations[ i ];
            const action = mixer.clipAction( clip );
            allActions[clip.name ] = action;

        }

        activeAction = allActions['idle'];
        activeAction.play();

        //将头加入到人物
        meshGroup.add(headGroup)
        headGroup.position.setY(2.5)

        //將燈光綁定到人物
        // meshGroup.add(directionalLight)
        // const lightPoint = new THREE.Group()
        // meshGroup.add(lightPoint)
        // lightPoint.position.set(50, 0, 50)
        // directionalLight.position.set(0, 50, 0)
        // directionalLight.target = lightPoint

        //注册改变太阳光焦点方法
        // funcListObj['changeSunLightTarget'] = () => {
        //     directionalLight.target = lightPoint
        // }

        renderFlag = true

        if (initFlag){
            loadLeadModelCallback()
        }

    })
}

function loadLeadModelCallback() {
    //注册人物移动方法
    funcListObj['movePerson'] = movePerson

    const group = new THREE.Group()
    group.position.copy(transmitPoint)

    interactionObj[group.uuid] = [
        // {
        //     distance: 11,
        //     icon: "fa-solid fa-arrow-right-from-bracket",
        //     name: "下一區",
        //     // mesh: shopList[index].children[0],
        //     mesh: group,
        //     callback: () => {
        //         // goShopConfirm(index)
        //         goNextRegionConfirm()
        //     }
        // },
        {
            distance: 11,
            icon: "fa-solid fa-arrow-right-from-bracket",
            name: i18n.tkey("lang_next_district"),
            mesh: group,
            callback: () => {
                tpAnimationFlag = false
                toggleSelectAreaBox(true)
            }
        }
    ]

    //meshGroup.position.set(0, 0, 0)

    teleporterManager.createTeleporter()

    audioManager.createAudio()

    loadingPercent.value += 5

    renderFrame()
}

function initValue() {
    dracoLoader.setDecoderPath(`${process.env.BASE_URL}static/js/draco/`)
    dracoLoader.setDecoderConfig({ type: 'js' });
    dracoLoader.preload();
    gltfLoader.setDRACOLoader(dracoLoader)

    scene = new THREE.Scene()
    // camera = new THREE.PerspectiveCamera(45, 8.0 / 5.0, 0.1, 600)
    camera = new THREE.PerspectiveCamera(60, 8.0 / 5.0, 0.01, 600)
    camera.aspect = (window.innerWidth) / (window.innerHeight);
    camera.updateProjectionMatrix();
    render = new THREE.WebGLRenderer({
        logarithmicDepthBuffer: true, // 设置对数深度缓冲区，优化深度冲突问题
        antialias: true, //开启抗锯齿,
        alpha: true,
        precision: 'mediump',
        powerPreference: "high-performance",
    })

    render.gammaInput = true;
    render.gammaOutput = true;//inear转gamma
    render.toneMapping = THREE.ACESFilmicToneMapping
    render.useLegacyLights = true

    render.setPixelRatio(window.devicePixelRatio); //设置屏幕像素比
    // render.setPixelRatio(1); //设置屏幕像素比
    render.setClearColor(0x000000, 1); //设置背景色

    // const lightPoint = new THREE.Group()
    // lightPoint.position.set(-50, 0, -50)

    // 实例化css2d的渲染器
    // label2DRenderer = new CSS2DRenderer();
    // label2DRenderer.setSize(window.innerWidth, window.innerHeight);
    // document.body.appendChild(label2DRenderer.domElement)
    //设置样式
    // label2DRenderer.domElement.style.position = 'fixed';
    // label2DRenderer.domElement.style.top = '0px';
    // label2DRenderer.domElement.style.left = '0px';
    // label2DRenderer.domElement.style.zIndex = '10';//设置层级
    // label2DRenderer.domElement.style.pointerEvents = 'none'

    // 实例化css3d的渲染器
    label3DRenderer = new CSS3DRenderer();
    label3DRenderer.setSize(window.innerWidth, window.innerHeight);

    //设置样式
    label3DRenderer.domElement.style.position = 'absolute';
    label3DRenderer.domElement.style.top = '0px';
    label3DRenderer.domElement.style.left = '0px';
    label3DRenderer.domElement.style.pointerEvents = 'none'

    document.body.appendChild(label3DRenderer.domElement)

    funcListObj['updateTween'] = updateTween
    funcListObj['updateAIObj'] = updateAIObj
    funcListObj['checkInteractionObj'] = checkInteractionObj
    funcListObj['checkTriggerMap'] = checkTriggerMap

    teleporterManager = new TeleporterManager(scene)
    audioManager = new AudioManager(scene,camera)

    regionMap.currPage = userInfoRef.value.currPage

    if (userInfoRef.value.guideCount > 2){
        delete triggerAreaMap['newGuide']
    }

    // const listener = new THREE.AudioListener();
    // camera.add( listener );

    // // create the PositionalAudio object (passing in the listener)
    // const sound = new THREE.PositionalAudio( listener );

    // // load a sound and set it as the PositionalAudio object's buffer
    // const audioLoader = new THREE.AudioLoader();
    // audioLoader.load( process.env.BASE_URL +'audio/我记得.m4a', function( buffer ) {
    // 	sound.setBuffer( buffer );
    // 	sound.setRefDistance( 20 );
    // 	sound.play();
    // });

    // // create an object for the sound to play from
    // const sphere = new THREE.SphereGeometry( 220, 32, 16 );
    // const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
    // const mesh = new THREE.Mesh( sphere, material );
    // scene.add( mesh );

    // // finally add the sound to the mesh
    // mesh.add( sound );
}

function initPage() {
    if (isMobile){
        document.getElementById("three").addEventListener('touchmove', handleDefaultTouchEvt, {passive: false})
    }

    //創建搖桿
    var options = {
        zone: proxy.$refs.operationNipple,
        mode: 'static',
        position: {left: '50%', top: '50%'},
        // color: 'gray',
        color: 'red',
        size: window.innerWidth > 768 ? 120 : 120,
        threshold: 0.1
    }

    const manager = nipplejs.create(options);
    nippleObj = manager

    // nippleObj.on('dir', function (evt, data) {
    //     console.log(data)
    //     // Do something.
    // });

    nippleObj.on('start', function (evt, data) {
        // console.log(data)

        if (!controlFlag){
            return;
        }

        // mousedownFlag = true
        // moveFlag = true
        nippleFlag = true

    });

    nippleObj.on('move', function (evt, data) {
        // console.log(data)
        // console.log(data.angle.radian)

        // evt.preventDefault()

        if (!controlFlag){
            return;
        }

        if (operateMode === "watch"){

            funcListObj["moveCameraFunc_1"] = () => {
                rotationNum += data.vector.x * 0.02 * 30 * mixerUpdateDelta
                rotationNumY += data.vector.y * 0.005 * 30 * mixerUpdateDelta

                calcCameraPosition()
            }

        }else{
            if ((data.angle.radian > Math.PI / 180 * 45 && data.angle.radian < Math.PI / 180 * 135) || (data.angle.radian > Math.PI / 180 * 225 && data.angle.radian < Math.PI / 180 * 315)){

                if (null != funcListObj["moveCameraFunc_1"]){
                    delete funcListObj["moveCameraFunc_1"]
                }

                mousedownFlag = true
                moveFlag = true

                moveVector3.x = 0 - camera.position.x
                moveVector3.y = 0
                moveVector3.z = 0 - camera.position.z

                moveVector3.normalize()
                moveVector3.applyAxisAngle(yAxis, data.angle.radian - Math.PI / 2)

            }else{
                mousedownFlag = false
                moveFlag = false

                if (data.angle.radian > Math.PI / 180 * 135 && data.angle.radian < Math.PI / 180 * 225){
                    funcListObj["moveCameraFunc_1"] = () => {
                        rotationNum -= data.distance / 50 * 0.02 * 30 * mixerUpdateDelta

                        calcCameraPosition()
                    }
                }else{
                    funcListObj["moveCameraFunc_1"] = () => {
                        rotationNum += data.distance / 50 * 0.02 * 30 * mixerUpdateDelta

                        calcCameraPosition()
                    }
                }
            }
        }



        // moveVector3.x = data.vector.x * -1
        // moveVector3.y = 0
        // moveVector3.z = data.vector.y

        // moveVector3.x = 0 - camera.position.x
        // moveVector3.y = 0
        // moveVector3.z = 0 - camera.position.z
        //
        // moveVector3.normalize()
        //
        // moveVector3.applyAxisAngle(yAxis, data.angle.radian - Math.PI / 2)

    });

    nippleObj.on('end', function (evt, data) {
        // console.log(data)

        mousedownFlag = false
        moveFlag = false
        touchPoint = null
        nippleFlag = false

        delete funcListObj["moveCameraFunc_1"]
    });

    proxy.$refs.operationNipple.style.opacity = 1
    proxy.$refs.operationNipple.style.display = "none"

    //读取街道地图
    const mapTexture = texLoader.load(process.env.BASE_URL + 'mytextures/cobbles-12_diffuse.jpg')
    mapTexture.wrapS = mapTexture.wrapT = THREE.RepeatWrapping;// CHANGED-->
    // mapTexture.offset.set(0, 0.5); // CHANGED-->
    mapTexture.repeat.set(100, 200);//但贴图重复过多时，可将此参数向下减少-->

    // const normalMapTexture = texLoader.load(process.env.BASE_URL + 'mytextures/cobbles-12_normal.jpg')
    // normalMapTexture.wrapS = mapTexture.wrapT = THREE.RepeatWrapping;// CHANGED-->
    // normalMapTexture.offset.set(0, 0.5); // CHANGED-->
    // normalMapTexture.repeat.set(200, 400);//但贴图重复过多时，可将此参数向下减少-->

    // streetMaterial.color = new THREE.Color(1, 1, 1)
    streetMaterial.map = mapTexture
    // streetMaterial.normalMap = normalMapTexture
    // streetMaterial.normalScale = new THREE.Vector2(300, 300)

    //創建地面
    createGround()

    //創建島
    createIsland()
    getCardListFunc()

    //创建记者
    createWelcomeReporter()

    //创建飞艇
    createAirShip()

    //創建路標
    createHallRoadSign()

    //加入对象组
    scene.add(meshGroup)

    //造人
    createMan()

    meshGroup.add(camera)
    camera.position.set(0,4,-16);
    camera.lookAt(new THREE.Vector3(0,5,0));

    //添加环境光
    scene.add(ambient);

    // 添加太陽光
    // directionalLight.castShadow = true

    // directionalLight.shadow.mapSize.width = 2048;
    // directionalLight.shadow.mapSize.height = 2048;
    //
    // directionalLight.shadow.camera.left = - 200;
    // directionalLight.shadow.camera.right = 200;
    // directionalLight.shadow.camera.top = 100;
    // directionalLight.shadow.camera.bottom = - 100;
    //
    // directionalLight.shadow.camera.far = 500;

    //加載天空盒
    const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256 );
    cubeCamera = new THREE.CubeCamera( 0.1, 1000, cubeRenderTarget)

    let environmentMap = new THREE.CubeTextureLoader().load( [
        process.env.BASE_URL + "mytextures/cube/Daylight_Box_Back.bmp",
        process.env.BASE_URL + "mytextures/cube/Daylight_Box_Front.bmp",
        process.env.BASE_URL + "mytextures/cube/Daylight_Box_Top.bmp",
        process.env.BASE_URL + "mytextures/cube/Daylight_Box_Bottom.bmp",
        process.env.BASE_URL + "mytextures/cube/Daylight_Box_Right.bmp",
        process.env.BASE_URL + "mytextures/cube/Daylight_Box_Left.bmp"], function ( cubeTexture ) {

        sceneEnvironmentMap = environmentMap
        scene.background = cubeTexture;

        cubeCamera.update( render, scene );

    } );

    let environmentMap2 = new THREE.CubeTextureLoader().load( [
        process.env.BASE_URL + "mytextures/px.jpg",
        process.env.BASE_URL + "mytextures/nx.jpg",
        process.env.BASE_URL + "mytextures/py.jpg",
        process.env.BASE_URL + "mytextures/ny.jpg",
        process.env.BASE_URL + "mytextures/pz.jpg",
        process.env.BASE_URL + "mytextures/nz.jpg"], function ( cubeTexture ) {

        testEnvMap = environmentMap2

    } );


    render.setSize(width, height);
    render.shadowMap.enabled = true //渲染器開啟陰影渲染
    render.shadowMap.type = THREE.PCFSoftShadowMap;
    render.render(scene, camera);

    document.getElementById("three").innerHTML = ""
    document.getElementById("three").appendChild(render.domElement);

    //监听鼠标、键盘事件
    document.addEventListener( 'keydown', onKeyDown );
    document.addEventListener( 'keyup', onKeyUp );

    if (isMobile){
        document.getElementById("three").addEventListener("touchmove", mouseMoveEvent)

        document.getElementById("three").addEventListener("touchstart", mouseDownEvent)

        document.getElementById("three").addEventListener("touchend", mouseUpEvent)

    }else{
        document.getElementById("three").addEventListener("mousemove", mouseMoveEvent)

        document.getElementById("three").addEventListener("mousedown", mouseDownEvent)

        document.getElementById("three").addEventListener("mouseup", mouseUpEvent)

        document.getElementById("three").addEventListener("click", mouseClickEvent)
    }
}

function renderFrame() {

    // stats.update();
    mixerUpdateDelta = clock.getDelta()

    if (loadingPercent.value > 39 && loadingPercent.value < 100){
        loadingPercent.value += 1
    }
    else if (loadingPercent.value == 100){
        // setInterval(() => {
        //     console.log(render.info)
        // }, 5000)

        //開始播放視頻
        setTimeout(() => {
            var video = document.getElementById("video");

            if (null != video){
                video.volume = 0
                video.muted = true
                video.play()
            }
        }, 25)

        //監聽廣告播放事件
        if (advList.length > 0){
            funcListObj['checkAdvVisble'] = checkAdvVisble
        }

        testModel()

        // controlFlag = true
        titleViewVisible.value = true
        loadingPercent.value += 1

        // if (currTimeStamp == 0){
        //     currTimeStamp = new Date().getTime() / 1000
        // }

        if (process.env.NODE_ENV !== 'production'){
            // setTimeout(() => {
            // if (!isMobile){
            //     scene.traverse((child)=>{
            //         if(child instanceof THREE.Mesh && (child.material instanceof THREE.MeshStandardMaterial || child.material instanceof THREE.MeshLambertMaterial || child.material instanceof THREE.MeshPhongMaterial)){
            //             if (child.material instanceof THREE.MeshStandardMaterial){
            //                 child.material.envMap = sceneEnvironmentMap
            //             }
            //
            //             child.castShadow = true
            //             child.receiveShadow = true
            //         }
            //     })
            // }

            // getSceneModelFaceNum(scene)
            // }, 5000)
        }

        let startFlag = true

        //如果是來自展館的，直接進入
        if (pageInfoRef.value.userFrom == 0){
            pageInfoRef.value.userFrom = null
            titleViewVisible.value = false
            startFlag = false
            clickTitleStart()
        }else if(myUtil.isNotEmpty(document.referrer) && document.referrer.indexOf(proxy.$EShopopeeUrl) != -1 ){
            if (userInfoRef.value.fromEshopopee == true){
                pageInfoRef.value.userFrom = null
                titleViewVisible.value = false
                startFlag = false
                clickTitleStart()
            }
        }

        userInfoRef.value.fromEshopopee = null

        if (null != pageInfoRef.value.rotationNum){
            rotationNum = pageInfoRef.value.rotationNum
            pageInfoRef.value.rotationNum = null
            calcCameraPosition()
        }

        if (startFlag){
            clickTitleStart()
        }

    }

    //更新时间戳
    // currTimeStamp += mixerUpdateDelta

    if (renderFlag){
        for (const v in funcListObj){
            if (typeof funcListObj[v] === "function"){
                funcListObj[v]()
            }
        }
    }

    // getSceneModelFaceNum(scene)
    timeStamp += mixerUpdateDelta;
    if (timeStamp > singleFrameTime) {
        teleporterManager.update()
        render.render(scene, camera)
        // label2DRenderer.render(scene,camera);
        label3DRenderer.render(scene,camera);


        //渲染
        // 剩余的时间合并进入下次的判断计算 这里使用取余数是因为 当页页面失去焦点又重新获得焦点的时候，delta数值会非常大， 这个时候就需要
        timeStamp = (timeStamp % singleFrameTime);
    }

    animationFrameId = requestAnimationFrame(renderFrame)

}

//按键按下
function onKeyDown( event ) {
    if (!controlFlag){
        return;
    }

    if (null != event && (event.code != 'KeyW' && event.code != 'KeyS' && event.code != 'KeyA' && event.code != 'KeyD' && event.code != 'ArrowUp' && event.code != 'ArrowDown' && event.code != 'ArrowLeft' && event.code != 'ArrowRight' )){
        return
    }

    if ( null != event || (operationObj.w || operationObj.s || operationObj.a || operationObj.d) ){
        camera.getWorldDirection(numVector3)
    }

    numVector3.setY(0)

    if (null != event ){
        switch ( event.code ) {

            case 'ArrowUp':
            case 'KeyW':
                if (!operationObj.w){
                    operationObj.w = true
                }

                moveFlag = true

                break;

            case 'ArrowDown':
            case 'KeyS':
                if (!operationObj.s){
                    operationObj.s = true
                }

                moveFlag = true

                break;

            // case 'ArrowLeft':
            case 'KeyA':
                if (!operationObj.a){
                    operationObj.a = true
                }

                moveFlag = true

                break;

            // case 'ArrowRight':
            case 'KeyD':
                if (!operationObj.d){
                    operationObj.d = true
                }

                moveFlag = true

                break;

            case 'ArrowLeft':
                funcListObj["moveCameraFunc_1"] = () => {
                    rotationNum -=  0.02 * 30 * mixerUpdateDelta

                    calcCameraPosition()
                }
                break;

            case 'ArrowRight':
                funcListObj["moveCameraFunc_1"] = () => {
                    rotationNum +=  0.02 * 30 * mixerUpdateDelta

                    calcCameraPosition()
                }
                break;

            // case 'KeyC': controls.crouch = true; break;
            // case 'Space': controls.jump = true; break;
            // case 'ControlLeft':
            // case 'ControlRight': controls.attack = true; break;

        }
    }



    if (operationObj.w){

    }

    if (operationObj.s){
        numVector3.negate()
    }

    if (operationObj.a){
        if (operationObj.w){
            numVector3.applyAxisAngle(yAxis,Math.PI/4)
        }else if(operationObj.s){
            numVector3.applyAxisAngle(yAxis,Math.PI/4 * -1)
        }else{
            numVector3.applyAxisAngle(yAxis,Math.PI/2)
        }

    }

    if (operationObj.d){

        if (operationObj.w){
            numVector3.applyAxisAngle(yAxis,Math.PI/4 * -1)
        }else if(operationObj.s){
            numVector3.applyAxisAngle(yAxis,Math.PI/4)
        }else{
            numVector3.applyAxisAngle(yAxis,Math.PI/2 * -1)
        }

    }

    moveVector3.copy(numVector3)

    // moveFlag = true

}

//按键抬起
function onKeyUp( event ) {

    switch ( event.code ) {

        case 'ArrowUp':
        case 'KeyW':
            if (operationObj.w){
                operationObj.w = false
                onKeyDown()
            }
            break;

        case 'ArrowDown':
        case 'KeyS':
            if (operationObj.s){
                operationObj.s = false
                onKeyDown()
            }
            break;

        // case 'ArrowLeft':
        case 'KeyA':
            if (operationObj.a){
                operationObj.a = false
                onKeyDown()
            }
            break;

        // case 'ArrowRight':
        case 'KeyD':
            if (operationObj.d){
                operationObj.d = false
                onKeyDown()
            }
            break;

        case 'ArrowLeft':
            delete funcListObj["moveCameraFunc_1"]
            break;

        case 'ArrowRight':
            delete funcListObj["moveCameraFunc_1"]
            break;
    }

    if ( !(operationObj.w || operationObj.s || operationObj.a || operationObj.d) ){
        moveFlag = false
        numVector3.set(0, 0, 0)
    }

}

//人物移动方法
function movePerson(){
    if (moveFlag || speed > 0){
        const currAddSize = mixerUpdateDelta * speedAddSize
        const currMinusSize = mixerUpdateDelta * speedMinusSize
        moveVector3.normalize()

        if (moveFlag){
            speed += currAddSize

            if (speed >= userInfoRef.value.speed){
                speed = userInfoRef.value.speed
            }
        }else{
            speed *= 0.96
            speed -= currMinusSize

            if (speed < 0.06){
                speed = 0
                moveVector3.set(0, 0, 0)
                toggleActiveMotion("idle")
            }
        }

        let timeScale = speed / 0.06
        const currMoveSpeed = speed * 60 * mixerUpdateDelta

        if (speed > 0.12){
            timeScale = 1
            timeScale += (speed - 0.12) / 14.0

            if (activeAction._clip.name == "walk"){
                toggleActiveMotion("running")
            }
        }else if (speed > 0 && speed <= 1.2){
            timeScale = 1

            if (activeAction._clip.name == "running"){
                toggleActiveMotion("walk")
            }else if (activeAction._clip.name == "idle"){
                toggleActiveMotion("walk")
            }
        }

        activeAction.timeScale = timeScale

        meshGroup.translateOnAxis(moveVector3, currMoveSpeed);

        let xnum2 = meshGroup.position.x + 1 * moveVector3.getComponent(0)
        let znum2 = meshGroup.position.z + 1 * moveVector3.getComponent(2)

        testBox.getWorldDirection(faceVector3)

        if (speed > 0){
            testBox.lookAt(xnum2, meshGroup.position.y, znum2)
        }

        for (const key in airWallList){
            const v = airWallList[key]
            const flagX1 = meshGroup.position.x < v.MAX_POSITION_X
            const flagX2 = meshGroup.position.x > v.MIN_POSITION_X

            const flagZ1 = meshGroup.position.z < v.MAX_POSITION_Z
            const flagZ2 = meshGroup.position.z > v.MIN_POSITION_Z

            if (flagX1 && flagX2 && flagZ1 && flagZ2){

                // if (Math.abs(v.MAX_POSITION_X - meshGroup.position.x) < Math.abs(v.MIN_POSITION_X - meshGroup.position.x)){
                //     meshGroup.position.x = v.MAX_POSITION_X + 0.2
                // }else{
                //     meshGroup.position.x = v.MIN_POSITION_X - 0.2
                // }

                let minX = null
                let minZ = null
                let min = null

                const distanceX1 = Math.abs(v.MAX_POSITION_X - meshGroup.position.x)
                const distanceX2 = Math.abs(v.MIN_POSITION_X - meshGroup.position.x)

                const distanceZ1 = Math.abs(v.MAX_POSITION_Z - meshGroup.position.z)
                const distanceZ2 = Math.abs(v.MIN_POSITION_Z - meshGroup.position.z)

                minX = distanceX1 < distanceX2 ? distanceX1 : distanceX2
                minZ = distanceZ1 < distanceZ2 ? distanceZ1 : distanceZ2
                min = minX < minZ ? minX : minZ
                min = min * -1 - 0.2
                meshGroup.translateOnAxis(moveVector3, min);
                // if (Math.abs(v.MAX_POSITION_Z - meshGroup.position.z) < Math.abs(v.MIN_POSITION_Z - meshGroup.position.z)){
                //     meshGroup.position.z = v.MAX_POSITION_Z + 0.2
                // }else{
                //     meshGroup.position.z = v.MIN_POSITION_Z - 0.2
                // }
            }
        }

        if (meshGroup.position.x > MAX_POSITION_X){
            meshGroup.position.x = MAX_POSITION_X - 0.2
        }

        if (meshGroup.position.x < MIN_POSITION_X){
            meshGroup.position.x = MIN_POSITION_X + 0.2
        }

        if (meshGroup.position.z > MAX_POSITION_Z){
            meshGroup.position.z = MAX_POSITION_Z - 0.2
        }

        if (meshGroup.position.z < MIN_POSITION_Z){
            meshGroup.position.z = MIN_POSITION_Z + 0.2
        }



        // moveRaycaster.set(new THREE.Vector3(meshGroup.position.x, 0.1, meshGroup.position.z), new THREE.Vector3(moveVector3.x, 0.1, moveVector3.z))
        // const intersects = moveRaycaster.intersectObjects(islandList);
        //
        // if (intersects.length > 0 && intersects[0].distance < 1){
        //     meshGroup.translateOnAxis(moveVector3, currMoveSpeed * -1);
        // }

        if (moveTimeStamp === 0){
            savePersonPosition()
            movePlayVolume()
        }

        moveTimeStamp += mixerUpdateDelta

        if (moveTimeStamp > 1.0){
            moveTimeStamp = moveTimeStamp % 1.0
            savePersonPosition()
            movePlayVolume()
        }

        if (rotationNumY !== 0){
            rotationNumY = 0
            calcCameraPosition()
        }

        // console.log("x: " + meshGroup.position.x + " z: " + meshGroup.position.z)
    }
}

//更新播放动作方法
function updateMixerByTime(){
    //播放动画
    for (let i in mixerObj){
        mixerObj[i].update( mixerUpdateDelta );
    }
}
//移動視頻音量大小
function movePlayVolume() {

    const distance = meshGroup.position.distanceTo(videoPoint)

    let video = document.getElementById("video");

    if (null == video){
        return
    }

    if (distance < 65 && userInfoRef.value.openSound === true){//開啟聲音
        // if (distance < 65){
        video.muted = false
        video.volume=0.4 + ((65-distance)/110);
    }else{
        video.muted = true
        video.volume=0;
    }
}


//前往下一区域方法
function moveNextRegion() {
    const distance = meshGroup.position.distanceTo(transmitPoint)

    if (distance < 10){

        let direction = new THREE.Vector3();
        direction.subVectors( meshGroup.position, transmitPoint ) ;
        meshGroup.translateOnAxis(direction.normalize(), 1);

        goNextRegionConfirm()
    }
}

//創建地面
function createGround(){
    // const groundGeometry = new THREE.PlaneGeometry(30000, 30000);
    //
    // let groudMesh = new Water(groundGeometry, {
    //     textureWidth: 500,
    //     textureHeight: 500,
    //     waterNormals: texLoader.load( process.env.BASE_URL + 'textures/waternormals.jpg', function ( texture ) {
    //         texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
    //     } ),
    //     sunDirection: new THREE.Vector3(),
    //     // sunColor: 0xffffff,
    //     sunColor: 0x23dffd,
    //     // waterColor: 0x001e0f,
    //     waterColor: 0x23dffd,
    //     distortionScale: 3.7,
    //     fog: scene.fog !== undefined
    // })
    // groudMesh.receiveShadow = true //地面接受其他物體的陰影，但自身不會產生陰影
    // groudMesh.position.set(0, -2.7, 0)
    // groudMesh.rotation.x = - Math.PI / 2;
    //
    // //設置水體流動
    // funcListObj[`changeWaterGround_${groudMesh.uuid}`] = function() {
    //     groudMesh.material.uniforms[ 'time' ].value += 1.0 / 60.0;
    // }
    //
    // scene.add(groudMesh)

    loadingPercent.value += 5

}

//創建島
function createIsland(){

    loadFbxModel("island/testIsland10.fbx", {
        // positionX: -12,
        positionY: 0,
        // positionZ: -30,
        // scaleY: 50,
        loadCallback: (model) => {
            //加载shopopeelogo贴图
            const shopopeeLogoTexture = texLoader.load(process.env.BASE_URL + 'mymodels/fbx/island/NuclearsoftERP.png');
            shopopeeLogoTexture.center.set(0.5, 0.5)
            shopopeeLogoTexture.rotation = Math.PI

            //加載广告牌貼圖
            const texture = texLoader.load(process.env.BASE_URL + 'mymodels/fbx/island/plane_empty.png');
            // const shopopeeAdsPlaneTex = texLoader.load(process.env.BASE_URL + 'mymodels/fbx/island/shopopeeAdsPlane.jpg')
            const verticalAdsText1 = texLoader.load(process.env.BASE_URL + 'mytextures/adv1.jpg');
            const verticalAdsText2 = texLoader.load(process.env.BASE_URL + 'mytextures/adv2.jpg');
            const verticalAdsText3 = texLoader.load(process.env.BASE_URL + 'mytextures/adv3.jpg');
            const verticalAdsText4 = texLoader.load(process.env.BASE_URL + 'mytextures/adv4.jpg');

            //加载视频
            let video = document.getElementById("video");
            const shopopeeAdsPlaneTex = new THREE.VideoTexture(video);
            shopopeeAdsPlaneTex.center.set(0.5, 0.5)
            shopopeeAdsPlaneTex.rotation = 90 * Math.PI / 180
            shopopeeAdsPlaneTex.colorSpace = THREE.SRGBColorSpace

            //加载招牌贴图
            // const signPlaneTex = texLoader.load('muban.jpg')

            //创建一个材质对象Material
            const shopopeeLogoMaterial = new THREE.MeshLambertMaterial({ //普通材质
                color: 0xffffff,//0xff0000设置材质颜色为红色
                map: shopopeeLogoTexture,
                // side: THREE.DoubleSide
            });

            //创建广告牌材质
            const adsMaterial = new THREE.MeshBasicMaterial({ //普通材质
                color: 0xffffff,
                map: texture,
                side: THREE.DoubleSide
            });

            const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                color: 0xffffff,
                map: verticalAdsText1,
            });

            const verticalAdsMaterial2 = new THREE.MeshBasicMaterial({ //普通材质
                color: 0xffffff,
                map: verticalAdsText2,
            });

            const verticalAdsMaterial3 = new THREE.MeshBasicMaterial({ //普通材质
                color: 0xffffff,
                map: verticalAdsText3,
            });

            const verticalAdsMaterial4 = new THREE.MeshBasicMaterial({ //普通材质
                color: 0xffffff,
                map: verticalAdsText4,
            });

            const shopopeeAdsMaterial = new THREE.MeshBasicMaterial({ //普通材质
                color: 0xffffff,//0xff0000设置材质颜色为红色
                map: shopopeeAdsPlaneTex,
                // lightMap: shopopeeAdsPlaneTex,
                reflectivity: 0,
                fog: false
                // side: THREE.DoubleSide
            });
            // const shopSignMaterial = new THREE.MeshLambertMaterial({ //普通材质
            //     color: 0xffffff,//0xff0000设置材质颜色为红色
            //     map: signPlaneTex,
            //     // side: THREE.DoubleSide
            // });

            //A街材质
            const roadAPadMaterial = createRoadPadMaterial("A 街")

            //B街材质
            const roadBPadMaterial = createRoadPadMaterial("B 街")

            //C街材质
            const roadCPadMaterial = createRoadPadMaterial("C 街")

            //D街材质
            const roadDPadMaterial = createRoadPadMaterial("D 街")

            const carList = []
            const pathList = []

            model.traverse( function ( object ) {
                if ( object.isMesh ) {
                    // object.castShadow = true;
                }

                if (object.name == "jump_1"){
                    tpPointsMap["1"] = object
                }

                if (object.name == "jump_2"){
                    tpPointsMap["2"] = object
                }

                if (object.name == "jump_3"){
                    tpPointsMap["3"] = object
                }

                if (object.name === "Vehicle_Boat_03"){
                    object.position.x = -40000
                    object.position.y = -350
                    object.position.z = -60000
                    object.rotation.y = -0.5


                    const tween_2 = new TWEEN.Tween(object.position)
                        .to({x: 20000, z: 90000}, 180000)
                        .start()
                        // .easing(TWEEN.Easing.Sinusoidal.In)
                        .onComplete(() => {
                            object.visible = false
                            delete animationObjGroup[object.uuid]
                        })

                    animationObjGroup[object.uuid] = tween_2
                }

                if (object.name === "Boat_animation_1"){
                    object.position.x = -25000
                    object.position.y = -330
                    object.position.z = 40000
                    // object.rotation.y = -0.5

                    const tween_2 = new TWEEN.Tween(object.position)
                        .to({x: 150000, z: 11000}, 360000)
                        .start()
                        // .easing(TWEEN.Easing.Sinusoidal.In)
                        .onComplete(() => {
                            object.visible = false
                            delete animationObjGroup[object.uuid]
                        })

                    animationObjGroup[object.uuid] = tween_2
                }

                if (object.name === "Vehicle_Boat_01"){
                    object.position.x = 100000
                    object.position.y = -350
                    object.position.z = 110000
                    // object.rotation.y = -0.5

                    const tween_2 = new TWEEN.Tween(object.position)
                        .to({x: 40000, z: -180000}, 360000)
                        .start()
                        // .easing(TWEEN.Easing.Sinusoidal.In)
                        .onComplete(() => {
                            object.visible = false
                            delete animationObjGroup[object.uuid]
                        })

                    animationObjGroup[object.uuid] = tween_2
                }

                if (object.name === "Boat_animation_2"){
                    object.position.x = 150000
                    object.position.y = -330
                    object.position.z = -200000
                    // object.rotation.y = -0.5

                    const tween_2 = new TWEEN.Tween(object.position)
                        .to({x: -40000, z: -10000}, 180000)
                        .start()
                        // .easing(TWEEN.Easing.Sinusoidal.In)
                        .onComplete(() => {
                            object.visible = false
                            delete animationObjGroup[object.uuid]
                        })

                    animationObjGroup[object.uuid] = tween_2
                }

                // if (object.name === "Logo_Plane_1"){
                //     object.rotation.x =  180 * Math.PI / 180
                //     object.material = shopopeeLogoMaterial
                // }
                //
                // if (object.name === "Logo_Plane_2"){
                //     object.material = shopopeeLogoMaterial
                // }

                if (object.name === "shopopee_ads_pad_sm_0"){
                    object.material = shopopeeLogoMaterial
                }

                if (object.name == "Plane01"){
                    startObj = object
                    showTitleView(object)

                }

                if (object.name == "Airport_Stair_Truck_Short"){
                    object.visible = false
                    startObj2 = object
                }

                //创建A街路牌
                if (object.name === "Street_A_pad_front_1" || object.name === "Street_A_pad_front_2"){
                    object.material = roadAPadMaterial
                }

                if (object.name === "Street_A_pad_back_1" || object.name === "Street_A_pad_back_2"){
                    object.material = roadAPadMaterial
                }

                //创建B街路牌
                if (object.name === "Street_B_pad_front_1" || object.name === "Street_B_pad_front_2"){
                    object.material = roadBPadMaterial
                }

                if (object.name === "Street_B_pad_back_1" || object.name === "Street_B_pad_back_2"){
                    object.material = roadBPadMaterial
                }

                //创建C街路牌
                if (object.name === "Street_C_pad_front_1" || object.name === "Street_C_pad_front_2"){
                    object.material = roadCPadMaterial
                }

                if (object.name === "Street_C_pad_back_1" || object.name === "Street_C_pad_back_2"){
                    object.material = roadCPadMaterial
                }

                //创建D街路牌
                if (object.name === "Street_D_pad_front_1" || object.name === "Street_D_pad_front_2"){
                    object.material = roadDPadMaterial
                }

                if (object.name === "Street_D_pad_back_1" || object.name === "Street_D_pad_back_2"){
                    object.material = roadDPadMaterial
                }

                //加载路上的广告牌
                if (object.name.indexOf("Ads_Plane") != -1){
                    object.material = adsMaterial
                }

                if (object.name == "Ads_Plane_shopopee_0"){
                    shopopeeSubHallMeshList.push(object)

                    if (regionMap.currPage != 1){
                        object.visible = false
                    }

                    if (userInfoRef.value.selectCountry != "HK" || null == currIsland || currIsland.companycode != "ZZ"){
                        if (null != currIsland && currIsland.companycode != "ZZ"){
                            //如果不是自營的島，加載用戶上傳的介紹圖片
                            let islandName = currIsland.addinfo6
                            let imgUrl = currIsland.addinfo16

                            if(userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(islandName)){
                                islandName = currIsland.recordname
                            }

                            if(userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(imgUrl)){
                                imgUrl = currIsland.addinfo15
                            }

                            if (myUtil.isEmpty(imgUrl)){
                                generateGoIslandPad(object, islandName)
                                object.material.map.rotation = Math.PI/2
                               object.material.map.flipY = true
                            }else{
                                const map = texLoader.load(imgUrl, (texture) => {
                                    texture.colorSpace = THREE.SRGBColorSpace
                                    // texture.flipY = false
                                    texture.generateMipmaps = false
                                    texture.center.set(0.5, 0.5)
                                    texture.rotation = Math.PI / 2
                                });

                                const material = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: map,
                                });

                                object.material = material
                                object.material.side = THREE.DoubleSide

                            }

                        }else{
                            disposeMesh(object)
                        }

                        try {
                            shopopeeAdsMaterial.dispose();
                            video.remove()
                        }catch (e) {

                        }

                    }else{
                        object.material = shopopeeAdsMaterial
                    }
                }

                if (object.name == "water_flow"){
                    object.material.transparent = true
                    object.material.opacity=0.5
                    object.material.emissiveIntensity = 1

                    const watertexture = object.material.map
                    watertexture.wrapS = watertexture.wrapT = THREE.RepeatWrapping;

                    funcListObj[`water_flow_${object.uuid}`] = () => {
                        watertexture.offset.x += 0.003
                    }

                }

                //加载商店
                if (object.name == "shop_building"){
                    shopPointList = object.children
                }

                //加载人流量显示牌
                if (object.name.indexOf("browse_") != -1){
                    object.rotation.y = - Math.PI
                    shopTrafficPadMap[object.name.substring(7)] = object
                    //
                    //     const obj = object.parent
                    //
                    //     object.parent.remove(object)
                    //     obj.parent.add(object)
                    //
                    //     object.position.x = -375
                    //     object.position.y = 380
                    //     object.position.z = -770
                    //
                    //     // object.position.x = -350
                    //     // object.position.y = 530
                    //     // object.position.z = -500
                }

                //更换水面
                // if (object.name === "shopopee_fountain_water_0"){
                //     let groudMesh = new Water(object.geometry, {
                //         textureWidth: 500,
                //         textureHeight: 500,
                //         waterNormals: texLoader.load( process.env.BASE_URL + 'textures/waternormals.jpg', function ( texture ) {
                //             texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                //         } ),
                //         sunDirection: new THREE.Vector3(),
                //         sunColor: 0xffffff,
                //         // sunColor: 0x23dffd,
                //         // waterColor: 0x001e0f,
                //         waterColor: 0x23dffd,
                //         distortionScale: 3.7,
                //         fog: scene.fog !== undefined
                //     })
                //     // groudMesh.receiveShadow = true //地面接受其他物體的陰影，但自身不會產生陰影
                //     groudMesh.position.set(0, object.position.y, 0)
                //     // groudMesh.rotation.x = - Math.PI / 2;
                //
                //     //設置水體流動
                //     funcListObj[`changeWaterGround_${groudMesh.uuid}`] = function() {
                //         groudMesh.material.uniforms[ 'time' ].value += 1.0 / 120.0;
                //     }
                //
                //     object.parent.add(groudMesh)
                //     object.visible = false
                //     object.parent.remove(object)
                // }
                //
                // if (object.name === "shopopee_fountain_water_1"){
                //
                //     let groudMesh = new Water(object.geometry, {
                //         textureWidth: 500,
                //         textureHeight: 500,
                //         waterNormals: texLoader.load( process.env.BASE_URL + 'textures/waternormals.jpg', function ( texture ) {
                //             texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                //         } ),
                //         sunDirection: new THREE.Vector3(),
                //         sunColor: 0xffffff,
                //         // sunColor: 0x23dffd,
                //         // waterColor: 0x001e0f,
                //         waterColor: 0x23dffd,
                //         distortionScale: 3.7,
                //         fog: scene.fog !== undefined
                //     })
                //     // groudMesh.receiveShadow = true //地面接受其他物體的陰影，但自身不會產生陰影
                //     groudMesh.position.set(0, object.position.y, 0)
                //     // groudMesh.rotation.x = - Math.PI / 2;
                //
                //     //設置水體流動
                //     funcListObj[`changeWaterGround_${groudMesh.uuid}`] = function() {
                //         groudMesh.material.uniforms[ 'time' ].value += 1.0 / 120.0;
                //     }
                //
                //     object.parent.add(groudMesh)
                //     object.visible = false
                //     object.parent.remove(object)
                // }
                //
                if (object.name === "shopopee_fountain_water_2"){

                    // let groudMesh = new Water(object.geometry, {
                    //     textureWidth: 500,
                    //     textureHeight: 500,
                    //     waterNormals: texLoader.load( process.env.BASE_URL + 'textures/waternormals.jpg', function ( texture ) {
                    //         texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
                    //     } ),
                    //     sunDirection: new THREE.Vector3(),
                    //     sunColor: 0xffffff,
                    //     // sunColor: 0x23dffd,
                    //     // waterColor: 0x001e0f,
                    //     waterColor: 0x23dffd,
                    //     distortionScale: 3.7,
                    //     fog: scene.fog !== undefined
                    // })
                    // // groudMesh.receiveShadow = true //地面接受其他物體的陰影，但自身不會產生陰影
                    // groudMesh.position.set(0, object.position.y, 0)
                    // // groudMesh.rotation.x = - Math.PI / 2;
                    //
                    // //設置水體流動
                    // funcListObj[`changeWaterGround_${groudMesh.uuid}`] = function() {
                    //     groudMesh.material.uniforms[ 'time' ].value += 1.0 / 60.0;
                    // }
                    //
                    // object.parent.add(groudMesh)
                    // object.visible = false
                    // object.parent.remove(object)
                }

                if (object.name === "SM_Prop_Fountain_01"){
                    // object.material = new THREE.MeshStandardMaterial()

                    // 材质
                    const basicMaterial = new THREE.MeshStandardMaterial({
                        // map: doorColorTexture, // 漫反射贴图
                        // alphaMap: doorAplhaTexture, // 透明贴图
                        // transparent: true, // 开启透明
                        // aoMap: doorAoTexture, // 环境光遮挡贴图
                        // aoMapIntensity: 1, // 环境光遮挡贴图强度
                        // displacementMap: doorHeightTexture, // 置换贴图
                        // displacementScale: 0.1, // 置换贴图强度
                        color: 0xffffff
                    })

                    object.material = basicMaterial
                }

                if (object.name === "shopopee_ads_vertical_0_0" || object.name === "shopopee_ads_vertical_0_1"){
                    object.material = verticalAdsMaterial1

                    if (object.name === "shopopee_ads_vertical_0_0"){
                        interactionObj[object.uuid] = [{
                            distance: 5,
                            icon: "fa-solid fa-magnifying-glass",
                            name: i18n.tkey("lang_check"),
                            mesh: object,
                            callback: () => {
                                proxy.$refs.shopopeePhone.goDisplayImgView(process.env.BASE_URL + 'mytextures/adv1.jpg')
                            }
                        }]
                    }
                }

                if (object.name === "shopopee_ads_vertical_1_0" || object.name === "shopopee_ads_vertical_1_1"){
                    object.material = verticalAdsMaterial2

                    if (object.name === "shopopee_ads_vertical_1_0"){
                        interactionObj[object.uuid] = [{
                            distance: 5,
                            icon: "fa-solid fa-magnifying-glass",
                            name: i18n.tkey("lang_check"),
                            // mesh: shopList[index].children[0],
                            mesh: object,
                            callback: () => {
                                proxy.$refs.shopopeePhone.goDisplayImgView(process.env.BASE_URL + 'mytextures/adv2.jpg')
                            }
                        }]
                    }
                }

                if (object.name === "shopopee_ads_vertical_2_0" || object.name === "shopopee_ads_vertical_2_1"){
                    object.material = verticalAdsMaterial3

                    if (object.name === "shopopee_ads_vertical_2_0"){
                        interactionObj[object.uuid] = [{
                            distance: 5,
                            icon: "fa-solid fa-magnifying-glass",
                            name: i18n.tkey("lang_check"),
                            // mesh: shopList[index].children[0],
                            mesh: object,
                            callback: () => {
                                proxy.$refs.shopopeePhone.goDisplayImgView(process.env.BASE_URL + 'mytextures/adv3.jpg')
                            }
                        }]
                    }
                }

                if (object.name === "shopopee_ads_vertical_3_0" || object.name === "shopopee_ads_vertical_3_1"){
                    object.material = verticalAdsMaterial4

                    if (object.name === "shopopee_ads_vertical_3_0"){
                        interactionObj[object.uuid] = [{
                            distance: 5,
                            icon: "fa-solid fa-magnifying-glass",
                            name: i18n.tkey("lang_check"),
                            // mesh: shopList[index].children[0],
                            mesh: object,
                            callback: () => {
                                proxy.$refs.shopopeePhone.goDisplayImgView(process.env.BASE_URL + 'mytextures/adv4.jpg')
                            }
                        }]
                    }
                }

                if (object.name.indexOf("initial_car_") !== -1) {
                    object.scale.multiply(new THREE.Vector3(0.01, 0.01, 0.01));
                    carList.push(object)
                }

                if (object.name === "car_normal_path_0"){
                    object.scale.y = Math.PI / 2
                    pathList.push(object)
                }

                // if (object.name.indexOf("area_pad_mesh") !== -1){
                //
                //     regionNumPad.push(object)
                //
                //     //創建區牌
                //     object.material = createRegionNumMaterial()
                // }
                //
                if (object.name === "area_pad_mesh_0"){
                    regionNumPad.push(object)

                    let nextPageNum = Number(regionMap.currPage) + 1
                    // if (nextPageNum > regionMap.lastPage){
                    //     nextPageNum = 1
                    // }

                    //創建區牌
                    object.material = createRegionNumMaterial(nextPageNum)
                }

                if (object.name === "area_pad_mesh_1"||object.name === "area_pad_mesh_2"){
                    regionNumPad.push(object)

                    //上下浮动
                    const key = `animation_${object.uuid}`
                    const withAIObj = {
                        model: object,
                        positionY: object.position.y,
                        offset: 0.25,
                        sum: 0,
                        AI: (obj) => {
                            if (obj.sum > 12){
                                obj.offset = -0.25
                            }

                            if (obj.sum <= -12){
                                obj.offset = 0.25
                            }

                            obj.sum += obj.offset
                            // obj.positionY += obj.offset
                            obj.model.position.y = obj.positionY + obj.sum
                        }
                    }
                    WithAIObjSet[key] = withAIObj

                    //創建區牌
                    object.material = createRegionNumMaterial()
                }

                // if(object.name == "area_pad_mesh"){

                // }

                // if (object.name === "car_7"){
                //     regionMap.guideCarObj = object.clone()
                // }

                if (object.name === "host_man_point_0"){
                    regionMap.welcomePoint = new THREE.Vector3()
                    object.getWorldPosition(regionMap.welcomePoint)
                    regionMap.welcomePoint.x /= 100
                    regionMap.welcomePoint.z /= 100
                    // regionMap.welcomePoint.z -= 20
                }

                if (object.name === "transfer_man_point_0"){
                    regionMap.transferManPoint_1 = new THREE.Vector3()
                    object.getWorldPosition(regionMap.transferManPoint_1)
                    regionMap.transferManPoint_1.x /= 100
                    regionMap.transferManPoint_1.z /= 100
                }

                if (object.name === "transfer_man_point_1"){
                    regionMap.transferManPoint_2 = new THREE.Vector3()
                    object.getWorldPosition(regionMap.transferManPoint_2)
                    regionMap.transferManPoint_2.x /= 100
                    regionMap.transferManPoint_2.z /= 100
                }

                // if (object.name === "Building_Mall"){
                //     shopopeeHallMesh = object
                //
                //     if (Number(regionMap.currPage) !== 1){
                //         shopopeeHallMesh.visible = false
                //         delete airWallList["shopopee_hall_1"]
                //     }
                // }

                if (object.name.indexOf("shop_map_") !== -1){
                    object.material = streetMaterial
                }

                // if (object.name === "door"){
                //     let gui = new GUI()
                //     gui.add(object.rotation, "x").step(0.01)
                //     gui.add(object.rotation, "y").step(0.01)
                //     gui.add(object.rotation, "z").step(0.01)
                // }

                if (object.name === "Small_Heli02"){
                    tpObjMap["tpHeli"] = object
                }

                if (object.name === "rotor_main"){
                    tpObjMap["tpHeliWing"] = object
                }

                if (object.name === "rotor_tail"){
                    tpObjMap["tpHeliWing2"] = object
                }

                if (object.name === "house" && null != currIsland && currIsland.companycode == "ZZ"){
                    var buildurl = "island/build2.gltf"
                    if (userInfoRef.value.selectCountry != "HK"){
                        // delete airWallList["shopopee_hall_1"]
                    }else{
                        buildurl = "island/build.gltf"
                    }
                    loadGlbModel(buildurl, {
                        // scaleY: 10,
                        loadCallback: (gltf,model) => {
                            shopopeeHallMesh = model

                            if (Number(regionMap.currPage) !== 1){
                                shopopeeHallMesh.visible = false
                                delete airWallList["shopopee_hall_1"]
                            }

                            model.traverse((child) => {
                                if (child.name === "glass"){
                                    const material = new THREE.MeshPhongMaterial({
                                        color: 0x87a19a,
                                        shininess: 50, //高光部分的亮度，默认30-->
                                        specular: 0xffffff, //高光部分的颜色-->
                                    })
                                    material.envMap = testEnvMap

                                    child.material = material
                                }

                                if (child.name === "ornament"){
                                    const material = new THREE.MeshBasicMaterial()
                                    material.copy(child.material)
                                    child.material = material
                                }

                                child.__deleteTag__ = false
                                clickVisibleList.push(child)

                                interactionObj[child.uuid] = [{
                                    time: 0,
                                    parentModel: model,
                                    callback: () => {
                                        if (child.visible == true){
                                            const oldTime = interactionObj[child.uuid].time
                                            interactionObj[child.uuid].time = new Date().getTime()

                                            if (interactionObj[child.uuid].time  - oldTime < 500){
                                                if (model.visible == true){
                                                    const vec3 = new THREE.Vector3()
                                                    tpPointsMap["1"].getWorldPosition(vec3)

                                                    meshGroup.position.x = vec3.x
                                                    meshGroup.position.z = vec3.z

                                                    rotationNum = -Math.PI / 2
                                                    calcCameraPosition()

                                                }

                                            }

                                        }
                                    }
                                }]
                            })

                            model.rotation.y = Math.PI

                            model.scale.x = 100
                            model.scale.y = 100
                            model.scale.z = 100

                            //註冊前往展館方法
                            triggerAreaMap[model.uuid] = {
                                scope: {
                                    MAX_POSITION_X: 229,
                                    MIN_POSITION_X: 209.3,
                                    MAX_POSITION_Z: 91,
                                    MIN_POSITION_Z: 89.5,
                                },
                                alive: false,
                                timer: 0.5,
                                timeLimit: 0.5,
                                func: () => {
                                    if (regionMap.currPage != 1){
                                        return
                                    }

                                    meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 2);

                                    controlFlag = false
                                    moveFlag = false
                                    speed = 0
                                    hallQueryType.value = 0
                                    hallVisible.value = true
                                }
                            }
                            // clearDataList.push({"key": model.uuid, map: triggerAreaMap})

                        },
                        callback: (group) => {
                            // group.position.copy(object.position)

                            object.add(group)
                        }
                    })



                    // shopopeeHallMesh = object
                    //
                    // if (Number(regionMap.currPage) !== 1){
                    //     shopopeeHallMesh.visible = false
                    //     delete airWallList["shopopee_hall_1"]
                    // }
                }

                if (object.name === "house2"){
                    if (userInfoRef.value.selectCountry == "HK" && null != currIsland && currIsland.companycode == "ZZ"){

                        loadGlbModel("island/build2.gltf", {
                            // scaleY: 10,
                            loadCallback: (gltf,model) => {
                                shopopeeHallMesh2 = model

                                if (Number(regionMap.currPage) !== 1){
                                    shopopeeHallMesh2.visible = false
                                    delete airWallList["shopopee_hall_2"]
                                }

                                model.traverse((child) => {
                                    if (child.name === "glass"){
                                        const material = new THREE.MeshPhongMaterial({
                                            color: 0x87a19a,
                                            shininess: 50, //高光部分的亮度，默认30-->
                                            specular: 0xffffff, //高光部分的颜色-->
                                        })
                                        material.envMap = testEnvMap

                                        child.material = material
                                    }

                                    if (child.name === "ornament"){
                                        const material = new THREE.MeshBasicMaterial()
                                        material.copy(child.material)
                                        child.material = material
                                    }

                                    child.__deleteTag__ = false
                                    clickVisibleList.push(child)
                                    interactionObj[child.uuid] = [{
                                        time: 0,
                                        parentModel: model,
                                        callback: () => {
                                            if (child.visible == true){
                                                const oldTime = interactionObj[child.uuid].time
                                                interactionObj[child.uuid].time = new Date().getTime()

                                                if (interactionObj[child.uuid].time  - oldTime < 500){
                                                    if (model.visible == true){
                                                        const vec3 = new THREE.Vector3()
                                                        tpPointsMap["2"].getWorldPosition(vec3)

                                                        meshGroup.position.x = vec3.x
                                                        meshGroup.position.z = vec3.z

                                                        rotationNum = 0
                                                        calcCameraPosition()
                                                    }

                                                }

                                            }
                                        }
                                    }]
                                })

                                model.rotation.y = Math.PI / 2

                                model.scale.x = 100
                                model.scale.y = 100
                                model.scale.z = 100

                                //註冊前往展館方法
                                triggerAreaMap[model.uuid] = {
                                    scope: {
                                        MAX_POSITION_X: 166,
                                        MIN_POSITION_X: 165.5,
                                        MAX_POSITION_Z: 88,
                                        MIN_POSITION_Z: 68,
                                    },
                                    alive: false,
                                    timer: 0.5,
                                    timeLimit: 0.5,
                                    func: () => {
                                        if (regionMap.currPage != 1){
                                            return
                                        }

                                        meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 2);

                                        controlFlag = false
                                        moveFlag = false
                                        speed = 0
                                        hallQueryType.value = 1
                                        hallVisible.value = true
                                    }
                                }

                            },
                            callback: (group) => {

                                object.add(group)
                            }
                        })
                    }else{
                        delete airWallList["shopopee_hall_2"]
                    }

                }

                //加载展館門口的廣告牌
                if (object.name.indexOf("shopopee_ads_door_vertical_") != -1 && object.type == "Group"){
                    hallDoorAdvList.push(object)
                }

                if (object.name == "path_ai_group"){
                    createHallDoorPerson(object)
                }

                if (object.name == "shopopee_ads_pad_title"){
                    islandNamePadMesh = object
                    islandNamePadMesh.visible = false
                    generateGoIslandPad(object)
                    generateIslandNameMesh()

                  if (userInfoRef.value.selectCountry == "HK" && currIsland.companycode == "ZZ") {
                    generateIslandMapMesh()
                  }
                }

                if (object.name == "prop_roadsign_title_1"){
                    let langTag = "en"

                    if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                        langTag = "hk"
                    }

                    const imgUrl = `${process.env.BASE_URL}mytextures/roadsign_title/prop_roadsign_title_1_${langTag}.jpg`
                    const map = texLoader.load(imgUrl)

                    const material = new THREE.MeshBasicMaterial({
                        map: map,
                        // lightMap: map,
                        // side: THREE.DoubleSide,
                        // opacity: 1,
                        // transparent: true
                    })

                    object.material = material
                }

                if (object.name == "prop_roadsign_title_2"){
                    let langTag = "en"

                    if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                        langTag = "hk"
                    }

                    if (myUtil.isEmpty(userInfoRef.value.areacode)){
                        const imgUrl = `${process.env.BASE_URL}mytextures/roadsign_title/prop_roadsign_title_2_${langTag}.jpg`
                        const map = texLoader.load(imgUrl)

                        const material = new THREE.MeshBasicMaterial({
                            map: map,
                            lightMap: map,
                            // transparent : true,
                        })


                        object.material = material
                    }else{
                        var data = regionName.value
                        generateIslandTitle(object,data)
                    }


                    object.__deleteTag__ = false
                    clickVisibleList.push(object)
                    interactionObj[object.uuid] = [{
                        time: 0,
                        parentModel: object,
                        callback: () => {
                            if (object.visible == true){
                                const oldTime = interactionObj[object.uuid].time
                                interactionObj[object.uuid].time = new Date().getTime()

                                if (interactionObj[object.uuid].time  - oldTime < 500){
                                    if (model.visible == true){
                                        const vec3 = new THREE.Vector3()
                                        tpPointsMap["3"].getWorldPosition(vec3)

                                        meshGroup.position.x = vec3.x
                                        meshGroup.position.z = vec3.z

                                        rotationNum = - Math.PI
                                        calcCameraPosition()
                                    }

                                }

                            }
                        }
                    }]


                }
                if (object.name == "title_light_bg"){
                    const watertexture = object.material.map
                    watertexture.wrapS = watertexture.wrapT = THREE.RepeatWrapping;

                    funcListObj[`title_light_bg_${object.uuid}`] = () => {
                        watertexture.offset.y += 0.003
                    }
                }
                if (object.name == "prop_roadsign_2"){
                    //上下浮动
                    const key = `animation_${object.uuid}`
                    const withAIObj = {
                        model: object,
                        positionY: object.position.y,
                        offset: 0.25,
                        sum: 0,
                        AI: (obj) => {
                            if (obj.sum > 12){
                                obj.offset = -0.25
                            }

                            if (obj.sum <= -12){
                                obj.offset = 0.25
                            }

                            obj.sum += obj.offset
                            // obj.positionY += obj.offset
                            obj.model.position.y = obj.positionY + obj.sum
                        }
                    }
                    WithAIObjSet[key] = withAIObj
                }

                if (object.name == "host_man_point_2"){
                    createUsher(object)

                    // interactionObj[object.uuid] = [{
                    //     distance: 8,
                    //     icon: "fa-solid fa-plane-departure",
                    //     name: i18n.tkey("lang_toggle_island"),
                    //     // mesh: shopList[index].children[0],
                    //     mesh: object,
                    //     callback: () => {
                    //         islandSelectVisible.value = true
                    //     }
                    // }]
                }

                // if (object.name.indexOf("_wheel_mesh") != -1){
                //     object.visible = false
                // }

                if (object.name == "Prop_Roadsign_2"){

                    object.material.opacity = 0
                    object.material.transparent = true
                }

            })

            //初始化交通工具
            //初始化路径1
            let pathPositionList1 = []
            //观光的士的路径
            let taxiPointList = []
            for (let i=0; i< pathList[0].children.length; i++){
                const v = pathList[0].children[i]
                const vec3 = new THREE.Vector3()
                vec3.x = v.position.x / 100
                vec3.y = v.position.y / 100
                vec3.z = v.position.z / 100
                // vec3.y += 2
                pathPositionList1.push(vec3)


                if (i < 21 || i > 29){
                    vec3.y = 0
                    taxiPointList.push(vec3)
                    // let boxGeometry = new THREE.BoxGeometry(1, 1, 1)
                    // let lambertMaterial = new THREE.MeshBasicMaterial({
                    //     color: 0xff0000
                    // })
                    //
                    // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
                    // scene.add(mesh)

                    // mesh.position.x = vec3.x
                    // mesh.position.y = vec3.y
                    // mesh.position.z = vec3.z
                }

            }

            // 生成一条闭合曲线
            let pathCurve = new THREE.CatmullRomCurve3(pathPositionList1, true);
            let pathPointList = pathCurve.getPoints(4000)

            pathPositionList1 = pathPointList

            //生成观光的士的闭合曲线
            pathCurve = new THREE.CatmullRomCurve3(taxiPointList, true);
            pathPointList = pathCurve.getPoints(4000)

            taxiPointList = pathPointList
            createSightseeingCar(taxiPointList)

            //创建移动的汽车
            carList.forEach((v, i) => {
                v.parent.remove(v)
                scene.add(v)

                // v.scale.x = 2
                // v.scale.y = 2
                // v.scale.z = 2

                const withAIObj = getEmptyWithAIObj()
                // const randomNum = Math.floor(Math.random() * 400) + 200 + i * 200
                const randomNum = i * 400
                // const randomNum = i * 40
                const currPosition = pathPositionList1[randomNum]
                v.position.x = currPosition.x
                v.position.y = currPosition.y
                v.position.z = currPosition.z

                withAIObj.speed = 4
                withAIObj.group = v
                withAIObj.model = v.children[0]
                withAIObj.model.rotation.y = Math.PI / 180 * 180
                withAIObj.action = "driving_init"
                withAIObj.name = v.name
                withAIObj.targetPositionList = pathPositionList1
                withAIObj.targetIndex = randomNum + 1
                withAIObj.nextTargetPosition = pathPositionList1[withAIObj.targetIndex]
                withAIObj.AI = normalCarAI
                WithAIObjSet[v.uuid] = withAIObj

                carWithAIObjList.push(withAIObj)
            })

            model.scale.multiply(new THREE.Vector3(0.01, 0.01, 0.01));


            //創建馬路牙子
            let boxGeometry = new THREE.BoxGeometry(40, 1, 4)
            let lambertMaterial = new THREE.MeshLambertMaterial({
                // color: "0x6E6E6E"
            })

            let boxMesh = new THREE.Mesh(boxGeometry, lambertMaterial)
            boxMesh.material.color = new THREE.Color(0.43137254, 0.43137254, 0.43137254)
            scene.add(boxMesh)
            boxMesh.position.x = 210
            boxMesh.position.y = -0.7
            boxMesh.position.z = 28

            //店員列表
            const shopmanList = []

            //创建店员
            createShopAndMan(shopPointList, shopmanList)

            //加載展館廣告牌
            loadHallDoorAdvImg()

            // setTimeout(() => {
            //     controlFlag = false
            //     meshGroup.remove(camera)
            //     scene.add(camera)
            //     camera.position.set(0, 0, 0)
            //
            // }, 3000)


            loadingPercent.value += 3

        },
        callback: (group) => {
            scene.add(group)
            islandList.push(group)



            // loadFbxModel("woman.fbx", {
            //     loadCallback: (model) => {
            //         // model.traverse( function ( object ) {
            //         //
            //         // })
            //         model.scale.multiply(new THREE.Vector3(0.1, 0.1, 0.1));
            //         getSceneModelFaceNum(model)
            //
            //
            //         const withAIObj = {
            //             group: null,
            //             model: null,
            //             allActions: null,
            //             activeAction: null,
            //             previousAction: null,
            //             nextTargetPosition: null,    //Vector3
            //             previousTargetPosition: null,
            //             targetPositionList: [],
            //             AI: null,
            //             action: null,
            //             name: "店員",
            //             targetIndex: 0,
            //             timer_1: 0,
            //             timer_2: 0
            //         }
            //
            //         withAIObj.allActions = {};
            //
            //
            //         let animations = model.animations;
            //         const mixer = new THREE.AnimationMixer( model );
            //         mixerObj[model.uuid] = mixer
            //
            //         //遍歷所有動作
            //         for ( let i = 0; i !== animations.length; ++ i ) {
            //             //動作
            //             const clip = animations[ i ];
            //             const action = mixer.clipAction( clip );
            //             withAIObj.allActions[clip.name ] = action;
            //
            //         }
            //
            //         withAIObj.activeAction = withAIObj.allActions['idle'];
            //         withAIObj.activeAction.play();
            //     },
            //     callback: (group) => {
            //         scene.add(group)
            //
            //     }
            // })






            // loadGlbModel("manp2_bin.glb", {
            //     scaleY: 0.45,
            //     castShadow: true,
            //     loadCallback: (gltf, model) => {
            //         withAIObj.model = model
            //
            //         // getSceneModelFaceNum(model)
            //         //动作
            //         const mixer = new THREE.AnimationMixer( model );
            //         mixerObj[model.uuid] = mixer
            //
            //         withAIObj.allActions = {};
            //
            //         let animations = gltf.animations;
            //
            //         //随机上衣和裤子的颜色
            //         model.traverse( function ( object ) {
            //             if (object.name === "Retopo_Wolf3D_Outfit_Top"){
            //                 object.material = object.material.clone()
            //                 object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
            //                 // object.material.color = new THREE.Color(0.52941176, 0.80784313, 0.98039215)
            //             }
            //
            //             if (object.name === "Retopo_Wolf3D_Outfit_Bottom"){
            //                 object.material = object.material.clone()
            //                 object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
            //                 // object.material.color = new THREE.Color(0.52941176, 0.80784313, 0.98039215)
            //             }
            //
            //             if (object.name === "Retopo_Wolf3D_Outfit_Footwear"){
            //                 object.material = object.material.clone()
            //                 object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
            //                 // object.material.color = new THREE.Color(0.52941176, 0.80784313, 0.98039215)
            //             }
            //         })
            //
            //
            //         //遍歷所有動作
            //         for ( let i = 0; i !== animations.length; ++ i ) {
            //             //動作
            //             const clip = animations[ i ];
            //             const action = mixer.clipAction( clip );
            //             withAIObj.allActions[clip.name ] = action;
            //
            //         }
            //
            //         withAIObj.activeAction = withAIObj.allActions['idle'];
            //         withAIObj.activeAction.play();
            //
            //         withAIObj.action = 'idle'
            //
            //         if (null != withAIObj.nextTargetPosition){
            //             model.lookAt(withAIObj.nextTargetPosition)
            //             createShopManAnimation(withAIObj)
            //         }
            //
            //         // getSceneModelFaceNum(model)
            //         //将店员加入列表
            //         shopmanList.push(withAIObj)
            //
            //
            //         resolve()
            //     },
            //     callback: (group) => {
            //         WithAIObjSet[group.uuid] = withAIObj
            //         withAIObj.group = group
            //         scene.add(group)
            //
            //         //加载店员的ai
            //         withAIObj.AI = ShopmanAI
            //
            //         group.position.x = initPosition.getComponent(0)
            //         group.position.y = initPosition.getComponent(1)
            //         group.position.z = initPosition.getComponent(2)
            //
            //
            //         // createShopManAnimation(withAIObj)
            //
            //
            //     }
            // })



        }
    })


}

async function createShopAndMan(shopList, shopmanList, index = 0){
    // shopList.forEach((v, i) => {
    const doorNum = index + 1

    if (index >= shopList.length){
        //加载名牌贴图
        const texture = texLoader.load(process.env.BASE_URL + "mytextures/name_pad.png");
        const spriteMaterial = new THREE.SpriteMaterial({
            map: texture,
        });
        const sprite = new THREE.Sprite(spriteMaterial);

        sprite.position.y = 3.5

        sprite.scale.x = 1.5
        sprite.scale.y = 0.75

        createShopmanNamePad(shopmanList)

        return
        // }else if (null == shopObjList[index]){
    }else if (null == regionMap.shopMap[regionMap.currPage] || null == regionMap.shopMap[regionMap.currPage][doorNum]){
        let colorType = 1
        let sizeType = 1

        if (doorNum === 5 || doorNum === 32){
            sizeType = 3

            if (doorNum === 32){
                colorType = 2
            }

        }else if(doorNum === 2 || doorNum === 12 || doorNum === 17 || doorNum === 23 || doorNum === 25 || doorNum === 30){
            sizeType = 2
            colorType = 1 + Math.floor(Math.random() * 2)
        }else{
            colorType = 1 + Math.floor(Math.random() * 5)
        }

        //隱藏廣告牌
        for(let i=0; i<shopList[index].children.length; i++){
            // if (shopList[index].children[i].name.indexOf("billboard_") !== -1){
            shopTrafficPadMap[doorNum - 1].visible = false
            shopList[index].children[i].visible = false
            break
            // }
        }

        // let scaleY = null
        // if (sizeType == 1){
        //     scaleY = 800
        // }
        sizeType = 1
        if (sizeType == 1){
            colorType = 1
        }

        if (doorNum > 32){
            colorType = 2

            const vec3 = new THREE.Vector3()
            // mesh.position.z = 1800

            shopList[index].getWorldPosition(vec3)

            let distance = 18

            if (shopList[index].rotation.y < 0){
                distance = -18
            }

            airWallList[`big_shop_building_${doorNum}`] = {
                MAX_POSITION_X: vec3.x + 19 + distance + 0.8,
                MIN_POSITION_X: vec3.x - 19 + distance - 0.8,
                MAX_POSITION_Z: vec3.z + 24.5 + 0.5,
                MIN_POSITION_Z: vec3.z - 24.5 - 0.5
            }
        }

        loadGlbModel(`island/BuildingShop_${sizeType}_${colorType}.gltf`, {
            // scaleY: scaleY,
            loadCallback: (model) => {
                // model.children[0].material = whiteMaterial
                model = model.scene

                //加載沒有店鋪數據的店鋪
                model.traverse((child) => {
                    // if (sizeType == 1 && child.isMesh){
                    //     child.material.emissive = null;
                    //     child.material.emissiveIntensity = 0;
                    //     child.material.emissiveMap = null;
                    // }

                    if (child.isMesh){
                        child.color = new THREE.Color(1,1,1);
                        child.material.emissiveIntensity = 1;
                        child.material.emissiveMap = child.material.map;
                    }

                    if (child.name === "House_number"){
                        createShopNumMaterial(child, doorNum)
                    }

                    if (child.name.indexOf("Name_Plane") != -1){
                        child.visible = false
                    }

                    if (child.name === "plane"){
                        const material = new THREE.MeshBasicMaterial();

                        material.copy(child.material)

                        child.material = material
                    }

                    if (child.name == "shop_gass_within"){
                        // const material = new THREE.MeshPhongMaterial()
                        // material.envMap = sceneEnvironmentMap
                        //
                        // child.material = material

                        const material = new THREE.MeshBasicMaterial()
                        child.material = material
                    }else{
                        if (child.isMesh && null != child.material){
                            if (child.material.length != null && child.material.length > 0){
                                child.material.forEach((v, i) => {
                                    const material = new THREE.MeshBasicMaterial()
                                    material.copy(v)
                                    v = material
                                })
                            }else{
                                try {
                                    const material = new THREE.MeshBasicMaterial()
                                    material.copy(child.material)
                                    child.material = material
                                }catch(e){
                                    console.log(e)
                                }
                            }

                        }
                    }

                    if (child.name === "shop_ad"){
                        child.visible = false
                    }

                    // if (colorType == 2 && child.name === "shop"){
                    //
                    //     child.material.forEach((m, i) => {
                    //         if (m.name.indexOf("Window_") != -1){
                    //             m.envMap = testEnvMap
                    //             m.envMapIntensity = 1
                    //         }
                    //     })
                    // }

                    // if (child.name == "shop_gass_01"){
                    //     let mirror = new Reflector(mirrorPlaneGeometry2, options);
                    //     child.add(mirror)
                    //
                    //     // mirror.position.x = -400
                    //     mirror.position.y = 30
                    //     mirror.position.z = 1
                    //     //
                    //     mirror.rotation.y = Math.PI
                    //
                    //
                    // }
                    //
                    // if (child.name == "shop_gass_02"){
                    //     let mirror = new Reflector(mirrorPlaneGeometry, options);
                    //     child.add(mirror)
                    //
                    //     mirror.rotation.y = Math.PI / 2
                    //
                    //     // mirror.position.x = 445
                    //     mirror.position.y = 30
                    //     // mirror.position.z = -350
                    //
                    //
                    // }
                })

                if (colorType == 1){
                    model.scale.x = 150
                    model.scale.y = 150
                    model.scale.z = 150
                }else{
                    model.scale.x = 100
                    model.scale.y = 100
                    model.scale.z = 100
                }

                // if (sizeType == 1){
                //     model.scale.y = 1.5
                // }
            },
            callback: (group) => {
                shopList[index].add(group)
                group.name = "add_shop_group"

                if (sizeType > 1){
                    interactionObj[group.uuid] = [{
                        distance: 15,
                        icon: "fa-solid fa-dollar-sign",
                        name: `${i18n.tkey("lang_application_to")} ${regionMap.currPage}-${doorNum}`,
                        // mesh: shopList[index].children[0],
                        mesh: group.children[0],
                        callback: () => {
                            openConfirm(i18n.tkey("lang_contact_shopopee_pls"), () => {
                                location.href = `${proxy.$ShopopeeUrl}/feedback`
                            })
                        }
                    }]
                }

                clearMeshList.push(group)
                clearDataList.push({"key": group.uuid, map: interactionObj})

            }
        })

        const withAIObj = getEmptyWithAIObj()

        withAIObj.login = ""
        withAIObj.name = ""
        withAIObj.memMale = ""
        withAIObj.whatsshopsbcataList = ""
        withAIObj.companyName = ""
        withAIObj.rid = regionMap.currPage
        withAIObj.did = doorNum

        let v = shopList[index]
        let randomIndex = Math.floor(Math.random() * 6)
        let nextIndex = Math.floor(Math.random() * 6)
        let initPosition = new THREE.Vector3()

        if (randomIndex == nextIndex){
            nextIndex = nextIndex++
            nextIndex = nextIndex > 5 ? 0 : nextIndex
        }

        v.traverse( (object) => {

            if (object.name.indexOf(`Shop_man_position_${index}_`) != -1){
                if (object.name == `Shop_man_position_${index}_${randomIndex}`){
                    object.getWorldPosition(initPosition)
                }

                if (object.name == `Shop_man_position_${index}_${nextIndex}`){
                    const vector3 = new THREE.Vector3()
                    object.getWorldPosition(vector3)
                    withAIObj.nextTargetPosition = vector3
                    withAIObj.targetIndex = nextIndex
                }

                const positionNum = new THREE.Vector3()
                withAIObj.targetPositionList.push(object.getWorldPosition(positionNum))
            }

        } )

        const promise = new Promise((resolve, reject) => {
            // let fileName = "town2/boy21.fbx"
            let fileName = "town2/aman.gltf"
            // if (withAIObj.memMale != 0){
            //     fileName = "town2/woman.fbx"
            // }

            if (userInfoRef.value.shopmanSex == 1){
                // fileName = "town2/woman.fbx"
                fileName = "town2/agirl.gltf"
            }

            loadGlbModel(fileName, {
                scaleY: 0.48,
                // castShadow: true,
                loadCallback: (gltf, model) => {
                    // const children = []
                    //
                    // children.push(model.children[1])
                    // children.push(model.children[0])
                    // model.children = children

                    withAIObj.model = model
                    // model.children[0].traverse( (object) => {
                    // interactionList.push(model.children[0])
                    // })

                    // getSceneModelFaceNum(model)
                    //动作
                    const mixer = new THREE.AnimationMixer( model );
                    mixerObj[model.uuid] = mixer

                    clearDataList.push({"key": model.uuid, map: mixerObj})

                    withAIObj.allActions = {};

                    let animations = gltf.animations;

                    //随机上衣和裤子的颜色
                    model.traverse( function ( object ) {
                        if (object.name === "Wolf3D_Outfit_Top"){
                            object.material = object.material.clone()

                            if (index % 2 === 0){
                                object.material.map = textureMap["outfit-classic-03-v2-m-top-D_G.jpg"]
                            }else{

                                object.material.map = textureMap["outfit-classic-03-v2-m-top-D_B.jpg"]
                            }

                            object.material.map.needsUpdate = true
                            object.material.needsUpdate = true
                        }

                        if (object.name === "Wolf3D_Outfit_Bottom"){
                            object.material = object.material.clone()

                            if (index % 2 === 0){
                                object.material.map = textureMap["outfit-classic-03-v2-m-bottom-D_G.jpg"]
                            }else{
                                object.material.map = textureMap["outfit-classic-03-v2-m-bottom-D_B.jpg"]
                            }

                            object.material.map.needsUpdate = true
                            object.material.needsUpdate = true

                        }
                    })

                    // model.children[0].material.shininess = 0
                    // const material = new THREE.MeshStandardMaterial({})
                    // material.copy(model.children[0].material)
                    // model.children[0].material = material

                    //遍歷所有動作
                    for ( let i = 0; i !== animations.length; ++ i ) {
                        //動作
                        const clip = animations[ i ];
                        const action = mixer.clipAction( clip );
                        withAIObj.allActions[clip.name ] = action;

                    }

                    withAIObj.activeAction = withAIObj.allActions['idle'];
                    withAIObj.activeAction.play();

                    withAIObj.action = 'idle'

                    // getSceneModelFaceNum(model)
                    //将店员加入列表
                    shopmanList.push(withAIObj)

                    if (Math.random() < 0.45){
                        const randomNum = Math.floor(Math.random() * commentTextList.length)

                        interactionObj[model.children[0].uuid] = [
                            {
                                distance: 10,
                                icon: "fa-solid fa-comment-dots",
                                name: i18n.tkey("lang_Conversation"),
                                mesh: model.children[0],
                                callback: () => {
                                    goPersonChat(model, i18n.tkey("lang_passerby"), commentTextList[randomNum], () => {

                                    })
                                }
                            }
                        ]

                        clearDataList.push({"key": model.children[0].uuid, map: interactionObj})
                    }




                    resolve()
                },
                callback: (group) => {
                    WithAIObjSet[group.uuid] = withAIObj
                    withAIObj.group = group
                    scene.add(group)

                    //加载店员的ai
                    withAIObj.AI = ShopmanAI

                    group.position.x = initPosition.getComponent(0)
                    group.position.y = initPosition.getComponent(1)
                    group.position.z = initPosition.getComponent(2)

                    if (null != withAIObj.nextTargetPosition){
                        withAIObj.model.lookAt(withAIObj.nextTargetPosition)
                        createShopManAnimation(withAIObj)
                    }

                    if (regionMap.guideFlag && null == rid && null == did && null == regionMap.guideWithAIObj){
                        createGuideContent(withAIObj)
                        // createGuideShopman(withAIObj)
                    }

                    // createShopManAnimation(withAIObj)

                    clearMeshList.push(group)
                    clearDataList.push({"key": group.uuid, map: WithAIObjSet})
                    clearDataList.push({"key": group.uuid, map: animationObjGroup})

                }
            })

        })

        promise.then(() => {
            createShopAndMan(shopList, shopmanList, doorNum)
        })



        // createShopAndMan(shopList, shopmanList, doorNum)
    }else{
        const shopData = regionMap.shopMap[regionMap.currPage][doorNum].data

        let setObj = {}
        let level = 1
        let type = 1

        //顯示廣告牌
        for(let i=0; i<shopList[index].children.length; i++){
            if (shopList[index].children[i].name.indexOf("browse_") !== -1){
                // shopList[index].children[i].visible = true
                // shopList[index].children[i].visible = false

                shopTrafficPadMap[doorNum - 1].visible = true


                replaceTrafficNumMaterial(shopData.materialStatus, regionMap.currPage, doorNum)

                // interactionObj[shopList[index].children[i].uuid] = [{
                //     trigger: false,
                //     distance: 6,
                //     icon: "fa-solid fa-circle-info",
                //     name: "店鋪產品",
                //     // mesh: shopList[index].children[0],
                //     mesh: shopList[index].children[i],
                //     callback: () => {
                //         // goShopConfirm(index)
                //         proxy.$refs.shopopeePhone.goMaterialView(shopData.companyCode)
                //     }
                // }]
                // clearDataList.push({"key": shopList[index].children[i].uuid, map: interactionObj})

                break
            }
        }

        if (shopData.shareSOCom != null){
            setObj = JSON.parse(shopData.shareSOCom)

            if (null != setObj.shopLevel){
                level = setObj.shopLevel
            }

            if (null != setObj.houseType){
                type = setObj.houseType
            }
        }

        // let scaleY = null
        // if (level == 1){
        //     scaleY = 800
        // }
        level = 1
        if (level === 1){
            type = 1
        }

        if (doorNum > 32){
            type = 2

            const vec3 = new THREE.Vector3()
            // mesh.position.z = 1800

            shopList[index].getWorldPosition(vec3)

            let distance = 18

            if (shopList[index].rotation.y < 0){
                distance = -18
            }

            airWallList[`big_shop_building_${doorNum}`] = {
                MAX_POSITION_X: vec3.x + 19 + distance + 0.8,
                MIN_POSITION_X: vec3.x - 19 + distance - 0.8,
                MAX_POSITION_Z: vec3.z + 24.5 + 0.5,
                MIN_POSITION_Z: vec3.z - 24.5 - 0.5
            }
        }

        loadGlbModel(`island/BuildingShop_${level}_${type}.gltf`, {
            // scaleY: scaleY,
            loadCallback: (model) => {
                // const texMap = texLoader.load(process.env.BASE_URL + "mymodels/fbx/island/shop01_3.png")
                model = model.scene
                //加載有店鋪數據的店鋪
                model.traverse( (object) => {
                    //加载招牌
                    if (object.name.indexOf("Name_Plane") != -1){
                        if (null != shopData.shopMallId && (null != shopData.mallCover || null != shopData.mallCover2)){
                            let texUrl = shopData.mallCover2

                            if (myUtil.isEmpty(texUrl) || userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                                texUrl = shopData.mallCover
                            }

                            const map = texLoader.load(texUrl);
                            const newMaterial = new THREE.MeshBasicMaterial({
                                map: map
                            });

                            object.material = newMaterial
                            object.scale.y = 3
                            object.scale.x = 2
                        }else{
                            let companyName = ""

                            if (null != shopData){
                                if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                                    companyName = shopData.companyName
                                }else{
                                    if (myUtil.isNotEmpty(shopData.companyName2)){
                                        companyName = shopData.companyName2
                                    }else{
                                        companyName = shopData.companyName
                                    }

                                }

                            }

                            if (0 == setObj.status || shopData.recordno == 0){
                                companyName = i18n.tkey("lang_Under_renovation")
                            }

                            object.material = createShopSignPad(companyName, true, -90)

                            if (null != shopData.shopMallId){
                                object.scale.y = 3
                                object.scale.x = 2
                            }
                        }

                    }

                    if (object.name === "plane"){
                        const material = new THREE.MeshBasicMaterial();

                        material.copy(object.material)

                        object.material = material

                        if (null != shopData.shopMallId){
                            object.scale.y = 3
                            object.scale.x = 2
                        }

                    }

                    if (object.name === "House_number" ){
                        createShopNumMaterial(object, doorNum)
                    }

                    if (object.name === "House_number" || object.name.indexOf("Name_Plane") != -1){
                        const country = shopData.countryCode
                      console.log(shopData)
                        const islandStr = null == userInfoRef.value.islandID ? '' : `${userInfoRef.value.islandID}/`
                        //const url = `${proxy.$ThreeDShopopeePath}${islandStr}index/${country}/${shopData.wa}/${shopData.siojournal}`
                        const url = `${proxy.$ThreeDShopopeePath}landShop/${country}/${shopData.shopId}`

                        clickVisibleList.push(object)
                        interactionObj[object.uuid] = [{
                            callback: () => {
                                shareCompanyCode.value = shopData.companyCode
                                shareUrl.value = url
                                shareUrlVisible.value = true
                                // copy(url)
                                // myUtil.alertSuccess(i18n.tkey("lang_copy_shop_url_alert"))
                            }
                        }]

                        clearDataList.push({"key": object.uuid, map: interactionObj})
                    }

                    if (object.name === "door"){

                        // interactionObj[object.uuid] = [{
                        //     distance: 2,
                        //     icon: "",
                        //     name: "",
                        //     UIFlag: false,
                        //     mesh: object,
                        //     triggerCallback: () => {
                        //         meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);
                        //         goShopConfirm(regionMap.currPage, doorNum)
                        //     }
                        // }]
                        // clearDataList.push({"key": object.uuid, map: interactionObj})
                    }

                    if (object.name.indexOf("shop_gass") != -1){
                        // const material = new THREE.MeshBasicMaterial({
                        //     color: "0x000000",
                        //     map: textureMap[`shopBackImg_${1 + Math.floor(Math.random() * 8)}.png`],
                        //     // side: THREE.DoubleSide
                        // })

                        // const material = new THREE.MeshPhongMaterial({
                        // color: 0x87a19a,
                        // shininess: 50, //高光部分的亮度，默认30-->
                        // specular: 0xffffff, //高光部分的颜色-->
                        // })
                        // material.envMap = testEnvMap

                        // object.material = material

                        // const material = new THREE.MeshPhongMaterial()
                        // material.envMap = sceneEnvironmentMap

                        // const material = new THREE.MeshBasicMaterial()
                        // material.map = textureMap["shopBackImg_1.png"]
                        //
                        // object.material = material

                        // object.visible = false
                        //
                        // const material = new THREE.MeshBasicMaterial({
                        //     color: "0xffffff",
                        //     map: textureMap[`shopBackImg_${1 + Math.floor(Math.random() * 8)}.png`],
                        //     side: THREE.DoubleSide
                        // })
                        //
                        // const boxGeometry = new THREE.PlaneGeometry(1000, 400);
                        // const mesh = new THREE.Mesh(boxGeometry, material)
                        // object.parent.add(mesh)
                        //
                        // mesh.position.copy(object.position)
                        //
                        // mesh.position.x = 0
                        // mesh.position.y = 200
                        // mesh.position.z = -300

                        // const gui = new GUI()
                        // gui.add(mesh.position, "x")
                        // gui.add(mesh.position, "y")
                        // gui.add(mesh.position, "z")

                    }else{
                        if (object.isMesh && null != object.material){
                            if (object.material.length != null && object.material.length > 0){
                                object.material.forEach((v, i) => {
                                    const material = new THREE.MeshBasicMaterial()
                                    material.copy(v)
                                    v = material
                                })
                            }else{
                                try {
                                    const material = new THREE.MeshBasicMaterial()
                                    material.copy(object.material)
                                    object.material = material
                                }catch(e){
                                    console.log(e)
                                }
                            }

                        }
                    }

                    if (object.name === "shop_ad"){
                        if (myUtil.isEmpty(shopData.advImg)){
                            object.visible = false
                        }else{
                            //加載廣告
                            const imgUrl = shopData.advImg
                            texLoader.load(imgUrl, (texture) => {
                                texture.colorSpace = THREE.SRGBColorSpace
                                texture.flipY = false

                                const advMaterial = new THREE.MeshBasicMaterial({
                                    map: texture
                                })
                                object.material = advMaterial
                            })

                            //添加點擊事件
                            clickVisibleList.push(object)
                            interactionObj[object.uuid] = [{
                                callback: () => {
                                    const distance = meshGroup.position.distanceTo(object.position)

                                    if (distance / 100 > 20){
                                        return
                                    }


                                    advRecord.value = generateAdvObj(shopData)

                                    advVideoVisible.value = true
                                }
                            }]

                            clearDataList.push({"key": object.uuid, map: interactionObj})

                        }

                    }

                    // if (type == 2 && object.name === "shop"){
                    //
                    //     object.material.forEach((m, i) => {
                    //         if (m.name.indexOf("Window_") != -1){
                    //             m.envMap = testEnvMap
                    //             m.envMapIntensity = 1
                    //         }
                    //     })
                    // }

                    // if (object.name == "shop_gass_01"){
                    //     let mirror = new Reflector(mirrorPlaneGeometry2, options);
                    //     object.add(mirror)
                    //
                    //     // mirror.position.x = -400
                    //     mirror.position.y = 30
                    //     mirror.position.z = 1
                    //     //
                    //     mirror.rotation.y = Math.PI
                    //
                    //
                    // }
                    //
                    // if (object.name == "shop_gass_02"){
                    //     let mirror = new Reflector(mirrorPlaneGeometry, options);
                    //     object.add(mirror)
                    //
                    //     mirror.rotation.y = Math.PI / 2
                    //
                    //     // mirror.position.x = 445
                    //     mirror.position.y = 30
                    //     // mirror.position.z = -350
                    //
                    //     // let gui = new GUI()
                    //     // gui.add(mirror.position, "x").step(0.1)
                    //     // gui.add(mirror.position, "y").step(0.1)
                    //     // gui.add(mirror.position, "z").step(0.1)
                    //
                    // }
                })

                if (type == 1){
                    model.scale.x = 150
                    model.scale.y = 150
                    model.scale.z = 150
                }else{
                    model.scale.x = 100
                    model.scale.y = 100
                    model.scale.z = 100
                }

                // if (level == 1){
                //     model.scale.y = 1.5
                // }
            },
            callback: (group) => {
                shopList[index].add(group)
                group.name = "add_shop_group"

                // group.scale.x = 0.6;
                // group.scale.y = 0.6;
                // group.scale.z = 0.6;

                const doorObj = group.getObjectByName("door")

                let xRange = 6
                let zRange = 0.4

                if (doorNum > 32) {
                    xRange = 1
                    zRange = 6
                }

                const vec3 = new THREE.Vector3()
                doorObj.getWorldPosition(vec3)

                triggerAreaMap[doorObj.uuid] = {
                    scope: {
                        MAX_POSITION_X: vec3.x + xRange,
                        MIN_POSITION_X: vec3.x - xRange,
                        MAX_POSITION_Z: vec3.z + zRange,
                        MIN_POSITION_Z: vec3.z - zRange,
                    },
                    alive: false,
                    timer: 0.5,
                    timeLimit: 0.5,
                    func: () => {
                        meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                      if (-1 == shopData.productVerify) {
                        hintNotOpenStore()
                      }else{
                        goShopConfirm(regionMap.currPage, doorNum)
                      }
                    }
                }
                clearDataList.push({"key": doorObj.uuid, map: triggerAreaMap})

               /*
                前往店鋪觸發
                let eventList = [{
                    distance: 15,
                    icon: "fa-solid fa-store",
                    // name: shopData.companyName,
                    name: i18n.tkey("lang_shop_website_1"),
                    description: shopData.companyName,
                    // mesh: shopList[index].children[0],
                    mesh: group.children[0],
                    callback: () => {
                        // goShopConfirm(index)
                      console.log(shopData)
                      if (-1 == shopData.productVerify) {
                        hintNotOpenStore()
                      }else{
                        goShopConfirm(regionMap.currPage, doorNum, "shop")
                      }

                    },
                    triggerCallback: () => {

                        if (null != shopData.materialModels && shopData.materialModels.length > 0) {
                            productDisplayViewVisible.value = true
                            showMaterialList.value = shopData.materialModels
                            showMaterialShopdata.value = shopData
                        }

                        saveShopVisits(shopData.companyId)

                    },
                    leaveCallback: () => {
                        productDisplayViewVisible.value = false
                        showMaterialList.value = []
                        showMaterialShopdata.value = null
                    }
                }]

                // if (-1 == shopData.dinumber) {
                //     eventList = []
                // }
                //前往商場觸發
                if (myUtil.isNotEmpty(shopData.shopMallId)) {
                    const newList = [{
                        distance: 15,
                        icon: "fa-solid fa-basket-shopping",
                        name: i18n.tkey("lang_enter_shopmall"),
                        description: shopData.companyName,
                        mesh: group.children[0],
                        callback: () => {
                          if (!myUtil.isEmpty(shopData.shopMallType)){
                            proxy.$router.push({path: `/personal/${shopData.shopMallId}`})
                          }else {
                            proxy.$router.push({path: `/hall/${shopData.shopMallId}`})
                          }
                        }
                    }]

                    eventList = newList
                }

                */

                /*if (myUtil.isNotEmpty(shopData.website)) {
                    eventList.push({
                        distance: 15,
                        icon: "fa-solid fa-arrow-up-right-from-square",
                        name: i18n.tkey("lang_company_website"),
                        description: shopData.companyName,
                        mesh: group.children[0],
                        callback: () => {
                            if (shopData.website.indexOf("http") == -1){
                                myUtil.goURLNewWindow("http://" + shopData.website)
                            }else{
                                myUtil.goURLNewWindow(shopData.website)
                            }
                        }
                    })
                }*/

               // interactionObj[group.uuid] = eventList
              //新增店鋪觸發聊天

              if (null == shopData.shopMallId) {
                interactionObj[group.children[0].uuid] = [
                  {
                    distance: 10,
                    icon: "fa-solid fa-address-card",
                    // name: withAIObj.name,
                    name: i18n.tkey("lang_memberwork"),
                    description: shopData.name,
                    mesh: group.children[0],
                    callback: () => {
                      let src = proxy.$ShopopeeUrl + shopData.cardInfo
                      let href = proxy.$ShopopeeUrl + "/receive?id=" + shopData.memberworkId
                      showCardBox(src, href, shopData.memberworkId)
                      goPersonChat(model, shopData.name, [i18n.tkey("lang_receive_card_pls")], () => {
                        // setTimeout(() => {
                        // closePersonChat()
                        // }, 1000)
                      })
                    },
                    triggerCallback: () => {

                      if (null != shopData.materialModels && shopData.materialModels.length > 0) {
                        productDisplayViewVisible.value = true
                        showMaterialList.value = shopData.materialModels
                        showMaterialShopdata.value = shopData
                      }

                      saveShopVisits(shopData.companyId)

                    },
                    leaveCallback: () => {
                      productDisplayViewVisible.value = false
                      showMaterialList.value = []
                      showMaterialShopdata.value = null
                    }
                  },
                  {
                    distance: 10,
                    icon: "fa-solid fa-comments",
                    // name: withAIObj.name,
                    name: i18n.tkey("lang_open_personal_chat"),
                    description: shopData.name,
                    mesh: group.children[0],
                    callback: () => {
                      // openNewChat(withAIObj.login)
                      // bottomInteractionUiVisible.value = false
                      // upperRightUiVisible.value = false
                      // nippleViewVisible.value = false
                      //
                      // controlFlag = false


                      chatCardId.value = shopData.memberworkId
                      chatSelectorVisible.value = true
                    }
                  }]
              }


                clearMeshList.push(group)
                clearDataList.push({"key": group.uuid, map: interactionObj})
            }
        })

        // interactionList.push(shopList[index].children[0])
        // interactionObj[shopList[index].children[0].uuid] = [{
        //     distance: 15,
        //     icon: "fa-solid fa-store",
        //     name: shopData.companyName,
        //     mesh: shopList[index].children[0],
        //     callback: () => {
        //         goShopConfirm(index)
        //     }
        // }]

        const withAIObj = getEmptyWithAIObj()

        withAIObj.login = shopData.login
        withAIObj.name = shopData.name
        withAIObj.memMale = shopData.memMale
        withAIObj.whatsshopsbcataList = shopData.whatsshopsbcataList
        withAIObj.companyName = shopData.companyName
        withAIObj.rid = regionMap.currPage
        withAIObj.did = doorNum

        let v = shopList[index]
        let randomIndex = Math.floor(Math.random() * 6)
        let nextIndex = Math.floor(Math.random() * 6)
        let initPosition = new THREE.Vector3()

        if (randomIndex == nextIndex){
            nextIndex = nextIndex++
            nextIndex = nextIndex > 5 ? 0 : nextIndex
        }

        v.traverse( (object) => {

            if (object.name.indexOf(`Shop_man_position_${index}_`) != -1){
                if (object.name == `Shop_man_position_${index}_${randomIndex}`){
                    object.getWorldPosition(initPosition)
                }

                if (object.name == `Shop_man_position_${index}_${nextIndex}`){
                    const vector3 = new THREE.Vector3()
                    object.getWorldPosition(vector3)
                    withAIObj.nextTargetPosition = vector3
                    withAIObj.targetIndex = nextIndex
                }

                const positionNum = new THREE.Vector3()
                withAIObj.targetPositionList.push(object.getWorldPosition(positionNum))
            }

        } )

        const promise = new Promise((resolve, reject) => {
            // let fileName = "town2/boy21.fbx"
            let fileName = "town2/aman.gltf"
            // if (withAIObj.memMale != 0){
            //     fileName = "town2/woman.fbx"
            // }

            if (userInfoRef.value.shopmanSex == 1){
                // fileName = "town2/woman.fbx"
                fileName = "town2/agirl.gltf"
            }

            loadGlbModel(fileName, {
                // scaleY: 2.5,
                scaleY: 0.48,
                // castShadow: true,
                loadCallback: (gltf, model) => {
                    // const children = []
                    // children.push(model.children[1])
                    // children.push(model.children[0])
                    // model.children = children

                    withAIObj.model = model
                    // model.children[0].traverse( (object) => {
                    // interactionList.push(model.children[0])

                    if (null == shopData.shopMallId){
                      //人綁定觸發聊天
                        /*interactionObj[model.children[0].uuid] = [
                            {
                                distance: 10,
                                icon: "fa-solid fa-address-card",
                                // name: withAIObj.name,
                                name: i18n.tkey("lang_memberwork"),
                                description: withAIObj.name,
                                mesh: model.children[0],
                                callback: () => {
                                    let src = proxy.$ShopopeeUrl + shopData.cardInfo
                                    let href = proxy.$ShopopeeUrl + "/receive?id=" + shopData.memberworkId
                                    showCardBox(src, href, shopData.memberworkId)
                                    goPersonChat(model, withAIObj.name, [i18n.tkey("lang_receive_card_pls")], () => {
                                        // setTimeout(() => {
                                        // closePersonChat()
                                        // }, 1000)
                                    })
                                }
                            },
                            {
                                distance: 10,
                                icon: "fa-solid fa-comments",
                                // name: withAIObj.name,
                                name: i18n.tkey("lang_open_personal_chat"),
                                description: withAIObj.name,
                                mesh: model.children[0],
                                callback: () => {
                                    // openNewChat(withAIObj.login)
                                    // bottomInteractionUiVisible.value = false
                                    // upperRightUiVisible.value = false
                                    // nippleViewVisible.value = false
                                    //
                                    // controlFlag = false


                                    chatCardId.value = shopData.memberworkId
                                    chatSelectorVisible.value = true
                                }
                            }]*/
                    }


                    // })

                    // getSceneModelFaceNum(model)
                    //动作
                    const mixer = new THREE.AnimationMixer( model );
                    mixerObj[model.uuid] = mixer

                    clearDataList.push({"key": model.children[0].uuid, map: interactionObj})
                    clearDataList.push({"key": model.uuid, map: mixerObj})

                    withAIObj.allActions = {};

                    let animations = gltf.animations;

                    //随机上衣和裤子的颜色
                    model.traverse( function ( object ) {
                        if (object.name === "Wolf3D_Outfit_Top"){
                            object.material = object.material.clone()

                            if (index % 2 === 0){
                                object.material.map = textureMap["outfit-classic-03-v2-m-top-D_G.jpg"]
                            }else{
                                object.material.map = textureMap["outfit-classic-03-v2-m-top-D_B.jpg"]
                            }

                            object.material.map.needsUpdate = true
                            object.material.needsUpdate = true
                        }

                        if (object.name === "Wolf3D_Outfit_Bottom"){
                            object.material = object.material.clone()

                            if (index % 2 === 0){
                                object.material.map = textureMap["outfit-classic-03-v2-m-bottom-D_G.jpg"]
                            }else{
                                object.material.map = textureMap["outfit-classic-03-v2-m-bottom-D_B.jpg"]
                            }

                            object.material.map.needsUpdate = true
                            object.material.needsUpdate = true

                        }
                    })

                    // model.children[0].material.shininess = 0
                    // const material = new THREE.MeshStandardMaterial({})
                    // material.copy(model.children[0].material)
                    // model.children[0].material = material

                    //遍歷所有動作
                    for ( let i = 0; i !== animations.length; ++ i ) {
                        //動作
                        const clip = animations[ i ];
                        const action = mixer.clipAction( clip );
                        withAIObj.allActions[clip.name ] = action;

                    }

                    withAIObj.activeAction = withAIObj.allActions['idle'];
                    withAIObj.activeAction.play();

                    withAIObj.action = 'idle'

                    // getSceneModelFaceNum(model)
                    //将店员加入列表
                    shopmanList.push(withAIObj)


                    resolve()
                },
                callback: (group) => {
                    WithAIObjSet[group.uuid] = withAIObj
                    withAIObj.group = group
                    scene.add(group)

                    //加载店员的ai
                    withAIObj.AI = ShopmanAI

                    group.position.x = initPosition.getComponent(0)
                    group.position.y = initPosition.getComponent(1)
                    group.position.z = initPosition.getComponent(2)

                    if (null != withAIObj.nextTargetPosition){
                        withAIObj.model.lookAt(withAIObj.nextTargetPosition)
                        createShopManAnimation(withAIObj)
                    }


                    // createShopManAnimation(withAIObj)

                    clearMeshList.push(group)
                    clearDataList.push({"key": group.uuid, map: WithAIObjSet})
                    clearDataList.push({"key": group.uuid, map: animationObjGroup})

                }
            })

        })

        promise.then(() => {
            createShopAndMan(shopList, shopmanList, index + 1)
        })
    }
}

async function getShopList(){
    if (null == userInfoRef.value.selectCountry){
        return
    }

    try{
        const request = companyApi.getCityInfoForThree
        const params = request.getParams()

        params.countrycode = userInfoRef.value.selectCountry

        if(null != props.islandID){
            params.islandID = props.islandID
        }

        //區號
        if(params.countrycode === "HK" && null != userInfoRef.value.areacode){
            params.areacode = userInfoRef.value.areacode
        }else{
            params.areacode = null
        }

        request.send(params, (res) => {
            if (res.code == 200){
                loadingPercent.value = 20

                shopObjList = res.detail.shopList
                advList = res.detail.advList

                // videoDomSrc.value = publicPath + 'caption.mp4'

                for (let i=0; i<advList.length; i++){
                    const obj = advList[i]

                    if (obj.jatype == 3 && myUtil.isNotEmpty(obj.addinfo3)){
                        videoDomSrc.value = obj.addinfo3
                        break;
                    }

                }

                initRegionStatus(shopObjList)
                loadTextureList()

            }else{
                myUtil.alertError(res.msg)
            }
        })

    }catch (e) {
        console.log(e)
    }
}

function loadTextureList() {
    const length = textureNameList.length
    let currCount = 0
    textureNameList.forEach((v, i) => {
        texLoader.load(process.env.BASE_URL + "mytextures/textures/" + v, (texture) => {
            texture.flipY = false
            textureMap[v] = texture
            currCount += 1

            if (currCount >= length){
                initPage()
            }

        })
    })

}

function clickAudio() {

    let video = document.getElementById("video");
    if (userInfoRef.value.openSound === true){
        userInfoRef.value.openSound = false
        try{
            audioManager.stopAllAuio()
            video.muted = true
        }catch (e) {

        }


    }else{
        userInfoRef.value.openSound = true
        try{
            audioManager.playAllAuio()
            video.muted = false
        }catch (e) {

        }

    }
}

function initRegionStatus(list) {
    let lastPage = 1

    if (myUtil.isNotEmpty(userInfoRef.value.areacode)){
        if(list.length>0){
            lastPage = Math.ceil(list.length / 32)
        }
        list.forEach((v, i) => {
            var wa = Math.ceil((i + 1) / 32)
            var siojournal = (i % 32) + 1
            if (null == regionMap.shopMap[wa]){
                regionMap.shopMap[wa] = {}
            }

            const shopObj = {
                data: v,
                shopMesh: null,
                shopmanMEsh: null
            }

            regionMap.shopMap[wa][siojournal] = shopObj
        })
    }else{
        list.forEach((v, i) => {
            if (v.wa > lastPage){
                lastPage = v.wa
            }

            if (null == regionMap.shopMap[v.wa]){
                regionMap.shopMap[v.wa] = {}
            }

            const shopObj = {
                data: v,
                shopMesh: null,
                shopmanMEsh: null
            }

            regionMap.shopMap[v.wa][v.siojournal] = shopObj
        })
    }

    regionMap.lastPage = lastPage
    lastPageNum.value = lastPage

    if (null != props.rid && null != regionMap.shopMap[props.rid]){
        regionMap.currPage = props.rid

        if (null != props.did && null != regionMap.shopMap[props.rid][props.did]){
            rid = props.rid
            did = props.did

            regionMap.fromInvite = true
            regionMap.guideFlag = true
            userInfoRef.value.invCode = regionMap.shopMap[rid][did].data.companyId

            const doorNumStr = `${rid}-${did}`
            //
            // if(userInfoRef.value.doorNumStr !== doorNumStr){
            if(userInfoRef.value.doorNumStr == null){
                userInfoRef.value.doorNumStr = doorNumStr
                // firstInvFlag = true
            }
        }
        else{
            userInfoRef.value.invCode = null
        }
        // else{
        //     userInfoRef.value.doorNumStr = null
        // }
    }
    else {
        if (null != userInfoRef.value.currPage){
            regionMap.currPage = userInfoRef.value.currPage
        }

        userInfoRef.value.invCode = null
    }
    // else{
    //     userInfoRef.value.doorNumStr = null
    // }


}

function loadFbxModel(modelName, option = {}){
    let deleteFlag = true

    if (fbxLoadFlag){
        fbxLoadQueue.push(() => {
            loadFbxModel(modelName, option)
        })
        return
    }else{
        if (fbxLoadQueue.length == 0){
            deleteFlag = false
        }

        fbxLoadFlag = true
    }

    let optionObj = {
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        scaleY: 0,
        rotateX: 0,
        rotateY: 0,
        rotateZ: 0,
        castShadow: false,
        receiveShadow: false,
        //加载模型成功后的回调
        loadCallback: null,
        //执行结束后的回调
        callback: null,
        //是否缓存加载的模型
        cache: true
    }

    optionObj = Object.assign(optionObj, option);

    const ObjGroup = new THREE.Group()

    //如果在缓存中没有该模型,加载模型
    if (null == loadObj[modelName]){
        //同步加载，避免出现同时加载多个时null
        const promiseHander = new Promise((resolve, reject) =>{
            fbxLoader.load( process.env.BASE_URL + `mymodels/fbx/${modelName}?r=${proxy.$versionNum}`, function ( model ) {
                if (optionObj.cache){
                    loadObj[modelName] = model
                    // model = model.clone()
                    model = clone(model)
                }

                optionObj["format"] = "fbx"

                handleModel(model, optionObj)

                ObjGroup.add(model)

                if (typeof optionObj.loadCallback === "function"){
                    optionObj.loadCallback(model)
                }

                ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

                if (typeof optionObj.callback === "function"){
                    optionObj.callback(ObjGroup)
                }

                if (deleteFlag){
                    fbxLoadQueue.splice(0, 1)
                }

                fbxLoadFlag = false
                if (fbxLoadQueue.length > 0){
                    fbxLoadQueue[0]()
                }

                return ObjGroup

                resolve()
            })
        })

    }else{
        //如果缓存中有此模型，克隆该模型
        // let model = loadObj[modelName].clone()
        let model = clone(loadObj[modelName])

        optionObj["format"] = "fbx"

        handleModel(model, optionObj)

        ObjGroup.add(model)

        if (typeof optionObj.loadCallback === "function"){
            optionObj.loadCallback(model)
        }

        ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

        if (typeof optionObj.callback === "function"){
            optionObj.callback(ObjGroup)
        }

        if (deleteFlag){
            fbxLoadQueue.splice(0, 1)
        }
        fbxLoadFlag = false
        if (fbxLoadQueue.length > 0){
            fbxLoadQueue[0]()
        }

        return ObjGroup
    }


    // ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)
    //
    // if (typeof optionObj.callback === "function"){
    //     optionObj.callback(ObjGroup)
    // }
    //
    // return ObjGroup
}


//加载glb模型
function loadGlbModel(modelName, option = {}) {
    let deleteFlag = true

    if (glbLoadFlag){
        glbLoadQueue.push(() => {
            loadGlbModel(modelName, option)
        })
        return
    }else{
        if (glbLoadQueue.length == 0){
            deleteFlag = false
        }

        glbLoadFlag = true
    }

    let optionObj = {
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        scaleY: 0,
        rotateX: 0,
        rotateY: 0,
        rotateZ: 0,
        castShadow: false,
        receiveShadow: false,
        //加载模型成功后的回调
        loadCallback: null,
        //执行结束后的回调
        callback: null,
        //是否缓存加载的模型
        cache: true
    }

    optionObj = Object.assign(optionObj, option);

    const ObjGroup = new THREE.Group()

    //如果在缓存中没有该模型,加载模型
    if (null == loadObj[modelName]){
        //同步加载，避免出现同时加载多个时null
        const promiseHander = new Promise((resolve, reject) =>{
            gltfLoader.load( process.env.BASE_URL + `mymodels/gltf/${modelName}?r=${proxy.$versionNum}`, function ( gltf ) {

                if (optionObj.cache){
                    loadObj[modelName] = gltf
                    // model = model.clone()
                    loadObj[modelName].scenes = []
                    const modelData = loadObj[modelName].scene
                    loadObj[modelName].scene = null

                    const copyObj = Object.assign({}, loadObj[modelName])
                    copyObj.scene = clone(modelData)
                    loadObj[modelName].scene = modelData

                    gltf = copyObj
                }

                let model = gltf.scene;

                optionObj["format"] = "gltf"

                handleModel(model, optionObj)

                ObjGroup.add(model)

                if (typeof optionObj.loadCallback === "function"){
                    optionObj.loadCallback(gltf, model)
                }

                ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

                if (typeof optionObj.callback === "function"){
                    optionObj.callback(ObjGroup)
                }

                if (deleteFlag){
                    glbLoadQueue.splice(0, 1)
                }

                glbLoadFlag = false
                if (glbLoadQueue.length > 0){
                    glbLoadQueue[0]()
                }

                return ObjGroup

                resolve()
            })
        })

    }else{
        //如果缓存中有此模型，克隆该模型
        const modelData = loadObj[modelName].scene
        loadObj[modelName].scene = null
        const copyObj = Object.assign({}, loadObj[modelName])
        copyObj.scene = clone(modelData)
        loadObj[modelName].scene = modelData

        let gltf = copyObj
        let model = gltf.scene

        handleModel(model, optionObj)

        ObjGroup.add(model)

        if (typeof optionObj.loadCallback === "function"){
            optionObj.loadCallback(gltf, model)
        }

        ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

        if (typeof optionObj.callback === "function"){
            optionObj.callback(ObjGroup)
        }

        if (deleteFlag){
            glbLoadQueue.splice(0, 1)
        }
        glbLoadFlag = false
        if (glbLoadQueue.length > 0){
            glbLoadQueue[0]()
        }

        return ObjGroup
    }
}

//根据传入的参数调整模型
function handleModel(model, optionObj) {
    let box3 = new THREE.Box3()
    let obj = new THREE.Vector3()
    let scaleNum
    box3.setFromObject(model)
    box3.getSize(obj)

    // if (optionObj.castShadow || optionObj.receiveShadow){
    model.traverse( function ( object ) {
        if ( object.isMesh ) {
            // if (optionObj.castShadow ){
            // object.castShadow = true;
            // }

            // if (optionObj.receiveShadow ){
            // object.receiveShadow = true;
            // }

            if (optionObj.format === "fbx"){
                object.material.emissive = new THREE.Color(1,1,1);
                object.material.emissiveIntensity = 1;
                object.material.emissiveMap = object.material.map;
            }

        }
    } );
    // }

    if (optionObj.rotateX > 0){
        model.rotation.x = optionObj.rotateX
    }

    if (optionObj.rotateY > 0){
        model.rotation.y = optionObj.rotateY
    }

    if (optionObj.rotateZ > 0){
        model.rotation.z = optionObj.rotateZ
    }

    if (optionObj.scaleY > 0){
        scaleNum = optionObj.scaleY / obj.getComponent(1)
        let vector = new THREE.Vector3(scaleNum, scaleNum, scaleNum);
        model.scale.multiply(vector);
    }


    return model
}
//店鋪名
function createShopSignPad(textName, materialOnly = false, rotation = 0) {
    var iszh =  /[\u4e00-\u9fa5]/.test(textName);
    var text = textName.replace("有限公司","")
    text = text.replace("公司","")
    text = text.replace("company limited","")
    text = text.replace(" limited","")
    text = text.replace(" Limited","")
    text = text.replace(" Limit","")
    let fontsize = 1160 / text.length
    let xLeft

    if (fontsize > 72){
        fontsize = 72
    }
    if(!iszh){
      if(fontsize<14){
        fontsize = fontsize*2.5
      }else if(fontsize<48){
        fontsize = fontsize*2
      }
    }else{
      if(fontsize<14){
        fontsize = fontsize*2
      }else if(fontsize<48){
        fontsize = fontsize*1.5
      }
    }

    // xLeft = 20 + (1160 - fontsize * text.length) / 2

    const padGeometry = new THREE.PlaneGeometry(9, 1.5)
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d')
    canvas.width = 1200
    canvas.height = 200
    //制作矩形
    ctx.fillStyle = "transparent";
    // ctx.fillStyle = "#0000ff";
    // ctx.drawImage(shopSignTexture, 0, 0, 1200, 200)
    ctx.fillRect(0, 0, 1200, 200)
    //设置文字
    ctx.fillStyle = "#ffffff";
    // ctx.fillStyle = "#000000";
    ctx.font = `normal ${fontsize}px "楷体"`
    const textWidth = ctx.measureText(text).width;
    xLeft = 20 + (1160 - textWidth) / 2
    // ctx.fillText(text, xLeft, (170 + fontsize) / 2)
    // ctx.fillText(text, xLeft, (140 + fontsize) / 2)
    // ctx.fillText(text, xLeft, 80 + fontsize / 2)
    ctx.fillText(text, xLeft, 100 + fontsize / 2)

    // console.log(fontsize)

    //生成图片
    let url = canvas.toDataURL('image/png');

    let map = texLoader.load(url)

    // if (rotation != 0){
    //     // 设置旋转中心点
    //     map.center.set(0.5, 0.5)
    //     map.rotation = rotation * Math.PI / 180
    // }

    const material = new THREE.MeshBasicMaterial({
        map: map,
        side: THREE.DoubleSide,
        opacity: 1,
        transparent: true
    })

    canvas.remove()

    if (materialOnly){
        padGeometry.dispose()
        return material
    }else{
        const padMesh = new THREE.Mesh(padGeometry, material)
        return padMesh
    }


}

//獲取鼠標位置的坐標和方向interactionList
// function getMousePosition(e, objList = islandList){
function getMousePosition(e, objList = islandList){
    const obj = {
        position: null,
        direction: null,
        intersects: []
    }

    let px
    let py

    if (isMobile){
        px = e.touches[0].clientX - 10;
        py = e.touches[0].clientY - 10;
    }else{
        px = e.clientX - 10;
        py = e.clientY - 10;
    }

    //屏幕坐标px、py转标准设备坐标x、y
    //width、height表示canvas画布宽高度
    const x = (px / width) * 2 - 1;
    const y = -(py / height) * 2 + 1;

    //创建一个射线投射器`Raycaster`
    const raycaster = new THREE.Raycaster();

    raycaster.setFromCamera(new THREE.Vector2(x, y), camera);

    // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
    const intersects = raycaster.intersectObjects(objList);

    if (intersects != null && intersects.length > 0){
        obj.intersects = intersects
        obj.position = intersects[0].point
    }

    if (obj.intersects.length > 0){
        const point = obj.intersects[0].point
        const vec3 = new THREE.Vector3()

        vec3.x = point.x - meshGroup.position.x
        vec3.z = point.z - meshGroup.position.z

        vec3.normalize()
        obj.direction = vec3
    }else{
        obj.direction = raycaster.ray.direction
    }



    return obj
}

function mouseDownEvent(e){
    if (!controlFlag){
        return;
    }

    mouseDownTimeStamp = new Date().getTime()

    // if (!isMobile){
        mousedownFlag = true
    // }

    // moveFlag = true
    //
    if (isMobile){
        if (null == e.touches){
            return
        }

        touchPoint = e.touches[0]
    }
    //
    // var obj = getMousePosition(e)
    //
    // obj.direction.setY(0)
    // moveVector3.copy(obj.direction)
}

function mouseUpEvent(e){
    if (isMobile){
        if (controlFlag){
            const temp = {
                touches: [
                    touchPoint
                ]
            }
            mouseClickEvent(temp)
        }
    }

    mousedownFlag = false
    moveFlag = false
    touchPoint = null
}

function mouseMoveEvent(e){
    if (!mousedownFlag)
        return

    if (!controlFlag){
        return;
    }

    // if (isMobile && operateMode != "watch"){
    //     return;
    // }

    // if (nippleFlag){
    //     return;
    // }

    if (isMobile){
        if (null == e.changedTouches){
            return
        }

        rotationNum -= (touchPoint.clientX - e.changedTouches[0].clientX) / 300;
        rotationNumY -= (touchPoint.clientY - e.changedTouches[0].clientY) / -1200;
        touchPoint = e.changedTouches[0]
    }else{
        rotationNum += e.movementX / 300;
        rotationNumY -= e.movementY / 1200;
    }

    //如果改变了镜头距离
    if (cameraOptionObj.changeCameraDistance){
        cameraOptionObj.changeCameraDistance = false

        const tween = new TWEEN.Tween(cameraOptionObj)
            .to({currCameraDistance: cameraOptionObj.defaultCameraDistance}, 5000)
            .start()
            .easing(TWEEN.Easing.Sinusoidal.InOut)
            .onComplete(() => {
                delete animationObjGroup["changeCameraDistance"]
            })
            .onUpdate(() => {
                let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
                let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;

                camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
                // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
                camera.lookAt(new THREE.Vector3(meshGroup.position.x,2.8,meshGroup.position.z));
            })

        animationObjGroup["changeCameraDistance"] = tween
    }

    //如果改变了镜头高度
    if (cameraOptionObj.changeCameraPostionY){
        cameraOptionObj.changeCameraPostionY = false

        const tween = new TWEEN.Tween(cameraOptionObj)
            .to({currCameraPositionY: cameraOptionObj.defalutCameraPositionY}, 5000)
            .start()
            .easing(TWEEN.Easing.Sinusoidal.InOut)
            .onComplete(() => {

                delete animationObjGroup["changeCameraPostionY"]
            })
            .onUpdate(() => {
                camera.position.y = cameraOptionObj.currCameraPositionY
            })

        animationObjGroup["changeCameraPostionY"] = tween
    }

    // let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
    // let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;
    //
    // camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
    // // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
    // camera.lookAt(new THREE.Vector3(meshGroup.position.x,2.5,meshGroup.position.z));

    calcCameraPosition()

    var obj = getMousePosition(e)

    obj.direction.setY(0)
    moveVector3.copy(obj.direction)

    // 将局部坐标转换为世界坐标
    let v = new THREE.Vector3()
    camera.localToWorld(v);

    // clearRam()

}

function calcCameraPosition() {
    // if (operateMode === "watch" || !isMobile || regionMap.airAdvPlayFlag){
        if (rotationNumY > 0.25){
            rotationNumY = 0.25
        }

        if (rotationNumY < -0.25){
            rotationNumY = -0.25
        }

        let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
        let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;

        camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
        // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
        camera.lookAt(new THREE.Vector3(meshGroup.position.x,cameraOptionObj.currCameraLookAtPositionY + rotationNumY,meshGroup.position.z));
    // }else{
    //     let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
    //     let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;
    //
    //     camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
    //     // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
    //     camera.lookAt(new THREE.Vector3(meshGroup.position.x,cameraOptionObj.currCameraLookAtPositionY,meshGroup.position.z));
    // }

}

function mouseClickEvent(e){
    if (!controlFlag){
        return;
    }

    if (new Date().getTime() - mouseDownTimeStamp > 250){
        return;
    }

    // const obj = getMousePosition(e, interactionList)
    const obj = getMousePosition(e, clickVisibleList)

    if (null == obj){
        return;
    }

    if (obj.intersects != null && obj.intersects.length > 0){
        const intersect = obj.intersects[0]
        if (intersect.distance < 200){
            const uuid = intersect.object.uuid
            const temp = interactionObj[uuid]

            if (null != temp){
                if (temp.length > 0){
                    for (const item in temp){
                        const obj = temp[item]
                        if (obj != null && null != obj.callback && typeof obj.callback === "function"){
                            obj.callback()
                        }
                    }
                }else{
                    if (temp != null && null != temp.callback && typeof temp.callback === "function"){
                        temp.callback()
                    }
                }
            }

        }
    }
}

function getSceneModelFaceNum(view) {  // 将scene传进去
    let objects = 0; // 场景模型对象
    let triangles = 0; // 模型面片

    for (let index = 0; index < view.children.length; index++) {
        let object = view.children[index];
        object.traverse(obj => {
            objects ++;
            if (obj instanceof THREE.Mesh || object instanceof THREE.Line) {
                let geometry = obj.geometry;
                if (geometry instanceof THREE.BufferGeometry) {
                    if (geometry.index && geometry.index.count) {
                        triangles += geometry.index.count
                    } else if (geometry.attributes.position) {
                        const pos = geometry.attributes.position
                        if (pos.count && pos.itemSize) {
                            triangles += Math.round(pos.count / pos.itemSize)
                        }
                    }
                }
            }
        });
    }
    console.log('模型对象数量: ' + objects, '模型面片数: ' + triangles);
}

function clickStartLoadBtn(){
    if (null == userInfoRef.value.selectCountry){
        selectCountryVisible.value = true
    }else{
        startViewVisible.value = false
    }

    setTimeout(() => {
        var video = document.getElementById("video");

        if (null != video){
            video.volume = 0
            video.muted = true
            video.play()
        }
    }, 25)


    // initValue()
}

onBeforeMount(() => {
    if (null != props.countrycode){
        userInfoRef.value.selectCountry = props.countrycode
    }

    if (null == userInfoRef.value.selectCountry && null != props.rid && null != props.did){
        userInfoRef.value.selectCountry = "HK"
    }

    if (null == userInfoRef.value.speed){
        userInfoRef.value.speed = 0.24
    }

    if (null == userInfoRef.value.vp){
        userInfoRef.value.vp = true
    }

})

onMounted(()=>{
    // setTimeout(() => {
    if (myUtil.isEmpty(props.islandID)){
        userInfoRef.value.islandID = null
    }else{
        userInfoRef.value.islandID = props.islandID
    }
    // }, 1000)

    insertViewRecord()
    const dateNow = new Date().getTime()
    userinfo.lastOnlineDate = dateNow

    // getShopList()
    initValue()
    // initPage()

    if (pageInfoRef.value.userFrom == 0){
        clickStartLoadBtn()
    }else if(myUtil.isNotEmpty(document.referrer) && document.referrer.indexOf(proxy.$EShopopeeUrl) != -1 ){
        clickStartLoadBtn()
    }
})

//清除three.js占用的内存
onBeforeUnmount(() => {
    timeStamp = -65535

    if (startViewVisible.value == true){
        return
    }

    //保存主角位置
    // savePersonPosition()

    //銷毀搖桿
    if (null != nippleObj){
        nippleObj.destroy()
    }

    console.log("开始清除内存")

    document.getElementById("three").removeEventListener('touchmove', handleDefaultTouchEvt)
    document.removeEventListener('keydown', onKeyDown)
    document.removeEventListener('keyup', onKeyUp)
    document.getElementById("three").removeEventListener('touchmove', mouseMoveEvent)
    document.getElementById("three").removeEventListener('touchstart', mouseDownEvent)
    document.getElementById("three").removeEventListener('touchend', mouseUpEvent)
    document.getElementById("three").removeEventListener('mousemove', mouseMoveEvent)
    document.getElementById("three").removeEventListener('mousedown', mouseDownEvent)
    document.getElementById("three").removeEventListener('mouseup', mouseUpEvent)
    document.getElementById("three").removeEventListener('click', mouseClickEvent)

    // stats.domElement.remove()

    try {
        funcListObj = {}

        cancelAnimationFrame(animationFrameId); // animationFrameId = requestAnimationFrame(this.render);
        render.dispose();
        render.forceContextLoss();
        render.content = null;
        let gl = render.domElement.getContext("webgl");
        if (gl && gl.getExtension("WEBGL_lose_context")) {
            gl.getExtension("WEBGL_lose_context").loseContext();
        }
        render = null;
        camera = null;
        scene.traverse((child) => {
            try {
                if (child.material && null != child.material) {
                    child.material.dispose();
                }
            }catch (e) {
                console.log(e)
            }

            try {
                if (child.geometry && null != child.geometry) {
                    child.geometry.dispose();
                }
            }catch (e) {
                console.log(e)
            }


            child = null;
        });
        scene = null;

        THREE.Cache.clear()
    } catch (e) {
        console.error('Failed to destroy threejs', e);
    }

    try{
        audioManager.stopAllAuio()
    }catch (e) {

    }

    //刪除render dom
    document.getElementById("three").innerHTML = ""
})

function goPersonChat(targetObj, name, msgList, callback){
    controlFlag = false
    bottomInteractionUiVisible.value = false
    upperRightUiVisible.value = false
    nippleViewVisible.value = false
    testBox.visible = false

    camera.far = 1500
    camera.updateProjectionMatrix()

    chatPersonName.value = name
    chatMsgText.value = msgList[0]
    chatVisible.value = true
    chatMsgIndex = 0
    chatMsgList = msgList
    chatClickFunc = callback

    chatTargetObject = targetObj
    saveCameraPosition()

    const vec3 = new THREE.Vector3()
    camera.getWorldPosition(vec3)
    chatTargetObject.worldToLocal(vec3)

    meshGroup.remove(camera)
    chatTargetObject.add(camera)
    // camera.position.set(0, 2, 5.5)
    // camera.position.set(0, 160, 300)
    camera.position.copy(vec3)

    camera.lookAt(new THREE.Vector3(0,1,0))
    camera.rotation.x = 0
    camera.rotation.y = 0
    camera.rotation.z = 0

    const tween_2 = new TWEEN.Tween(camera.position)
        // .to({x: 0, y: 1.60, z: 3.00}, 1000)
        .to({x: 0, y: 1.6, z: 3}, 1000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.Out)
        .onComplete(() => {
            delete animationObjGroup["camera_position_1"]
        })

    animationObjGroup["camera_position_1"] = tween_2

    if (null != WithAIObjSet[targetObj.parent.uuid]){
        WithAIObjSet[targetObj.parent.uuid].action = "deliver_card_wait"
    }

    // if (typeof callback === "function"){
    //     callback()
    // }else{
    //     closePersonChat()
    // }


}

function closePersonChat(){
    camera.far = 150
    camera.updateProjectionMatrix()

    testBox.visible = true

    chatPersonName.value = ""
    chatMsgText.value = ""
    chatMsgIndex = 0
    chatMsgList = []
    chatClickFunc = null

    if(null != chatTargetObject){
        chatTargetObject.remove(camera)
        meshGroup.add(camera)
        loadCameraPosition()

        if (null != WithAIObjSet[chatTargetObject.parent.uuid]){
            WithAIObjSet[chatTargetObject.parent.uuid].action = "chat_complete"
        }

        chatTargetObject = null
        // beforeCameraPosition = null
        // beforeCameraUp = null
        // beforeCameraRotation = null

        setTimeout(() => {
            chatVisible.value = false
        }, 25)


        controlFlag = true

        setTimeout(() => {
            bottomInteractionUiVisible.value = true
            upperRightUiVisible.value = true
            nippleViewVisible.value = true
        }, 250)
    }

}

function clickPersonChat(){
    // audioManager.playdownAudio()
    chatMsgIndex += 1

    if (chatMsgIndex < chatMsgList.length){
        chatMsgText.value = chatMsgList[chatMsgIndex]
    }else{
        if (typeof chatClickFunc === "function"){
            chatClickFunc()
            chatClickFunc = null
        }

        chatMsgText.value = ""
        chatPersonName.value = ""
        chatClickFunc = null
        chatMsgList = []
        chatMsgIndex = 0


        closePersonChat()
    }
}

function clickCardHref(tag = true) {
    proxy.$refs.shopopeePhone.goCardView(cardId, tag)
    audioManager.playdownAudio()
    setTimeout(() => {
        closePersonChat()
    }, 250)

    closeCardBox()

    setTimeout(() => {
        controlFlag = false
    }, 500)
}

function goCardHref() {
    clickCardHref(false)
}

function goCardRequest() {
    clickCardHref(true)
}

function showCardBox(src, href, id) {
    // cardHref = href
    currCardSrc.value = src
    cardId = id

    setTimeout(() => {
        cardVisible.value = true
    }, 250)
}

function closeCardBox() {
    // controlFlag = true

    setTimeout(() => {
        cardVisible.value = false
        // cardHref = null
        currCardSrc.value = null
        closePersonChat()
    }, 250)
}

// function goShopConfirm(index) {
//     const obj = shopObjList[index]
//
//     openConfirm(`要前往 ${obj.companyName} 的店鋪嗎？`, () => {
//         location.href = `${proxy.$SSL}://` + obj.addinfo7 + "/Web/W006/shop_list.asp?Companycode=" + obj.accCompanyCode
//     })
// }

function hintNotOpenStore(){
  openConfirm(`${i18n.tkey("land_store_not_opent")} `, () => {

  })
}

function goShopConfirm(regionIndex, doorIndex, tag) {
    const obj = regionMap.shopMap[regionIndex][doorIndex].data
    if (null != obj.shopMallId && (null == tag || tag !== "shop")){
        openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyName} ${i18n.tkey("lang_go_mall_confirm_2")}`, () => {
          if (!myUtil.isEmpty(obj.shopMallType)){
            proxy.$router.push({path: `/personal/${obj.shopMallId}`})
          }else{
            proxy.$router.push({path: `/hall/${obj.shopMallId}`})
          }
        })
    }else{
            seleteStor.value = obj
            companySelectorVisible.value = true


        // if (null == obj.companyHallId){
        //     openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyName} ${i18n.tkey("lang_go_eshopopee_shop_confrim_2")}`, () => {
        //         userInfoRef.value.fromEshopopee = true
        //
        //         const window2 = window.open("", "eshopopee")
        //
        //         setTimeout(() => {
        //             window2.location.href = myUtil.generateEShopopeeShopUrl(obj.accCompanyCode, obj.addinfo7)
        //         }, 1000)
        //     })
        // }else{
           /* openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyName} ${i18n.tkey("lang_go_shop_confirm_3")}`, () => {

                savePersonPosition()

                const url = myUtil.generateEshopopeeLoginAndJumpUrl(
                    "/three",
                    myUtil.isEmpty(userInfoRef.value.login) ? "" : userInfoRef.value.login,
                    myUtil.isEmpty(userInfoRef.value.password) ? "" : userInfoRef.value.password,
                    [obj.accCompanyCode]
                )

                myUtil.goURLNewWindow(url, "eshopopee")
                // proxy.$router.push({path: `/pe/${obj.companyHallId}`})
            })*/
        // }



    }

}

function goNextRegionConfirm() {
    openConfirm(i18n.tkey("lang_go_next_confirm"), () => {
        // loadingCarViewVisible.value = true
        goNextRegion(false)
    })
}

function openConfirm(text, func, func2){
    moveFlag = false
    speed = 0
    confirmVisible.value = true
    confirmFunc = func
    cancelFunc = func2
    controlFlag = false
    bottomInteractionUiVisible.value = false
    audioManager.playdownAudio()
    upperRightUiVisible.value = false
    nippleViewVisible.value = false
    setTimeout(() => {
        confirmText.value = text
    }, 1250)
}

function sureConfirm() {
    if (typeof confirmFunc === "function"){
        confirmFunc()
    }

    audioManager.playdownAudio()
    confirmVisible.value = false
    confirmText.value = ""
    confirmFunc = null
    cancelFunc = null
    bottomInteractionUiVisible.value = true
    upperRightUiVisible.value = true

    controlFlag = true

    setTimeout(() => {
        bottomInteractionUiVisible.value = true
        upperRightUiVisible.value = true
        nippleViewVisible.value = true
    }, 250)
}

function closeConfirm() {
    if (typeof cancelFunc === "function"){
        cancelFunc()
    }

    confirmVisible.value = false
    confirmText.value = ""
    confirmFunc = null
    cancelFunc = null
    bottomInteractionUiVisible.value = true
    upperRightUiVisible.value = true

    controlFlag = true

    audioManager.playdownAudio()
    setTimeout(() => {
        bottomInteractionUiVisible.value = true
        upperRightUiVisible.value = true
        nippleViewVisible.value = true
    }, 250)
}

function updateTween() {
    for( let i in animationObjGroup){
        animationObjGroup[i].update()
    }
}

function updateAIObj() {
    for( let i in WithAIObjSet){
        if (typeof WithAIObjSet[i].AI === "function"){
            WithAIObjSet[i].AI(WithAIObjSet[i])
        }
    }
}

function playStartAnimation_plane_1(object) {

    object.position.x = -40000
    object.position.y = 15000
    object.position.z = -1440
    object.rotation.x = 0
    object.rotation.y = Math.PI / 2
    object.rotation.z = 0

    object.position.z = -5440

    // controlFlag = false
    testBox.visible = false
    // camera.position.set(-48.2, 0, 14.84)
    // camera.position.set(0, 4, 0)

    camera.position.x = -48.2
    camera.position.y = 4
    // camera.position.z = 14.84

    camera.position.z = -25.16


    // camera.position.x = 58.2
    // camera.position.z = 4.84


    // camera.rotation.x = 0.45164123
    // camera.rotation.y = 1.42738089
    // camera.rotation.z = -0.44760193

    // camera.rotation.x = 1
    // camera.rotation.y = 1
    // camera.rotation.z = -0.9

    camera.rotation.x = 1.4
    camera.rotation.y = 1.15
    camera.rotation.z = -1.4

    //飛機滑行降落
    const tween = new TWEEN.Tween(object.position)
        .to({x: 20022}, 12000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.In)
        .easing(TWEEN.Easing.Sinusoidal.Out);

    animationObjGroup['Plane01_1'] = tween
    //飛機下降
    const tween2 = new TWEEN.Tween(object.position)
        .to({y: 0}, 6000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.Out);

    animationObjGroup['Plane01_2'] = tween2
    //鏡頭隨飛機移動
    const tween4 = new TWEEN.Tween(camera.position)
        // .delay(2000)
        // .onStart(() => {
        //     console.log(camera.position)
        // })
        .onStart(() => {
            // console.log(camera.position)
        })
        .to({x: 247, z: -72}, 12000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.In)
        .easing(TWEEN.Easing.Sinusoidal.Out);

    animationObjGroup['Plane01_4'] = tween4

    //鏡頭旋轉
    const tween6 = new TWEEN.Tween(camera.rotation)
        // .delay(2000)
        // .onStart(() => {
        //     console.log(camera)
        // })
        .to({x: 0, y:2.1,  z: 0}, 12000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.InOut)
        .onComplete(() => {
            if (regionMap.guideFlag){
                displayOrHideCarAnimation(0)
            }

            meshGroup.position.set(217.1, 5.3, -50)
            toggleActiveMotion("walk")
            testBox.visible = true
            const tween_w_1 = new TWEEN.Tween(meshGroup.position)
                .delay(2500)
                .to({x: 217.1, y:5.3,  z: -47.1}, 1000)
                .start()
                // .easing(TWEEN.Easing.Sinusoidal.InOut)
                .onComplete(() => {
                    const tween_w_2 = new TWEEN.Tween(meshGroup.position)
                        .to({x: 217.1, y:0,  z: -36}, 3000)
                        .start()
                        // .easing(TWEEN.Easing.Sinusoidal.InOut)
                        .onComplete(() => {
                            const tween_w_3 = new TWEEN.Tween(meshGroup.position)
                                .to({x: 217.1, y:0,  z: -18}, 7000)
                                .start()
                                .onComplete(() => {
                                    toggleActiveMotion("idle")

                                    if (!regionMap.guideFlag && !regionMap.fromInvite){
                                        cameraOptionObj.currCameraDistance = 33.74033194857454
                                        cameraOptionObj.currCameraDistance = camera.position.distanceTo(meshGroup.position)
                                        cameraOptionObj.changeCameraDistance = true
                                        cameraOptionObj.currCameraPositionY = camera.position.y
                                        cameraOptionObj.changeCameraPostionY = true
                                    }

                                    // rotationNum = camera.rotation.y
                                    rotationNum = 4.69
                                    scene.remove(camera)
                                    meshGroup.add(camera)
                                    // 将世界坐标转换为局部坐标
                                    meshGroup.worldToLocal(camera.position);

                                    //播放结束后允许用户操作
                                    // controlFlag = true
                                    // bottomInteractionUiVisible.value = true
                                    // upperRightUiVisible.value = true
                                    // nippleViewVisible.value = true
                                    // proxy.$refs.operationNipple.style.display = "block"

                                    upperRightUiVisibleForAnimation.value = false

                                    //闪光
                                    blinkEffectVisible.value = true

                                    setTimeout(() => {
                                        blinkEffectVisible.value = true
                                    }, 500)

                                    setTimeout(() => {
                                        blinkEffectVisible.value = true
                                    }, 850)

                                    setTimeout(() => {
                                        blinkEffectVisible.value = true
                                    }, 1400)

                                    setTimeout(() => {
                                        blinkEffectVisible.value = true
                                    }, 1900)

                                    //允許顯示廣告
                                    regionMap.airShipAdvVisible = true

                                    if (regionMap.guideFlag){
                                        regionMap.guideFlag = false

                                        setTimeout(() => {
                                            regionMap.reporterObj.visible = false

                                            try {
                                                disposeMesh(regionMap.reporterObj)
                                            }catch (e){
                                                console.log(e)
                                            }

                                            regionMap.reporterObj = null

                                        }, 2000)

                                        //暫停汽車動畫
                                        // playOrPauseCarAnimation(0)
                                        // displayOrHideCarAnimation(0)

                                        setTimeout(() => {
                                            const obj = regionMap.guideWithAIObj[0]

                                            if (null != obj.login && "" !== obj.login){
                                                goPersonChat(obj.model, obj.name, [`${i18n.tkey("lang_welcome_3d_msg_1")} ${obj.companyName}`], () => {
                                                    // openConfirm(`要前往 ${obj.companyName} 的店鋪嗎？`, () => {
                                                    setTimeout(() => {
                                                        goGuideShop(obj)
                                                    }, 260)

                                                    // playOrPauseCarAnimation(1)
                                                    displayOrHideCarAnimation(1)
                                                    // }, ()=> {
                                                    //     // removeGuideMan(obj)
                                                    moveGuideManPoint()
                                                    //     // playOrPauseCarAnimation(1)
                                                    //     displayOrHideCarAnimation(1)
                                                    // 	audioManager.playbgAudio()
                                                    // })
                                                })
                                            }else{
                                                // goPersonChat(obj.model, obj.name, [`${i18n.tkey("lang_welcome_3d_msg_2")}<br>${i18n.tkey("lang_welcome_3d_msg_3")}<br>${i18n.tkey("lang_welcome_3d_msg_4")}`], () => {
                                                    // removeGuideMan(obj)
                                                    // toggleSelectAreaBox(true)
                                                    moveGuideManPoint()
                                                    displayOrHideCarAnimation(1)
                                                    audioManager.playbgAudio()

                                                    if (userInfoRef.value.CameraPerspective === "3"){
                                                        meshGroup.visible = true
                                                        cameraOptionObj.defaultCameraDistance = cameraOptionObj.defaultThirdCameraDistance
                                                        cameraOptionObj.currCameraDistance = cameraOptionObj.defaultThirdCameraDistance
                                                    }else{
                                                        meshGroup.visible = false
                                                        cameraOptionObj.defaultCameraDistance = cameraOptionObj.defaultFirstCameraDistance
                                                        cameraOptionObj.currCameraDistance = cameraOptionObj.defaultFirstCameraDistance
                                                    }

                                                    controlFlag = true
                                                    bottomInteractionUiVisible.value = true
                                                    upperRightUiVisible.value = true
                                                    nippleViewVisible.value = true
                                                    proxy.$refs.operationNipple.style.display = "block"

                                                    savePersonPosition()

                                                    calcCameraPosition()

                                                    setTimeout(() => {
                                                        calcCameraPosition()
                                                    }, 250)
                                                // })
                                            }

                                        }, 1500)

                                    }else{
                                        controlFlag = true
                                    }

                                    camera.far = 150
                                    camera.updateProjectionMatrix()

                                    delete animationObjGroup['Plane01_1']
                                    delete animationObjGroup['Plane01_2']
                                    delete animationObjGroup['Plane01_4']

                                    delete animationObjGroup['Plane01_6']
                                    delete animationObjGroup['Plane01_7']
                                    delete animationObjGroup['Plane01_8']
                                    delete animationObjGroup['Plane01_9']
                                    delete animationObjGroup['Plane01_10']

                                    delete animationObjGroup['Plane02_1']
                                    delete animationObjGroup['Plane02_3']
                                    delete animationObjGroup['Plane02_3_1']

                                    delete animationObjGroup['Plane01_walk_1']
                                    delete animationObjGroup['Plane01_walk_2']
                                    delete animationObjGroup['Plane01_walk_3']

                                    delete animationObjGroup['Plane01_car_1']

                                })
                            // .easing(TWEEN.Easing.Sinusoidal.InOut)

                            animationObjGroup['Plane01_walk_3'] = tween_w_3
                        })

                    animationObjGroup['Plane01_walk_2'] = tween_w_2
                })

            animationObjGroup['Plane01_walk_1'] = tween_w_1
            //延遲2秒移動相機
            const tween7 = new TWEEN.Tween(camera.position)
                .delay(500)
                .to({x: 230, y:8,  z: -56}, 3000)
                .start()
                .easing(TWEEN.Easing.Sinusoidal.InOut)

            animationObjGroup['Plane01_7'] = tween7
            //延遲2秒旋轉相機
            const tween8 = new TWEEN.Tween(camera.rotation)
                // .delay(500)
                .to({y:2.1}, 3000)
                .start()
                .easing(TWEEN.Easing.Sinusoidal.InOut)
                .onComplete(() => {
                    // const tween9 = new TWEEN.Tween(camera.position)
                    //     // .delay(500)
                    //     // .to({x: 205.0789320785081, y:4,  z: 16.938353600532512}, 6000)
                    //     // .to({x: 195, y:5,  z: 5}, 8000)
                    //     .to({x: 216, y:3,  z: -25}, 10000)
                    //     .onComplete(() => {
                    //
                    //     })
                    //     .start()
                    //     .easing(TWEEN.Easing.Sinusoidal.InOut)
                    //
                    // animationObjGroup['Plane01_9'] = tween9
                    //
                    // const tween10 = new TWEEN.Tween(camera.rotation)
                    //     .delay(1000)
                    //     // .to({y:3.87}, 8000)
                    //     .to({y:3.2, x: 0}, 10000)
                    //     .start()
                    //     .easing(TWEEN.Easing.Sinusoidal.InOut)
                    //     .onComplete(() => {
                    //
                    //     })
                    //
                    // animationObjGroup['Plane01_10'] = tween10

                    camera.rotation.y = 3.13

                    camera.position.x = 217.1
                    camera.position.y = 7.7
                    camera.position.z = -53

                    const tween_c_1 = new TWEEN.Tween(camera.position)
                        .to({x: 217.1, y:7.7,  z: -51}, 1000)
                        .start()
                        .onStart(() => {

                        })
                        .easing(TWEEN.Easing.Sinusoidal.In)
                        .onComplete(() => {
                            const tween_c_2 = new TWEEN.Tween(camera.position)
                                .to({x: 217.1, y:2.5,  z: -38}, 3000)
                                .start()
                                // .easing(TWEEN.Easing.Sinusoidal.In)
                                .onComplete(() => {
                                    const tween_c_3 = new TWEEN.Tween(camera.position)
                                        .to({x: 217.1, y:2.5,  z: -15}, 6000)
                                        .start()
                                        // .easing(TWEEN.Easing.Sinusoidal.In)
                                        .onComplete(() => {

                                        })

                                    animationObjGroup['cameraC_3'] = tween_c_3
                                })

                            animationObjGroup['cameraC_2'] = tween_c_2

                        })

                    animationObjGroup['cameraC_1'] = tween_c_1

                    // let gui = new GUI()
                    // gui.add(camera.position, "x").step(1)
                    // gui.add(camera.position, "y").step(1)
                    // gui.add(camera.position, "z").step(1)
                    //
                    //
                    // let gui2 = new GUI()
                    // gui2.add(camera.rotation, "x").step(0.01)
                    // gui2.add(camera.rotation, "y").step(0.01)
                    // gui2.add(camera.rotation, "z").step(0.01)
                })

            animationObjGroup['Plane01_8'] = tween8
        })

    animationObjGroup['Plane01_6'] = tween6
}

// function playStartAnimation_plane_2(object) {

//     const tween = new TWEEN.Tween(object.position)
//         .to({x: -23000, y: 16000, z: 0}, 8025)
//         .start()
//         .onComplete(() => {
//             delete animationObjGroup['Plane02_1']

//             camera.rotation.x = 0
//             camera.rotation.y = 1.554859363304975
//             camera.rotation.z = 0
//             playStartAnimation_plane_1(object)
//         })
//     // .easing(TWEEN.Easing.Sinusoidal.Out);

//     animationObjGroup['Plane02_1'] = tween

//     const tween2 = new TWEEN.Tween(object.rotation)
//         .to({x: 0.5, y: 1.2, z: -0.5}, 8000)
//         .start()
//         .onComplete(() => {
//             console.log(object.rotation)
//             delete animationObjGroup['Plane02_2']
//         })

//     animationObjGroup['Plane02_2'] = tween2

//     const tween3 = new TWEEN.Tween(camera.position)
//         // .to({x: 2.7, y: -2.8, z: 2.8}, 2500)
//         // .delay(500)
//         .to({x: -460, y: 180, z: 1800}, 8000)
//         .start()
//         .onComplete(() => {
//             delete animationObjGroup['Plane02_3']
//         })
//         .easing(TWEEN.Easing.Sinusoidal.InOut);

//     animationObjGroup['Plane02_3'] = tween3

//     const tween4 = new TWEEN.Tween(camera.rotation)
//         .to({x: 0, y: 0, z: 0}, 1500)
//         .start()
//         .onComplete(() => {
//             delete animationObjGroup['Plane02_4']
//         })
//         .easing(TWEEN.Easing.Sinusoidal.Out);

//     animationObjGroup['Plane02_4'] = tween4

// }

function playStartAnimation_plane_2(object) {


    camera.position.x = -1840
    camera.position.y = 360
    camera.position.z = -45

    camera.rotation.x = -0.7
    camera.rotation.y = -2.26
    camera.rotation.z = -0.8



    object.position.x = -184000
    object.position.y = 35600
    object.position.z = 0

    object.rotation.x = 0
    object.rotation.y = 1.5
    object.rotation.z = 0

    const tween = new TWEEN.Tween(object.position)
        .to({x: -130000, y: 35400, z: -30}, 2500)
        .start()
        .onComplete(() => {
            camera.rotation.x = 0
            camera.rotation.y = 1.554859363304975
            camera.rotation.z = 0
            playStartAnimation_plane_1(object)
        })

    animationObjGroup['Plane02_1'] = tween

    const tween3 = new TWEEN.Tween(camera.rotation)
        .delay(25)
        // .to({x: 2.7, y: -2.8, z: 2.8}, 2500)
        .to({x: 0, y: -1.5, z: 0}, 2000)
        .onComplete(() => {
        })
        .start()
        .easing(TWEEN.Easing.Sinusoidal.InOut);

    animationObjGroup['Plane02_3'] = tween3


    const tween31 = new TWEEN.Tween(camera.position)
        .to({z: 0}, 2500)
        .start()

    animationObjGroup['Plane02_3_1'] = tween31



}
function playStartCarAnimation_1(object) {

    const orgPositionZ = object.position.z
    object.position.z = -3000

    const tween1 = new TWEEN.Tween(object.position)
        .delay(10500)
        .to({z: orgPositionZ}, 3000)
        .start()
        .onStart(() => {
            object.visible = true
        })
        .easing(TWEEN.Easing.Sinusoidal.InOut)

    animationObjGroup['Plane01_car_1'] = tween1
}

// function playStartCarAnimation_1(object) {

//     const orgPositionZ = object.position.z
//     object.position.z = 4000

//     const tween1 = new TWEEN.Tween(object.position)
//         .delay(15500)
//         .to({z: orgPositionZ}, 8000)
//         .start()
//         .onStart(() => {
//             object.visible = true
//         })
//         .easing(TWEEN.Easing.Sinusoidal.InOut)

//     animationObjGroup['Plane01_car_1'] = tween1
// }

function showTitleView(object) {
    controlFlag = false
    meshGroup.remove(camera)
    scene.add(camera)

    camera.position.x = -720
    camera.position.y = 685
    camera.position.z = 70

    // camera.rotation.x = 0.3
    camera.rotation.x = 0.5
    camera.rotation.y = 0
    camera.rotation.z = 0

    // object.position.x = -78000
    // object.position.y = 72500
    // object.position.z = 0
    // object.rotation.x = 0.5
    // object.rotation.y = Math.PI / 2
    // object.rotation.z = -0.5


    object.position.x = -86000
    object.position.y = 58200
    object.position.z = 50000
    object.rotation.x = 0
    object.rotation.y = 2.7
    object.rotation.z = 0

    funcListObj["titileViewRotate"] = () => {
        camera.rotation.y -= 0.0001
        camera.rotation.z += 0.00005
        if (camera.rotation.y < -0.42){
            delete funcListObj["titileViewRotate"]
        }
    }
}

function clickTitleStart() {
    if (loadingPercent.value < 100)
        return

    delete funcListObj["titileViewRotate"]


    //       camera.position.x = -900
    //       camera.position.y = 600
    //       camera.position.z = 400

    // camera.rotation.x = 2.2
    // camera.rotation.y = -2.1
    // camera.rotation.z = 2.2



    titleViewVisible.value = false
    //正式模式
    // const tween3 = new TWEEN.Tween(camera.rotation)
    //     .to({x: 0.3}, 1000)
    //     .start()
    //     .onComplete(() => {
    //         delete animationObjGroup['clickTitleTween']

    //         playStartAnimation_plane_2(startObj)
    //         playStartCarAnimation_1(startObj2)


    //         var video = document.getElementById("video");
    //         video.play()
    //     })
    //     .easing(TWEEN.Easing.Sinusoidal.In);

    // animationObjGroup['clickTitleTween'] = tween3



    // const tween3 = new TWEEN.Tween(camera.rotation)
    //           .to({x: -0.2}, 1000)
    //           .start()
    //           .onComplete(() => {
    //               delete animationObjGroup['clickTitleTween']

    //       //         playStartAnimation_plane_2(startObj)
    //       //         playStartCarAnimation_1(startObj2)


    //       //         var video = document.getElementById("video");
    //       //         video.play()
    //           })
    //           .easing(TWEEN.Easing.Sinusoidal.In);

    //       animationObjGroup['clickTitleTween'] = tween3

    // const tween31 = new TWEEN.Tween(camera.position)
    //     .to({y: 260}, 1000)
    //     .start()
    //     .onComplete(() => {
    //         delete animationObjGroup['clickTitleTween1']
    //     })
    //     .easing(TWEEN.Easing.Sinusoidal.In);

    // animationObjGroup['clickTitleTween1'] = tween31

    // var video = document.getElementById("video");
    //
    // if (null != video){
    //     video.volume = 0
    //     video.muted = true
    //     video.play()
    // }

    if (userInfoRef.value.CameraPerspective === "3"){
        meshGroup.visible = true
        cameraOptionObj.defaultCameraDistance = cameraOptionObj.defaultThirdCameraDistance
        cameraOptionObj.currCameraDistance = cameraOptionObj.defaultThirdCameraDistance
    }else{
        meshGroup.visible = false
        cameraOptionObj.defaultCameraDistance = cameraOptionObj.defaultFirstCameraDistance
        cameraOptionObj.currCameraDistance = cameraOptionObj.defaultFirstCameraDistance
    }


    if ((null == userInfoRef.value.positionX || null == userInfoRef.value.positionZ) && pageInfoRef.value.showWelcomeAnimation){
        // if (null == userInfoRef.value.positionX || null == userInfoRef.value.positionZ || (null != did && null != rid && firstInvFlag)){
        savePersonPosition(217, -5)

        meshGroup.visible = false

        audioManager.playdownAudio()
        audioManager.playflyAudio()
        upperRightUiVisibleForAnimation.value = true

        //显示记者
        regionMap.reporterObj.visble = true
        playStartCarAnimation_1(startObj2)
        playStartAnimation_plane_2(startObj)
        moveGuideManPoint()


        // setTimeout(() => {
        //     let video = document.getElementById("video");
        //     video.play()
        // }, 250)
    }else{
        //移除记者
        removeWelcomeReporter()

        startInitValue()

        if (null != rid && null != did){
            // if (null != rid && null != did && !firstInvFlag){
            movePersonToShopPosition(did)
        }

    }

    pageInfoRef.value.showWelcomeAnimation = false



    // testBox.visible = true
    // toggleActiveMotion("idle")
    // rotationNum = camera.rotation.y
    // scene.remove(camera)
    // meshGroup.add(camera)
    // // 将世界坐标转换为局部坐标
    // meshGroup.worldToLocal(camera.position);
    //
    // controlFlag = true



//測試模式
//         toggleActiveMotion("idle")
//         rotationNum = camera.rotation.y
//         scene.remove(camera)
//         meshGroup.add(camera)
//         // 将世界坐标转换为局部坐标
//         meshGroup.worldToLocal(camera.position);
//
//         controlFlag = true
//         bottomInteractionUiVisible.value = true
//         moveGuideManPoint()
//
//         var video = document.getElementById("video");
//         video.play()
}

//处理店员的帧动画
function createShopManAnimation(withAIObj){
    if (withAIObj.targetPositionList.length == 0){
        return
    }

    let duration
    if (withAIObj.nextTargetPosition == null){
        let randomNum = Math.floor(Math.random() * (withAIObj.targetPositionList.length))

        if (randomNum == withAIObj.targetIndex){
            randomNum = withAIObj.targetIndex + 1

            if (randomNum >= withAIObj.targetPositionList.length){
                randomNum = 0
            }
        }

        withAIObj.nextTargetPosition = withAIObj.targetPositionList[randomNum]
        withAIObj.targetIndex = randomNum

        duration = withAIObj.group.position.distanceTo(withAIObj.nextTargetPosition)
        duration = duration / 2 * 1000
    }

    let randomNum = 1000 + Math.floor(Math.random() * 2500)

    // setTimeout(() => {
    const tween = new TWEEN.Tween(withAIObj.group.position)
        .delay(randomNum)
        .to({x: withAIObj.nextTargetPosition.x, z: withAIObj.nextTargetPosition.z}, duration)
        .start()
        .onStart(() => {
            withAIObj.model.lookAt(withAIObj.nextTargetPosition)
            toggleActiveMotionObj(withAIObj, "walk")
        })
        // .easing(TWEEN.Easing.Sinusoidal.In)
        .onComplete(() => {
            delete animationObjGroup[withAIObj.group.uuid]
            withAIObj.previousTargetPosition = withAIObj.nextTargetPosition
            withAIObj.nextTargetPosition = null

            toggleActiveMotionObj(withAIObj, "idle")

            createShopManAnimation(withAIObj)
        })

    animationObjGroup[withAIObj.group.uuid] = tween
    // }, randomNum)
}

//店员的ai
function ShopmanAI(withAIObj) {
    const distance = meshGroup.position.distanceTo(withAIObj.group.position)
    withAIObj.timer_1 += mixerUpdateDelta

    if (distance < 10 ){

        if (null != animationObjGroup[withAIObj.group.uuid]){
            animationObjGroup[withAIObj.group.uuid].pause()
        }

        if (withAIObj.action === 'idle' || withAIObj.action === 'walk_normal'){
            if (withAIObj.action !== 'waving'){
                withAIObj.action = 'waving'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "waving")
            }
        }else if(withAIObj.action === 'waving'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if (withAIObj.action === 'idle_wait'){
            if (withAIObj.timer_1 > 6){
                withAIObj.action = 'waving'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "waving")
            }
        }else if(withAIObj.action === 'deliver_card_wait'){
            withAIObj.action = 'deliver_card'
            withAIObj.timer_1 = 0
            toggleActiveMotionObj(withAIObj, "talk2")
        }else if(withAIObj.action === 'deliver_card'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'chat_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if(withAIObj.action === 'chat_wait'){
            if (withAIObj.timer_1 > 4){
                withAIObj.action = 'chatting'
                withAIObj.timer_1 = 0

                const randomNum = Math.random()

                if (randomNum < 0.5){
                    toggleActiveMotionObj(withAIObj, "talk")
                }else{
                    toggleActiveMotionObj(withAIObj, "clapping")
                }

            }
        }else if(withAIObj.action === 'chatting'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'chat_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if(withAIObj.action === 'chat_complete'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }


        withAIObj.model.lookAt(meshGroup.position)
    }else{
        if (withAIObj.action === 'waving'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }

        if (withAIObj.action === 'idle_wait'){
            if (withAIObj.timer_1 > 1.5){

                withAIObj.action = 'walk_normal'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "walk")

                if (null != animationObjGroup[withAIObj.group.uuid]){

                    if (animationObjGroup[withAIObj.group.uuid]._isPaused){
                        animationObjGroup[withAIObj.group.uuid].resume()

                        withAIObj.model.lookAt(withAIObj.nextTargetPosition)
                    }

                }
            }
        }
    }

}

//普通行驶车辆的AI
function normalCarAI(withAIObj){
    if (withAIObj.action === "driving_init"){
        withAIObj.action = "driving"
        // withAIObj.group.lookAt(withAIObj.nextTargetPosition)
        const distance = withAIObj.group.position.distanceTo(withAIObj.nextTargetPosition)
        const timeNum = distance / 0.012
        const randomStartTime = Math.floor(Math.random() * 3000)

        const tween = new TWEEN.Tween(withAIObj.group.position)
            .delay(randomStartTime)
            .to({x: withAIObj.nextTargetPosition.x, y: withAIObj.nextTargetPosition.y, z: withAIObj.nextTargetPosition.z}, timeNum)
            .start()
            .onStart(() => {
                withAIObj.group.lookAt(withAIObj.nextTargetPosition)
            })
            .onComplete(() => {
                delete animationObjGroup[withAIObj.group.uuid]
                withAIObj.previousTargetPosition = withAIObj.nextTargetPosition
                withAIObj.nextTargetPosition = null
                withAIObj.action = "driving_complete"

                withAIObj.targetIndex += 1

                if (withAIObj.targetIndex >= withAIObj.targetPositionList.length){
                    withAIObj.targetIndex = 1
                }

                withAIObj.nextTargetPosition = withAIObj.targetPositionList[withAIObj.targetIndex]
                withAIObj.group.lookAt(withAIObj.nextTargetPosition)

            })

        animationObjGroup[withAIObj.group.uuid] = tween
    }else if(withAIObj.action === "driving_complete"){
        withAIObj.action = "driving"

        // withAIObj.group.lookAt(withAIObj.nextTargetPosition)
        const distance = withAIObj.group.position.distanceTo(withAIObj.nextTargetPosition)
        const timeNum = distance / 0.012
        // const randomStartTime = Math.floor(Math.random() * 3000)

        const tween = new TWEEN.Tween(withAIObj.group.position)
            // .delay(randomStartTime)
            .to({x: withAIObj.nextTargetPosition.x, y: withAIObj.nextTargetPosition.y, z: withAIObj.nextTargetPosition.z}, timeNum)
            .start()
            .onStart(() => {
                withAIObj.group.lookAt(withAIObj.nextTargetPosition)
            })
            // .onUpdate(() => {
            //     withAIObj.group.lookAt(withAIObj.nextTargetPosition)
            // })
            // .onUpdate(() => {
            //     // const vec3 = new THREE.Vector3()
            //     // withAIObj.nextTargetPosition.localToWorld(vec3)
            //     // withAIObj.group.lookAt(vec3)
            //     withAIObj.group.lookAt(withAIObj.nextTargetPosition)
            // })
            // .easing(TWEEN.Easing.Sinusoidal.In)
            .onComplete(() => {
                delete animationObjGroup[withAIObj.group.uuid]
                withAIObj.previousTargetPosition = withAIObj.nextTargetPosition
                withAIObj.nextTargetPosition = null
                withAIObj.action = "driving_complete"

                withAIObj.targetIndex += 1

                if (withAIObj.targetIndex >= withAIObj.targetPositionList.length){
                    withAIObj.targetIndex = 1
                }

                withAIObj.nextTargetPosition = withAIObj.targetPositionList[withAIObj.targetIndex]
                withAIObj.group.lookAt(withAIObj.nextTargetPosition)

            })

        animationObjGroup[withAIObj.group.uuid] = tween

    }

}

//观光的士的AI
function SightseeingTaxiAI(withAIObj){
    if (withAIObj.action === "driving_init"){
        withAIObj.action = "driving"
        // withAIObj.group.lookAt(withAIObj.nextTargetPosition)
        const distance = withAIObj.group.position.distanceTo(withAIObj.nextTargetPosition)
        const timeNum = distance / 0.024
        // const randomStartTime = Math.floor(Math.random() * 3000)

        const tween = new TWEEN.Tween(withAIObj.group.position)
            // .delay(randomStartTime)
            .to({x: withAIObj.nextTargetPosition.x, y: withAIObj.nextTargetPosition.y, z: withAIObj.nextTargetPosition.z}, timeNum)
            .start()
            .onStart(() => {
                withAIObj.group.lookAt(withAIObj.nextTargetPosition)
            })
            .onComplete(() => {
                delete animationObjGroup[withAIObj.group.uuid]
                withAIObj.previousTargetPosition = withAIObj.nextTargetPosition
                withAIObj.nextTargetPosition = null
                withAIObj.action = "driving_complete"

                withAIObj.targetIndex += 1

                if (withAIObj.targetIndex >= withAIObj.targetPositionList.length){
                    withAIObj.targetIndex = 2
                }

                withAIObj.nextTargetPosition = withAIObj.targetPositionList[withAIObj.targetIndex]
                withAIObj.group.lookAt(withAIObj.nextTargetPosition)

            })

        animationObjGroup[withAIObj.group.uuid] = tween

        withAIObj.wheelList.forEach((v, i) => {
            if (v > Math.PI * 2){
                v.rotation.x = 0
            }

            v.rotation.x += 0.1
        })
    }else if(withAIObj.action === "driving_complete"){
        withAIObj.action = "driving"

        const distance = withAIObj.group.position.distanceTo(withAIObj.nextTargetPosition)
        const timeNum = distance / 0.024

        const tween = new TWEEN.Tween(withAIObj.group.position)
            .to({x: withAIObj.nextTargetPosition.x, y: withAIObj.nextTargetPosition.y, z: withAIObj.nextTargetPosition.z}, timeNum)
            .start()
            .onStart(() => {
                withAIObj.group.lookAt(withAIObj.nextTargetPosition)
            })
            .onComplete(() => {
                delete animationObjGroup[withAIObj.group.uuid]
                withAIObj.previousTargetPosition = withAIObj.nextTargetPosition
                withAIObj.nextTargetPosition = null
                withAIObj.action = "driving_complete"

                withAIObj.targetIndex += 1

                if (withAIObj.targetIndex >= withAIObj.targetPositionList.length){
                    if (withAIObj.currPathKey == "SightseePath"){
                        withAIObj.currPathKey = "normalPath"
                        withAIObj.targetPositionList = withAIObj.normalPath
                        withAIObj.targetIndex = 1
                        withAIObj.nextTargetPosition = withAIObj.targetPositionList[2]
                        withAIObj.cycleCount = 0
                    }else{
                        withAIObj.currPathKey = "SightseePath"
                        withAIObj.targetPositionList = withAIObj.SightseePath

                        withAIObj.targetIndex = 300
                        withAIObj.nextTargetPosition = withAIObj.targetPositionList[301]
                        withAIObj.cycleCount += 1
                    }

                }

                // if (withAIObj.cycleCount > 1 && withAIObj.targetIndex > 1900){
                //     withAIObj.currPathKey = "SightseePath"
                //     withAIObj.targetPositionList = withAIObj.SightseePath
                //     withAIObj.targetIndex = 149
                //     withAIObj.nextTargetPosition = withAIObj.targetPositionList[150]
                //     withAIObj.cycleCount = 0
                // }

                withAIObj.nextTargetPosition = withAIObj.targetPositionList[withAIObj.targetIndex]
                withAIObj.group.lookAt(withAIObj.nextTargetPosition)

                if (withAIObj.targetIndex > 1 && withAIObj.withPerson === true){
                    let startVec = new THREE.Vector2(withAIObj.targetPositionList[withAIObj.targetIndex - 2].x, withAIObj.targetPositionList[withAIObj.targetIndex - 2].z)
                    let endVec = new THREE.Vector2(withAIObj.targetPositionList[withAIObj.targetIndex - 1].x, withAIObj.targetPositionList[withAIObj.targetIndex - 1].z)
                    const vec1 = new THREE.Vector2()
                    vec1.subVectors(endVec, startVec)
                    // vec1.normalize()

                    startVec = new THREE.Vector2(withAIObj.targetPositionList[withAIObj.targetIndex - 1].x, withAIObj.targetPositionList[withAIObj.targetIndex - 1].z)
                    endVec = new THREE.Vector2(withAIObj.nextTargetPosition.x, withAIObj.nextTargetPosition.z)

                    const vec2 = new THREE.Vector2()
                    vec2.subVectors(endVec, startVec)
                    // vec2.normalize()

                    const angleNum = vec1.dot(vec2) / ((Math.sqrt(Math.pow(vec1.x, 2) + Math.pow(vec1.y, 2))) * (Math.sqrt(Math.pow(vec2.x, 2) + Math.pow(vec2.y, 2))))
                    const crossNum = vec1.cross(vec2)

                    if (crossNum != 0){
                        // if (crossNum < 0){
                        //     rotationNum += Math.acos(angleNum) * 180 / -Math.PI
                        // }else{
                        //     rotationNum += Math.acos(angleNum) * 180 / Math.PI
                        // }

                        if (crossNum < 0){
                            rotationNum += Math.acos(angleNum) * -1
                        }else{
                            rotationNum += Math.acos(angleNum)
                        }

                        calcCameraPosition()
                    }

                }

            })

        animationObjGroup[withAIObj.group.uuid] = tween

        withAIObj.wheelList.forEach((v, i) => {
            if (v > Math.PI * 2){
                v.rotation.x = 0
            }

            v.rotation.x += 0.1
        })

    }else if(withAIObj.action === "stop"){
        delete animationObjGroup[withAIObj.group.uuid]
    }else if(withAIObj.action === "wait"){

    }else if(withAIObj.action === "ride_init"){
        meshGroup.position.x = withAIObj.group.position.x
        meshGroup.position.z = withAIObj.group.position.z
        moveFlag = false
        moveVector3.x = 0
        moveVector3.z = 0
        numVector3.x = 0
        numVector3.z = 0
        cameraOptionObj.currCameraPositionY = 1.8
        cameraOptionObj.currCameraLookAtPositionY = 1.8
        calcCameraPosition()
        withAIObj.action = "driving_init"
        withAIObj.model.rotation.y = 0

        interactionObj[withAIObj.group.uuid] = [
            {
                distance: 8,
                icon: "fa-solid fa-ban",
                name: i18n.tkey("lang_stop_car"),
                mesh: withAIObj.group,
                displayFlag: () => {
                    return withAIObj.action !== "stop"
                },
                callback: () => {
                    delete animationObjGroup[withAIObj.group.uuid]
                    bottomUIObj.value = {}
                    withAIObj.action = "stop"
                }
            },
            {
                distance: 8,
                icon: "fa-solid fa-arrow-up",
                name: i18n.tkey("lang_forward_text"),
                mesh: withAIObj.group,
                displayFlag: () => {
                    return withAIObj.action === "stop"
                },
                callback: () => {
                    bottomUIObj.value = {}
                    withAIObj.action = "driving_init"
                }
            },
            {
                distance: 8,
                icon: "fa-solid fa-taxi",
                name: i18n.tkey("lang_get_down"),
                mesh: withAIObj.group,
                callback: () => {
                    bottomUIObj.value = {}
                    cameraOptionObj.currCameraPositionY = cameraOptionObj.defalutCameraPositionY
                    cameraOptionObj.currCameraLookAtPositionY = cameraOptionObj.defaultCameraLookAtPositionY
                    withAIObj.withPerson = false
                    withAIObj.action = "wait"
                    delete animationObjGroup[withAIObj.group.uuid]
                    calcCameraPosition()

                    interactionObj[withAIObj.group.uuid] = [
                        {
                            distance: 8,
                            icon: "fa-solid fa-taxi",
                            name: i18n.tkey("lang_ride"),
                            mesh: withAIObj.group,
                            callback: () => {
                                // bottomUIObj.value = {}
                                // withAIObj.withPerson = true
                                // withAIObj.action = "ride_init"
                                goTaxi()
                            }
                        },
                    ]
                }
            },
        ]
        bottomUIObj.value = {}

    }

    if (withAIObj.action !== "wait" && withAIObj.withPerson){
        carWithAIObjList.forEach((v, i) => {
            const distance = v.group.position.distanceTo(withAIObj.group.position)

            if (distance > 10){
                v.group.visible = true
            }else{
                v.group.visible = false
            }
        })

        const personY = meshGroup.position.y
        const cameraY = camera.position.y
        meshGroup.position.x = withAIObj.group.position.x
        meshGroup.position.z = withAIObj.group.position.z

        const vec3 = new THREE.Vector3()
        withAIObj.group.getWorldDirection(vec3)


        moveFlag = false
        moveVector3.x = 0
        moveVector3.z = 0
        numVector3.x = 0
        numVector3.z = 0
        meshGroup.translateOnAxis(vec3, -0.9);
        meshGroup.position.y = personY
        camera.position.y = cameraY

        cameraOptionObj.currCameraPositionY = 1.8
        cameraOptionObj.currCameraLookAtPositionY = 1.8
        // cameraOptionObj.changeCameraPostionY = true

    }

}


function createRoadPadMaterial(text, rotation){
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d')
    canvas.width = 120
    canvas.height = 60
    //制作矩形
    ctx.fillStyle = "red";
    ctx.fillRect(0, 0, 120, 60)
    //设置文字
    ctx.fillStyle = "white";
    ctx.font = 'normal 30px "楷体"'
    ctx.fillText(text, 30, 40)

    //生成图片
    let url = canvas.toDataURL('image/png');
    //删除dom
    canvas.remove()
    //将图片构建到纹理中
    return new THREE.MeshLambertMaterial({
        map: texLoader.load(url),
        // side: THREE.DoubleSide,
        // opacity: 1,
    })
}

function createShopmanNamePad(shopmanList) {
    // Promise.all([
    //     loadImage(process.env.BASE_URL + "mytextures/name_pad.png")
    // ]).then((images) => {
    //判断是否是中文的正则表达式
    var reg = new RegExp("^[\u4e00-\u9fa5]{0,}$");

    shopmanList.forEach((v, i) => {
        // if(null == v.name || "" === v.name){
        //     return
        // }
        //
        // //创建名牌
        // const text = v.name
        // let text2 = ""
        // text2 = text
        //
        // // for (let n=0; n<text.length; n++){
        // //     let charText = text.charAt(n)
        // //
        // //     if (reg.test(charText)){
        // //         text2 += charText
        // //     }else{
        // //         text2 += `${charText} `
        // //     }
        // // }
        //
        // let fontsize = 110 / text.length
        // let xLeft
        //
        // if (fontsize > 50){
        //     fontsize = 50
        // }
        //
        // // xLeft = 5 + (110 - fontsize * text.length) / 2
        //
        // let canvas = document.createElement("canvas");
        // let ctx = canvas.getContext('2d')
        //
        // canvas.width = 120
        // canvas.height = 60
        // //制作矩形
        // // ctx.fillStyle = "transparent";
        // // ctx.fillRect(0, 0, 120, 60)
        // ctx.drawImage(images[0], 0, 0, 120, 60)
        // //设置文字
        // ctx.fillStyle = "white";
        // ctx.font = `normal ${fontsize}px "楷体"`
        // var textWidth = ctx.measureText(text2).width;
        // xLeft = 5 + (110 - textWidth) / 2
        // ctx.fillText(text2, xLeft, (45 + fontsize) / 2)
        //
        // //生成图片
        // let url = canvas.toDataURL('image/png');
        // //将图片构建到纹理中
        // const material = new THREE.SpriteMaterial({
        //     map: texLoader.load(url),
        //     // side: THREE.DoubleSide,
        //     opacity: 1,
        //     transparent: true
        // })
        //
        // const sprite = new THREE.Sprite(material)
        // sprite.position.y = 3.5
        //
        // sprite.scale.x = 1.5
        // sprite.scale.y = 0.75
        //
        // sprite.name = "shopman_name_sprite"
        //
        // v.model.parent.add(sprite)
        // canvas.remove()


        //创建类别牌
        // v.whatsshopsbcataList.forEach((obj, index) => {
        //     const langhk = obj.langhk
        //     const canvasWidth = langhk.length * 20
        //
        //     let canvas2 = document.createElement("canvas");
        //     let ctx2 = canvas2.getContext('2d')
        //     canvas2.width = canvasWidth
        //     canvas2.height = canvasWidth
        //     //制作矩形
        //     ctx2.fillStyle = "transparent";
        //     // ctx.fillStyle = "#fefefe";
        //     ctx2.fillRect(0, 0, canvasWidth, canvasWidth)
        //     //设置文字
        //     ctx2.fillStyle = "red";
        //     ctx2.font = `normal 20px "楷体"`
        //     ctx2.fillText(langhk, 0, canvasWidth / 2)
        //
        //     //生成图片
        //     let url2 = canvas2.toDataURL('image/png');
        //     //将图片构建到纹理中
        //     const material2 = new THREE.SpriteMaterial({
        //         map: texLoader.load(url2),
        //         // side: THREE.DoubleSide,
        //         opacity: 1,
        //         transparent: true
        //     })
        //
        //     const sprite2 = new THREE.Sprite(material2)
        //
        //     sprite2.position.y = 4 + index * 0.5
        //     sprite2.scale.multiply(new THREE.Vector3(1.5, 1.5, 1.5))
        //     sprite2.name = `shopman_type_sprite_${index}`
        //
        //     v.model.parent.add(sprite2)
        //     canvas2.remove()
        // })

        if (regionMap.guideFlag && v.rid === rid && v.did == did){
            // createGuideShopman(v)
            createGuideContent(v)
        }
        // })

    })

    loadingPercent.value += 5
}

function loadImage(url) {
    return new Promise((resolve)=>{
        const img = new Image();
        img.onload = ()=>resolve(img);
        img.src = url;
        img.remove()
    })
}

function checkInteractionObj() {
    for (let key in interactionObj){
        const objList = interactionObj[key]

        objList.forEach((obj, i) => {
            if (null != obj.mesh && null != obj.name){
                if (null != obj.distance){
                    const objuuid = obj.mesh.uuid + i
                    const vec3 = new THREE.Vector3()
                    obj.mesh.getWorldPosition(vec3)
                    const distance = meshGroup.position.distanceTo(vec3)

                    if (distance <= obj.distance && !(objuuid in bottomUIObj.value)){
                        if (null !== obj.trigger){
                            obj.trigger = true

                            if (null != obj.triggerCallback && typeof obj.triggerCallback === "function"){
                                obj.triggerCallback()
                            }
                        }

                        if (null == obj.UIFlag || true === obj.UIFlag){
                            let flag = true

                            if (null != obj.displayFlag){
                                if (typeof obj.displayFlag === "function"){
                                    flag = obj.displayFlag()
                                }else{
                                    flag = obj.displayFlag
                                }
                            }

                            if (flag){
                                bottomUIObj.value[objuuid] = {
                                    icon: obj.icon,
                                    text: obj.name,
                                    description: obj.description,
                                    callback: () => {
                                        audioManager.playdownAudio()
                                        obj.callback()
                                    }
                                }
                            }

                        }

                    }

                    if(distance > obj.distance && (objuuid in bottomUIObj.value)){
                        if (objuuid in bottomUIObj.value){
                            delete bottomUIObj.value[objuuid]
                        }

                        if (null !== obj.trigger && true === obj.trigger){
                            obj.trigger = false

                            if (null != obj.leaveCallback && typeof obj.leaveCallback === "function"){
                                obj.leaveCallback()
                            }
                        }
                    }
                }

            }
        })

    }
}

function getEmptyWithAIObj() {
    const withAIObj = {
        group: null,
        model: null,
        allActions: null,
        activeAction: null,
        previousAction: null,
        nextTargetPosition: null,    //Vector3
        previousTargetPosition: null,
        targetPositionList: [],
        AI: null,
        action: null,
        name: "",
        memMale: 0,
        targetIndex: 0,
        timer_1: 0,
        timer_2: 0
    }

    return withAIObj
}

function openNewChat(login) {
    if (userInfoRef.value.login === login){
        openConfirm(i18n.tkey("lang_not_chat_self"))
    }else {
        proxy.$refs.shopopeePhone.openPersonChat(login)

        // audioManager.playdownAudio()
        setTimeout(() => {
            controlFlag = false
        }, 500)
    }
}

function phoneCommandCallback(functionName, status, data){
    // if (functionName === "openPersonChat" || functionName === "goCardView"){
    shopopeeChatVisible.value = true
    bottomInteractionUiVisible.value = false
    upperRightUiVisible.value = false
    nippleViewVisible.value = false
    controlFlag = false
    setTimeout(() => {
        shopopeeChatStatus.value = "show"
    }, 25)
    // }
}

function hideShopopeeChatBox() {
    if (shopopeeChatStatus.value === "hide"){
        return
    }
    audioManager.playdownAudio()
    shopopeeChatStatus.value = "hide"

    // setTimeout(() => {
    shopopeeChatVisible.value = false
    bottomInteractionUiVisible.value = true
    upperRightUiVisible.value = true
    nippleViewVisible.value = true
    controlFlag = true
    // }, 1450)
}

//生成区号材质
function createRegionNumMaterial(num = regionMap.currPage) {
    //用canvas生成图片
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d')
    canvas.width = 60
    canvas.height = 60
    //制作矩形
    ctx.fillStyle = "transparent";
    ctx.fillRect(0, 0, 60, 60)
    //设置文字
    ctx.fillStyle = "white";
    ctx.font = 'normal 50px "楷体"'
    ctx.fillText(num, 5, 50)

    //生成图片
    let url = canvas.toDataURL('image/png');
    const map = texLoader.load(url)
    map.center.set(0.5, 0.5)
    map.rotation = -90 * Math.PI / 180

    canvas.remove()

    //将图片构建到纹理中
    let material1 = new THREE.MeshBasicMaterial({
        map: map,
        // side: THREE.DoubleSide,
        opacity: 1,
        transparent: true
    })

    return material1
}

//生成门牌号材质
function createShopNumMaterial(object, num) {
    Promise.all([
        loadImage(process.env.BASE_URL + "mytextures/shop_num_pad.png")
    ]).then((images) => {
        //用canvas生成图片
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d')

        canvas.width = 60
        canvas.height = 40
        //制作矩形
        ctx.drawImage(images[0], 0, 0, 60, 40)
        //设置文字
        ctx.fillStyle = "red";
        ctx.font = 'normal 23px "楷体"'

        if(myUtil.isNotEmpty(userInfoRef.value.areacode)){
            let wa = Math.ceil((num) / 40)
            let shomlenght =  0

            if(Object.keys(regionMap.shopMap).length > 0){
                shomlenght = Object.keys(regionMap.shopMap[wa]).length
            }

            if (shomlenght >= num){
                let siojournal = ( (num - 1) % 33) + 1
                ctx.fillText(`${regionMap.shopMap[wa][siojournal].data.wa }-${regionMap.shopMap[wa][siojournal].data.siojournal }`, 1, 30)
            }else{
                ctx.fillText(`${regionMap.currPage}-${num}`, 1, 30)
            }
        }else {
            ctx.fillText(`${regionMap.currPage}-${num}`, 1, 30)
        }


        // ctx.fillText(num, 20, 30)

        //生成图片
        let url = canvas.toDataURL('image/png');

        const map = texLoader.load(url)
        // map.center.set(0.5, 0.5)
        // map.rotation = -90 * Math.PI / 180

        canvas.remove()

        //将图片构建到纹理中
        let material1 = new THREE.MeshBasicMaterial({
            map: map,
            side: THREE.DoubleSide,
            opacity: 1,
            transparent: true
        })

        object.material = material1
    })
}

function disposeMesh(mesh) {
    try {
        mesh.parent.remove(mesh)

        mesh.traverse((child) => {
            if (child.material) {
                child.material.dispose();
            }
            if (child.geometry) {
                child.geometry.dispose();
            }
            child = null;
        })
    }catch (e) {
        console.log(e)
    }
}

function disposeData(data) {
    try {
        data.map[data.key] = null
        delete data.map[data.key]
    }catch (e) {
        console.log(e)
    }
}

function clearRam() {

    scene.traverse((child) => {
        try {
            if (child.material) {
                child.material.dispose();
            }
        }catch (e) {
            console.log(e)
        }

        try {
            if (child.geometry) {
                child.geometry.dispose();
            }
        }catch (e) {
            console.log(e)
        }
    });
}

function clearSenceData() {
    clearDataList.forEach((v, i) => {
        disposeData(v)
    })

    clearMeshList.forEach((v, i) => {
        disposeMesh(v)
    })

    clearDataList = []
    clearMeshList = []
}

//清除下方操作栏
function clearBottomUI() {
    for (const key in bottomUIObj.value){
        if (key in bottomUIObj.value){
            delete bottomUIObj.value[key]
        }
    }
}

function ReportAnimation(){
    controlFlag = false

    loadGlbModel("town2/girl02.gltf", {
        // scaleY: 2.5,
        scaleY: 0.3,
        loadCallback: (gltf, modelData) => {
            const fbx = modelData

            let model = fbx;
            //放大縮小
            let box3 = new THREE.Box3()
            let obj = new THREE.Vector3()
            let scaleNum
            box3.setFromObject(model)
            box3.getSize(obj)

            scaleNum = 2.6 / obj.getComponent(1)

            let vector = new THREE.Vector3(scaleNum, scaleNum, scaleNum);
            model.scale.multiply(vector);
            box3.setFromObject(model)
            box3.getSize(obj)
            let shu = null;
            model.traverse(function (object) {
                if (object.isMesh) {
                    if (object.name === "shu") {
                        shu = object
                        object.visible = false
                    }
                }
            })

            model.position.x = 217
            model.position.y = 0
            model.position.z = -10
            model.rotation.y = Math.PI

            //动作
            const mixer = new THREE.AnimationMixer(model);
            mixerObj[modelData.uuid] = mixer

            let allActions = {};

            let animations = gltf.animations;

            //遍歷所有動作
            for (let i = 0; i !== animations.length; ++i) {
                //動作
                const clip = animations[i];
                const action = mixer.clipAction(clip);
                allActions[clip.name] = action;

            }

            let activeAction = allActions['walk'];
            activeAction.play();

            scene.add(model)

            const positionVec3 = new THREE.Vector3()
            meshGroup.getWorldPosition(positionVec3)
            model.position.copy(positionVec3)

            const directionVec3 = new THREE.Vector3()
            directionVec3.x = 0 - camera.position.x
            directionVec3.y = 0
            directionVec3.z = 0 - camera.position.z

            directionVec3.normalize()

            if (userInfoRef.value.CameraPerspective != "1"){
                directionVec3.applyAxisAngle(yAxis, Math.PI / 180 * 10)
            }


            model.translateOnAxis(directionVec3, -3)
            positionVec3.copy(model.position)
            model.translateOnAxis(directionVec3, -9)
            model.lookAt(new THREE.Vector3(meshGroup.position.x,0,meshGroup.position.z));

            // let gui = new GUI()
            // gui.add(model.position, "x").step(1)
            // gui.add(model.position, "y").step(1)
            // gui.add(model.position, "z").step(1)

            // let gui2 = new GUI()
            // gui2.add(model.rotation, "x").step(0.01)
            // gui2.add(model.rotation, "y").step(0.01)
            // gui2.add(model.rotation, "z").step(0.01)
            const tween_2 = new TWEEN.Tween(model.position)
                .to({ x: positionVec3.x, z: positionVec3.z}, 1500)
                .start()
                // .easing(TWEEN.Easing.Sinusoidal.In)
                .onComplete(() => {

                    activeAction.paused = true
                    let previousAction = activeAction
                    activeAction = allActions["give"];
                    activeAction.reset().play();
                    previousAction.crossFadeTo( activeAction, 0.25 )
                    setTimeout(() => {
                        activeAction.paused = true
                        shu.visible = true

                        reportManConfirm(modelData)

                    },1000)



                    delete animationObjGroup["animationgirl0201"]
                })

            animationObjGroup["animationgirl0201"] = tween_2
        },
        callback: (group) => {

        }
    })

}

function reportManConfirm(mesh) {
    openConfirm(
        i18n.tkey("lang_view_confirm_msg"),
        () => {
            reportVisible.value = true
            disposeMesh(mesh)
        },
        () => {
            disposeMesh(mesh)
        }
    )
}

function goNextRegion(checkFlag = true) {
    regionMap.airShipAdvTimer = -20
    timeStamp = -9999999999

    //显示过渡页面
    loadingCarViewVisible.value = true
    //關閉下方的操作欄
    bottomInteractionUiVisible.value = false
    //關閉右上角的操作欄
    upperRightUiVisible.value = false
    //隱藏搖桿
    nippleViewVisible.value = false
    //关闭手机
    shopopeeChatVisible.value = false
    //不允许操作
    controlFlag = false
    //清除当前区域信息
    clearSenceData()
    //清除下方操作栏内容
    clearBottomUI()

    //清除区牌材质
    regionNumPad.forEach((v, i) => {
        const material = v.material
        v.material = null

        if (null != material){
            material.dispose()
        }
    })

    const notDelList = []

    clickVisibleList.forEach((v, i) => {
        if (false == v.__deleteTag__){
            notDelList.push(v)
        }
    })

    clickVisibleList = notDelList


    //切换到下一区
    if (regionMap.currPage >= regionMap.lastPage && checkFlag){
        regionMap.currPage = 1
    }else{
        regionMap.currPage = (Number(regionMap.currPage) + 1).toString()
    }

    userInfoRef.value.currPage = regionMap.currPage

    let nextPageNum = (Number(regionMap.currPage) + 1)

    if (nextPageNum > regionMap.lastPage && checkFlag){
        nextPageNum = 1
    }

    //将人物移动到初始坐标
    if (null === regionMap.selectShopIndex){
        meshGroup.position.copy(startPoint)
    }else{
        movePersonToShopPosition(regionMap.selectShopIndex, true, 5750)
        regionMap.selectShopIndex = null
    }

    toggleActiveMotion("idle")

    //生成新的区号材质
    const newPadNumMaterial = createRegionNumMaterial()
    const nextPadNumMaterial = createRegionNumMaterial(nextPageNum)
    regionNumPad.forEach((v, i) => {
        if (v.name === "area_pad_mesh_0"){
            v.material = nextPadNumMaterial
        }

        if (v.name === "area_pad_mesh_1"){
            v.material = newPadNumMaterial
        }

        if (v.name === "area_pad_mesh_2"){
            v.material = newPadNumMaterial
        }

    })
    // regionNumPad.material = createRegionNumMaterial()

    if (Number(regionMap.currPage) === 1){
        if (null != shopopeeHallMesh){
            shopopeeHallMesh.visible = true

            if (userInfoRef.value.selectCountry == 'HK'){
                airWallList["shopopee_hall_1"] = shopopeeHallWall
            }else{
                airWallList["shopopee_hall_1"] = shopopeeHallWall2
            }

            shopopeeSubHallMeshList.forEach((v, i) => {
                try {
                    if (null != v){
                        v.visible = true
                    }
                }catch (e){
                    console.log(e)
                }
            })
        }
    }else{
        if (null != shopopeeHallMesh){
            shopopeeHallMesh.visible = false
            delete airWallList["shopopee_hall_1"]

            shopopeeSubHallMeshList.forEach((v, i) => {
                try{
                    if (null != v){
                        v.visible = false
                    }
                }catch (e){
                    console.log(e)
                }

            })
        }
    }

    setTimeout(() => {
        //加载下一区的数据
        const shopmanList = []
        createShopAndMan(shopPointList, shopmanList)
    }, 1000)

    setTimeout(() => {
        nippleViewVisible.value = false
    }, 251)

    setTimeout(() => {
        timeStamp = 0
    }, 4500)

    setTimeout(() => {
        //关闭过渡页面
        loadingCarViewVisible.value = false
        //重新顯示下方的操作欄
        bottomInteractionUiVisible.value = true
        //重新顯示右上角的操作欄
        upperRightUiVisible.value = true
        //重新顯示搖桿
        nippleViewVisible.value = true
        //允许操作
        controlFlag = true
        //保存主角位置
        savePersonPosition()

    }, 5500)
}

//创建欢迎相关的模型
function createGuideContent(withAIObj) {
    regionMap.guideWithAIObj = []

    //創建歡迎人員
    createGuideShopman(withAIObj, 0, 0, "waving", true)
    createGuideShopman(withAIObj, -2, 2, "idle", false)
    createGuideShopman(withAIObj, 2, 2, "idle", false)
    //創建傳送點旁邊的人
    createTransferman(withAIObj, regionMap.transferManPoint_1, 0, 0, "idle")
    // createTransferman(withAIObj, regionMap.transferManPoint_2, 0, 0, "idle")

    // scene.add(regionMap.guideCarObj)
    // regionMap.guideCarObj.scale.multiply(new THREE.Vector3(0.01, 0.01, 0.01));
    //
    // regionMap.guideCarObj.position.x = regionMap.welcomePoint.x - 5
    // regionMap.guideCarObj.position.z = regionMap.welcomePoint.z


}

function createGuideShopman(withAIObj, positionX = 0, positionZ = 0, action = "waving", mainTag = false) {
    const copyWithAIObj = getEmptyWithAIObj()

    copyWithAIObj.did = withAIObj.did
    copyWithAIObj.login = withAIObj.login
    copyWithAIObj.memMale = withAIObj.memMale
    copyWithAIObj.name = withAIObj.name
    copyWithAIObj.rid = withAIObj.rid
    copyWithAIObj.whatsshopsbcatalist = withAIObj.whatsshopsbcatalist
    copyWithAIObj.companyName = withAIObj.companyName
    copyWithAIObj.group = clone(withAIObj.group)
    copyWithAIObj.model = copyWithAIObj.group.children[0]











    loadGlbModel("town2/aman.gltf", {
        // scaleY: 2.5,
        scaleY: 0.48,
        // castShadow: true,
        loadCallback: (gltf, model) => {
            // const children = []
            // children.push(model.children[1])
            // children.push(model.children[0])
            // model.children = children

            copyWithAIObj.model = model

            //动作
            const mixer = new THREE.AnimationMixer( model );
            mixerObj[model.uuid] = mixer

            copyWithAIObj.allActions = {};

            let animations = gltf.animations;

            //随机上衣和裤子的颜色
            model.traverse( function ( object ) {
                if (object.name === "Wolf3D_Outfit_Top"){
                    object.material = object.material.clone()
                    object.material.map = textureMap["outfit-classic-03-v2-m-top-D_W.jpg"]
                    object.material.map.needsUpdate = true
                    object.material.needsUpdate = true
                }

                if (object.name === "Wolf3D_Outfit_Bottom"){
                    object.material = object.material.clone()
                    object.material.map = textureMap["outfit-classic-03-v2-m-bottom-D_W.jpg"]
                    object.material.map.needsUpdate = true
                    object.material.needsUpdate = true

                }

            })

            // model.children[0].material.shininess = 0
            // const material = new THREE.MeshStandardMaterial({})
            // material.copy(model.children[0].material)
            // model.children[0].material = material

            //遍歷所有動作
            for ( let i = 0; i !== animations.length; ++ i ) {
                //動作
                const clip = animations[ i ];
                const action = mixer.clipAction( clip );
                copyWithAIObj.allActions[clip.name ] = action;

            }

            copyWithAIObj.activeAction = copyWithAIObj.allActions[action];
            copyWithAIObj.activeAction.play();

            copyWithAIObj.action = action

        },
        callback: (group) => {
            copyWithAIObj.group = group
            scene.add(group)

            copyWithAIObj.group.position.x = regionMap.welcomePoint.x + positionX
            copyWithAIObj.group.position.z = regionMap.welcomePoint.z + positionZ

            copyWithAIObj.model.lookAt(new THREE.Vector3(regionMap.welcomePoint.x + positionX, 0, regionMap.welcomePoint.z - 1 + positionZ))

            regionMap.guideWithAIObj.push(copyWithAIObj)

            if (!mainTag){
                try {
                    const meshs = []
                    copyWithAIObj.group.traverse((child) => {
                        if (child instanceof THREE.Sprite){
                            // disposeMesh(child)
                            meshs.push(child)
                        }
                    })

                    meshs.forEach((v, i) => {
                        disposeMesh(v)
                    })
                }catch (e) {
                    console.log(e)
                }
            }else{
                withAIObj.group.traverse((child) => {
                    if (child instanceof THREE.Sprite){
                        // disposeMesh(child)
                        copyWithAIObj.group.add(child.clone())
                    }
                })
            }

        }
    })


















    // const mixer = new THREE.AnimationMixer( copyWithAIObj.model.children[0] );
    // mixerObj[copyWithAIObj.model.uuid] = mixer
    //
    // copyWithAIObj.allActions = {};
    //
    // let animations = model.animations;
    //
    // //遍歷所有動作
    // for ( let i = 0; i !== animations.length; ++ i ) {
    //     //動作
    //     const clip = animations[ i ];
    //     const action = mixer.clipAction( clip );
    //     copyWithAIObj.allActions[clip.name ] = action;
    //
    // }
    //
    // copyWithAIObj.activeAction = copyWithAIObj.allActions[action];
    // copyWithAIObj.activeAction.play();
    // copyWithAIObj.action = action

    // scene.add(copyWithAIObj.group)

    // copyWithAIObj.group.position.x = 217 + positionX
    // copyWithAIObj.group.position.z = 38 + positionZ
    //
    // copyWithAIObj.model.lookAt(new THREE.Vector3(217 + positionX, 0, 37 + positionZ))

    // copyWithAIObj.group.position.x = regionMap.welcomePoint.x + positionX
    // copyWithAIObj.group.position.z = regionMap.welcomePoint.z + positionZ
    //
    // copyWithAIObj.model.lookAt(new THREE.Vector3(regionMap.welcomePoint.x + positionX, 0, regionMap.welcomePoint.z - 1 + positionZ))

    // regionMap.guideWithAIObj = copyWithAIObj
    // regionMap.guideWithAIObj.push(copyWithAIObj)
    //
    // if (!mainTag){
    //     try {
    //         const meshs = []
    //         copyWithAIObj.group.traverse((child) => {
    //             if (child instanceof THREE.Sprite){
    //                 // disposeMesh(child)
    //                 meshs.push(child)
    //             }
    //         })
    //
    //         meshs.forEach((v, i) => {
    //             disposeMesh(v)
    //         })
    //     }catch (e) {
    //         console.log(e)
    //     }
    // }
}

//創建傳送點旁邊的人
function createTransferman(withAIObj, position, positionX = 0, positionZ = 0, action = "waving", mainTag = false) {
    const copyWithAIObj = getEmptyWithAIObj()

    copyWithAIObj.did = withAIObj.did
    copyWithAIObj.login = withAIObj.login
    copyWithAIObj.memMale = withAIObj.memMale
    copyWithAIObj.name = withAIObj.name
    copyWithAIObj.rid = withAIObj.rid
    copyWithAIObj.whatsshopsbcatalist = withAIObj.whatsshopsbcatalist
    copyWithAIObj.companyName = withAIObj.companyName
    copyWithAIObj.group = clone(withAIObj.group)
    copyWithAIObj.model = copyWithAIObj.group.children[0]













    loadGlbModel("town2/aman.gltf", {
        scaleY: 0.48,
        // scaleY: 2.5,
        // castShadow: true,
        loadCallback: (gltf, model) => {
            // const children = []
            // children.push(model.children[1])
            // children.push(model.children[0])
            // model.children = children

            copyWithAIObj.model = model

            //动作
            const mixer = new THREE.AnimationMixer( model );
            mixerObj[model.uuid] = mixer

            copyWithAIObj.allActions = {};

            let animations = gltf.animations;

            //随机上衣和裤子的颜色
            model.traverse( function ( object ) {
                if (object.name === "Wolf3D_Outfit_Top"){
                    object.material = object.material.clone()
                    object.material.map = textureMap["outfit-classic-03-v2-m-top-D_W.jpg"]
                    object.material.map.needsUpdate = true
                    object.material.needsUpdate = true
                }

                if (object.name === "Wolf3D_Outfit_Bottom"){
                    object.material = object.material.clone()
                    object.material.map = textureMap["outfit-classic-03-v2-m-bottom-D_W.jpg"]
                    object.material.map.needsUpdate = true
                    object.material.needsUpdate = true

                }
            })

            // model.children[0].material.shininess = 0
            // const material = new THREE.MeshStandardMaterial({})
            // material.copy(model.children[0].material)
            // model.children[0].material = material

            //遍歷所有動作
            for ( let i = 0; i !== animations.length; ++ i ) {
                //動作
                const clip = animations[ i ];
                const action = mixer.clipAction( clip );
                copyWithAIObj.allActions[clip.name ] = action;

            }

            copyWithAIObj.activeAction = copyWithAIObj.allActions[action];
            copyWithAIObj.activeAction.play();

            copyWithAIObj.action = action

        },
        callback: (group) => {
            copyWithAIObj.group = group
            scene.add(group)

            copyWithAIObj.group.position.x = position.x + positionX
            copyWithAIObj.group.position.z = position.z + positionZ

            copyWithAIObj.model.lookAt(new THREE.Vector3(position.x - 1 + positionX, 0, position.z + positionZ))

            regionMap.guideWithAIObj.push(copyWithAIObj)

            if (!mainTag){
                try {
                    const meshs = []
                    copyWithAIObj.group.traverse((child) => {
                        if (child instanceof THREE.Sprite){
                            // disposeMesh(child)
                            meshs.push(child)
                        }
                    })

                    meshs.forEach((v, i) => {
                        disposeMesh(v)
                    })
                }catch (e) {
                    console.log(e)
                }
            }

        }
    })
















    // const mixer = new THREE.AnimationMixer( copyWithAIObj.model );
    // mixerObj[copyWithAIObj.model.uuid] = mixer
    //
    // copyWithAIObj.allActions = {};
    //
    // let animations = model.animations;
    //
    // //遍歷所有動作
    // for ( let i = 0; i !== animations.length; ++ i ) {
    //     //動作
    //     const clip = animations[ i ];
    //     const action = mixer.clipAction( clip );
    //     copyWithAIObj.allActions[clip.name ] = action;
    //
    // }
    //
    // copyWithAIObj.activeAction = copyWithAIObj.allActions[action];
    // copyWithAIObj.activeAction.play();
    // copyWithAIObj.action = action
    //
    // scene.add(copyWithAIObj.group)

    // copyWithAIObj.group.position.x = position.x + positionX
    // copyWithAIObj.group.position.z = position.z + positionZ
    //
    // copyWithAIObj.model.lookAt(new THREE.Vector3(position.x - 1 + positionX, 0, position.z + positionZ))
    //
    // try {
    //     const meshs = []
    //     copyWithAIObj.group.traverse((child) => {
    //         if (child instanceof THREE.Sprite){
    //             // disposeMesh(child)
    //             meshs.push(child)
    //         }
    //     })
    //
    //     meshs.forEach((v, i) => {
    //         disposeMesh(v)
    //     })
    // }catch (e) {
    //     console.log(e)
    // }
}

//刪除引導人員
function removeGuideMan(withAIObj) {
    regionMap.guideWithAIObj.forEach((v, i) => {
        disposeMesh(v.group)

        mixerObj[v.model.uuid] = null
        delete mixerObj[v.model.uuid]
    })

    // disposeMesh(regionMap.guideCarObj)
    // regionMap.guideCarObj = null
    // regionMap.guideWithAIObj = null
}

//將引導人員移動到直升機旁
function moveGuideManPoint() {
    regionMap.guideWithAIObj.forEach((v, i) => {
        if (i === 0){
            v.group.position.copy(regionMap.transferManPoint_2)

            const lookPoint = new THREE.Vector3()
            lookPoint.copy(v.group.position)
            lookPoint.x -= 0.5
            lookPoint.z -= 1

            v.model.lookAt(lookPoint)

            const meshs = []
            v.group.traverse((child) => {
                if (child instanceof THREE.Sprite){
                    // disposeMesh(child)
                    meshs.push(child)
                }
            })

            meshs.forEach((v, i) => {
                disposeMesh(v)
            })

            interactionObj[v.model.uuid] = [
                {
                    distance: 8,
                    icon: "fa-solid fa-helicopter",
                    name: "區域傳送",
                    mesh: v.model,
                    callback: () => {
                        // // alert("請收下我的名片吧")
                        // let src = proxy.$ShopopeeUrl + shopData.cardInfo
                        // let href = proxy.$ShopopeeUrl + "/receive?id=" + shopData.memberworkId
                        // showCardBox(src, href, shopData.memberworkId)
                        // goPersonChat(model.children[0], withAIObj.name, ["請您收下我的名片"], () => {
                        //     // setTimeout(() => {
                        //     // closePersonChat()
                        //     // }, 1000)
                        // })
                        // audioManager.playdownAudio()
                        toggleSelectAreaBox(true)
                    }
                }
            ]
        }else if (i === 1){
            v.group.position.copy(regionMap.transferManPoint_2)

            v.group.position.x += 2
            v.group.position.z -= 1

            const lookPoint = new THREE.Vector3()
            lookPoint.copy(v.group.position)
            lookPoint.x -= 0.5
            lookPoint.z -= 1

            v.model.lookAt(lookPoint)
        }else if(i === 2){
            v.group.position.copy(regionMap.transferManPoint_2)

            v.group.position.x += 2
            v.group.position.z += 1

            const lookPoint = new THREE.Vector3()
            lookPoint.copy(v.group.position)
            lookPoint.x -= 0.5
            lookPoint.z -= 1

            v.model.lookAt(lookPoint)
        }
    })
}

function goGuideShop(withAIObj) {
    controlFlag = false
    bottomInteractionUiVisible.value = false
    upperRightUiVisible.value = false
    nippleViewVisible.value = false
    loadingCarViewVisible.value = true

    // removeGuideMan(withAIObj)
    moveGuideManPoint(withAIObj)

    // const obj = shopPointList[withAIObj.did - 1]
    //
    // obj.traverse((child) => {
    //     if (child.name === `Shop_transfer_position_${withAIObj.did - 1}`){
    //         const worldPosition = new THREE.Vector3()
    //         child.getWorldPosition(worldPosition)
    //         meshGroup.position.copy(worldPosition)
    //     }
    // })

    movePersonToShopPosition(withAIObj.did)

    setTimeout(() => {
        controlFlag = true
        loadingCarViewVisible.value = false
        bottomInteractionUiVisible.value = true
        upperRightUiVisible.value = true
        nippleViewVisible.value = true
    }, 1500)

    setTimeout(() => {
        controlFlag = false
        bottomInteractionUiVisible.value = false
        upperRightUiVisible.value = false
        nippleViewVisible.value = false
    }, 251)
}

//將主角傳送到某個店鋪門口
function movePersonToShopPosition(doorNum, animationFlag, animationDelay) {
    const index = doorNum - 1
    const obj = shopPointList[index]

    const shopPosition = new THREE.Vector3()

    obj.getWorldPosition(shopPosition)

    obj.traverse((child) => {
        // if (child.name === `billboard_${index}`){
        //     child.parent.getWorldPosition(shopPosition)
        // }

        if (child.name === `Shop_transfer_position_${index}`){
            const worldPosition = new THREE.Vector3()
            child.getWorldPosition(worldPosition)
            meshGroup.position.copy(worldPosition)

            const cameraDirect = new THREE.Vector3()
            cameraDirect.x = worldPosition.x - shopPosition.x
            cameraDirect.z = worldPosition.z - shopPosition.z
            cameraDirect.normalize()

            if (Math.abs(cameraDirect.x) > Math.abs(cameraDirect.z)){
                camera.position.z = 0

                if (cameraDirect.x > 0){
                    camera.position.x = cameraOptionObj.currCameraDistance
                }else{
                    camera.position.x = cameraOptionObj.currCameraDistance * -1
                }
            }else{
                camera.position.x = 0

                if (cameraDirect.z > 0){
                    camera.position.z = cameraOptionObj.currCameraDistance
                }else{
                    camera.position.z = cameraOptionObj.currCameraDistance * -1
                }
            }

            camera.position.y = cameraOptionObj.currCameraPositionY
            camera.lookAt(new THREE.Vector3(meshGroup.position.x,2.5,meshGroup.position.z));

            // rotationNum = camera.rotation.y - Math.PI / 2
            rotationNum = cameraDirect.x * Math.PI + cameraDirect.z * Math.PI / 2

            if (doorNum == 35 || doorNum == 36 || doorNum == 39 || doorNum == 40){
                rotationNum = 0
            }

            testBox.lookAt(shopPosition)
        }
    })

    //如果该商家存在广告，播放广告
    const shopData = regionMap.shopMap[regionMap.currPage][doorNum].data
    if (myUtil.isNotEmpty(shopData.advVideoPath) || myUtil.isNotEmpty(shopData.advUrl)){
        if (false !== animationFlag){
            if (null != animationDelay ){
                setTimeout(() => {
                    playMoveToShopAnimation(shopData)
                }, animationDelay)
            }else{
                playMoveToShopAnimation(shopData)
            }
        }

    }

    savePersonPosition()
}

//播放或者暫停汽車動畫 type 0暫停 1播放
function playOrPauseCarAnimation(type) {
    if (type == 0){
        carWithAIObjList.forEach((v, i) => {
            if (null != animationObjGroup[v.group.uuid]){
                animationObjGroup[v.group.uuid].pause()
            }
        })
    }else{
        carWithAIObjList.forEach((v, i) => {
            if (null != animationObjGroup[v.group.uuid]){
                animationObjGroup[v.group.uuid].resume()
            }
        })
    }
}

//顯示或者隱藏汽車動畫 type 0隱藏 1顯示
function displayOrHideCarAnimation(visible) {
    if (visible == 0){
        carWithAIObjList.forEach((v, i) => {
            v.group.visible = false
        })
    }else{
        carWithAIObjList.forEach((v, i) => {
            if (null != animationObjGroup[v.group.uuid]){
                v.group.visible = true
            }
        })
    }
}

function loginCallback(){
    if (loadingPercent.value < 100){

        loadingPercent.value = 10

        //先查詢島嶼
        getIslandList(getShopList)
    }
}

//顯示或者關閉區域傳送窗口
function toggleSelectAreaBox(flag = true) {
    if (flag === true){
        selectAreaNum.value = regionMap.currPage
        selectDoorNum.value = null
        selectAreaVisible.value = true
        controlFlag = false
    }else{
        selectAreaNum.value = regionMap.currPage
        selectDoorNum.value = null
        selectAreaVisible.value = false
        controlFlag = true
    }

}

//前往選定的區域
function goSelectArea() {

    // console.log(selectDoorNum.value)
    if (null != selectDoorNum.value){
        regionMap.selectShopIndex = selectDoorNum.value
        selectDoorNum.value = null
    }

    audioManager.playdownAudio()
    regionMap.currPage = selectAreaNum.value - 1
    userInfoRef.value.currPage = regionMap.currPage
	// userInfoRef.value.areacode = ""
	
    toggleSelectAreaBox(false)
    if (tpAnimationFlag){
        bottomInteractionUiVisible.value = false
        upperRightUiVisible.value = false
        nippleViewVisible.value = false

        regionMap.airShipAdvTimer = -20

        tpAnimation()
    }else{
        tpAnimationFlag = true
        bottomInteractionUiVisible.value = false
        upperRightUiVisible.value = false
        nippleViewVisible.value = false

        goNextRegion(false)
    }

    // goNextRegion(false)
}

function closeSelectArea() {
    tpAnimationFlag = true
    audioManager.playdownAudio()
    toggleSelectAreaBox(false)
}

function goLogin() {
    proxy.$refs.shopopeePhone.goLoginView()
    audioManager.playdownAudio()
}

function goAccountView() {
    // proxy.$refs.shopopeePhone.goAccountView()
    // proxy.$refs.shopopeePhone.goDisplayIndexView()
    // proxy.$refs.shopopeePhone.goMyCardView()
    proxy.$refs.shopopeePhone.goDisplayIndexView()
    audioManager.playdownAudio()
}

function goChatView() {
    proxy.$refs.shopopeePhone.goChatView()
    audioManager.playdownAudio()
}

function savePersonPosition(x, z) {
    if(null == x){
        x = meshGroup.position.x
    }

    if(null == z){
        z = meshGroup.position.z
    }

    userInfoRef.value.currPage = regionMap.currPage
    userInfoRef.value.positionX = x
    userInfoRef.value.positionZ = z
}

function goShopPosition(wa, siojournal, islandid) {
    if (null != islandid && null != currIsland && islandid != currIsland.id){
        proxy.$router.push({path: `/${islandid}/index/${wa}/${siojournal}`})
        reload()
    }else{
        regionMap.selectShopIndex = siojournal
        regionMap.currPage = Number(wa) - 1
        goNextRegion(false)
    }

}

function goThreeGuide() {
    hideShopopeeChatBox()

    setTimeout(() => {
        guideViewVisible.value = true
        controlFlag = false
    }, 250)

}

//檢測觸發區域
function checkTriggerMap() {
    for (const key in triggerAreaMap){
        const obj = triggerAreaMap[key]

        if (checkInAreaFlag(obj.scope)){
            if (!obj.alive && (obj.timer > obj.timeLimit)){
                obj.timer = 0
                obj.alive = true

                if (typeof obj.func === "function"){
                    obj.func()
                }
            }
        }else{
            if (!obj.alive){
                obj.timer += mixerUpdateDelta
            }else{
                obj.alive = false
            }
        }
    }
}

//檢測主角是否在某個區域中
function checkInAreaFlag(obj){
    const flagX1 = meshGroup.position.x < obj.MAX_POSITION_X
    const flagX2 = meshGroup.position.x > obj.MIN_POSITION_X

    const flagZ1 = meshGroup.position.z < obj.MAX_POSITION_Z
    const flagZ2 = meshGroup.position.z > obj.MIN_POSITION_Z

    return flagX1 && flagX2 && flagZ1 && flagZ2
}

function closeGuideView() {
    controlFlag = true
    guideViewVisible.value = false
}

function clickNewShop() {
    hideShopopeeChatBox()
}

function clickReturnShopopee() {
    hideShopopeeChatBox()

    setTimeout(() => {
        confirmReturnShopopee()
    }, 250)

}

function confirmReturnShopopee() {
    openConfirm(i18n.tkey("lang_return_shopopee_confirm"), () => {
        window.location.href = `${proxy.$ShopopeeUrl}my_memberwork`
    })
}

function goShopMaterialList(obj) {
  var whereStr=""
  if (myUtil.isNotEmpty(userInfoRef.value.login)){//
    whereStr+=`fromShopopeeMall=-1&shopopeeLogin=${userInfoRef.value.login}&`
  }
    const url = `${proxy.$SSL}://${obj.procedurename}/Web/W006/single_product.asp?${whereStr}productID=${obj.productid}&ProductCompanyCode=${obj.acccode}&CompanyCode=${obj.acccode}&formUrl=3dshop`

    openConfirm(i18n.tkey("lang_go_eshopopee_confirm_1"), () => {
        // location.href = url
        myUtil.goURLNewWindow(url, "web")

    })


    // if (null != showMaterialShopdata.value){
    //     let login = showMaterialShopdata.value.eshopopeeLogin
    //
    //     if (userInfoRef.value.login === login){
    //         openConfirm("不能跟自己聊天")
    //     }else{
    //         proxy.$refs.shopopeePhone.openPersonChat(login, true)
    //
    //         // audioManager.playdownAudio()
    //         setTimeout(() => {
    //             controlFlag = false
    //         }, 500)
    //     }
    //
    //
    // }
}

function clearCache() {
    // userInfoRef.value.positionX = null
    // userInfoRef.value.positionZ = null
    // userInfoRef.value.currPage = 1
    // userInfoRef.value.guideCount = 0
    const obj = cookie.getCookie()

    for (const key in obj){
        cookie.removeCookie(key)
        cookie.removeCookie(key, {path: '/'})
    }

    const lang = userInfoRef.value.lang

    userInfoRef.value.$reset()

    userInfoRef.value.lang = lang

    ElMessage({
        showClose: true,
        message: i18n.tkey("lang_clear_success"),
        type: 'success',
        offset: 180
    })

    window.location.reload(true)
}
//瀏覽數量
async function replaceTrafficNumMaterial(num, wa, siojournal) {
    if (null == num){
        num = 0
    }

    if (null != regionMap.shopMap[wa] && null != regionMap.shopMap[wa][siojournal] && regionMap.currPage == wa){
        siojournal = Number(siojournal) - 1
        const mesh = shopTrafficPadMap[siojournal]

        Promise.all([
            loadImage(process.env.BASE_URL + "mytextures/name_pad.png")
        ]).then((images) => {
            //创建名牌
            const text = `${i18n.tkey("lang_viewers")}：${num}`

            let fontsize = 20
            let xLeft

            xLeft = 10 + (180 - 20 * text.length) / 2

          if (userInfoRef.value.lang !== "zh" && userInfoRef.value.lang !== "szh"){
            xLeft+=40
          }

            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext('2d')

            canvas.width = 200
            canvas.height = 40
            //制作矩形
            // ctx.fillStyle = "transparent";
            // ctx.fillRect(0, 0, 120, 60)
            ctx.drawImage(images[0], 0, 0, 200, 40)
            //设置文字
            ctx.fillStyle = "#fefefe";
            ctx.font = `normal ${fontsize}px "楷体"`
            ctx.fillText(text, xLeft, 28)

            //生成图片
            let url = canvas.toDataURL('image/png');
            //删除dom
            canvas.remove()
            //将图片构建到纹理中
            const material = new THREE.MeshBasicMaterial({
                map: texLoader.load(url),
                side: THREE.DoubleSide,
                opacity: 1,
                transparent: true
            })

            const tempMaterial = mesh.material
            mesh.material = material
            tempMaterial.dispose()
        })

    }
}

//記錄訪問量
async function saveShopVisits(companyId) {
    const request = companyApi.addShopVisits
    const params = request.getParams()

    params.id = companyId

    request.send(params, (res) => {
        if (res.code == 200 && null != res.detail){
            const obj = res.detail
            replaceTrafficNumMaterial(obj.materialstatus, obj.wa, obj.siojournal)
        }
    })

}

function testModel() {
    return

    let boxGeometry = new THREE.BoxGeometry(10, 10, 10)
    let lambertMaterial = new THREE.MeshBasicMaterial({
        color: 0xff0000
    })

    const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
    scene.add(mesh)

    mesh.position.x = 285
    mesh.position.y = 60
    mesh.position.z = -82

    // const gui = new GUI()
    // gui.add(mesh.position, "x").step(1)
    // gui.add(mesh.position, "y").step(1)
    // gui.add(mesh.position, "z").step(1)

    const tween = new TWEEN.Tween(mesh.position)
        .to({z: 82}, 9000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.InOut)
        .onComplete(() => {
            delete animationObjGroup["balloon_animation_1"]
        })

    animationObjGroup["balloon_animation_1"] = tween

    setTimeout(() => {
        rotationNum = Math.PI - Math.PI / 180 * 30
        rotationNumY = 0.065
        calcCameraPosition()
        const obj = {
            num: rotationNum
        }

        const tween = new TWEEN.Tween(obj)
            .to({num: Math.PI + Math.PI / 180 * 30}, 6000)
            .start()
            .easing(TWEEN.Easing.Sinusoidal.InOut)
            .onComplete(() => {
                delete animationObjGroup["balloon_animation_2"]
            })
            .onUpdate(() => {
                rotationNum = obj.num
                calcCameraPosition()
            })

        animationObjGroup["balloon_animation_2"] = tween

    }, 2000)

}

function tpAnimation() {
    controlFlag = false

    const tpHeliObj = tpObjMap["tpHeli"]
    const tpHeliWingObj = tpObjMap["tpHeliWing"]
    const tpHeliWing2Obj = tpObjMap["tpHeliWing2"]

    tpHeliObj.position.y = 60

    saveCameraPosition()

    meshGroup.remove(camera)
    scene.add(camera)

    camera.lookAt(new THREE.Vector3())
    camera.position.x = 230
    camera.position.y = 5
    camera.position.z = 9
    camera.rotation.x = 0
    camera.rotation.y = -1.91
    camera.rotation.z = 0


    // const gui = new GUI()
    // gui.add(tpHeliObj.position, "x")
    // gui.add(tpHeliObj.position, "y")
    // gui.add(tpHeliObj.position, "z")
    // gui.add(tpHeliObj.rotation, "x").step(0.01)
    // gui.add(tpHeliObj.rotation, "y").step(0.01)
    // gui.add(tpHeliObj.rotation, "z").step(0.01)


    tpHeliObj.rotation.x = 0.1

    const tween_1 = new TWEEN.Tween(tpHeliWingObj.rotation)
        .to({y: Math.PI * 140}, 9000)
        .start()
        // .easing(TWEEN.Easing.Sinusoidal.In)
        .onComplete(() => {
            delete animationObjGroup[tpHeliWingObj.uuid]
        })

    animationObjGroup[tpHeliWingObj.uuid] = tween_1

    const tween_2 = new TWEEN.Tween(tpHeliWing2Obj.rotation)
        .to({x: Math.PI * 140}, 9000)
        .start()
        // .easing(TWEEN.Easing.Sinusoidal.In)
        .onComplete(() => {
            delete animationObjGroup[tpHeliWing2Obj.uuid]

            setTimeout(() => {
                tpHeliWingObj.rotation.y = 0
                tpHeliWing2Obj.rotation.x = 0
            }, 250)
        })

    animationObjGroup[tpHeliWing2Obj.uuid] = tween_2

    const tween_3 = new TWEEN.Tween(tpHeliObj.position)
        .to({y: 2000, z: 3000}, 3000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.In)
        .onComplete(() => {
            delete animationObjGroup["tpHeliAnimation_1"]


            const tween_5 = new TWEEN.Tween(tpHeliObj.position)
                .to({y: 5000, z: 10000}, 5000)
                .start()
                // .easing(TWEEN.Easing.Sinusoidal.Out)
                .onComplete(() => {
                    delete animationObjGroup["tpHeliAnimation_3"]
                })

            animationObjGroup["tpHeliAnimation_3"] = tween_5

            const tween_6 = new TWEEN.Tween(tpHeliObj.position)
                .to({x: 31000}, 5000)
                .start()
                .easing(TWEEN.Easing.Sinusoidal.InOut)
                .onComplete(() => {
                    delete animationObjGroup["tpHeliAnimation_4"]
                })

            animationObjGroup["tpHeliAnimation_4"] = tween_6

            const tween_7 = new TWEEN.Tween(tpHeliObj.rotation)
                .to({x: 0.3, y: 0.7}, 5000)
                .start()
                // .easing(TWEEN.Easing.Sinusoidal.In)
                .onComplete(() => {
                    delete animationObjGroup["tpHeliAnimation_5"]

                    setTimeout(() => {
                        tpHeliObj.position.x = 23985
                        tpHeliObj.position.y = 25
                        tpHeliObj.position.z = 1560
                        tpHeliObj.rotation.x = 0
                        tpHeliObj.rotation.y = 0
                        tpHeliObj.rotation.z = 0
                    }, 250)
                })

            animationObjGroup["tpHeliAnimation_5"] = tween_7

        })

    animationObjGroup["tpHeliAnimation_1"] = tween_3

    const tween_4 = new TWEEN.Tween(tpHeliObj.rotation)
        .to({x: 0.3}, 3000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.In)
        .onComplete(() => {
            delete animationObjGroup["tpHeliAnimation_2"]
        })

    animationObjGroup["tpHeliAnimation_2"] = tween_4

    const tween_c1 = new TWEEN.Tween(camera.position)
        .to({x: 230, y: 22 ,z: 21}, 3000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.In)
        .onComplete(() => {
            delete animationObjGroup["tpCamera1"]

            const tween_c3 = new TWEEN.Tween(camera.position)
                // .to({x: 290, y: 34 ,z: 87.5}, 4500)
                .to({x: 290, y: 52 ,z: 87.5}, 4500)
                .start()
                .delay(1000)
                .easing(TWEEN.Easing.Sinusoidal.In)
                .onComplete(() => {
                    delete animationObjGroup["tpCamera3"]
                })

            animationObjGroup["tpCamera3"] = tween_c3

            const tween_c4 = new TWEEN.Tween(camera.rotation)
                .to({y: -2.06}, 4500)
                .start()
                .delay(1000)
                .easing(TWEEN.Easing.Sinusoidal.In)
                .onComplete(() => {
                    delete animationObjGroup["tpCamera4"]

                    scene.remove(camera)
                    meshGroup.add(camera)
                    loadCameraPosition()

                    bottomInteractionUiVisible.value = true
                    upperRightUiVisible.value = true
                    nippleViewVisible.value = true

                    goNextRegion(false)
                })

            animationObjGroup["tpCamera4"] = tween_c4
        })

    animationObjGroup["tpCamera1"] = tween_c1
}

function saveCameraPosition() {
    beforeCameraPosition = camera.position.clone()
    beforeCameraUp = camera.up.clone()
    beforeCameraRotation = camera.rotation.clone()
}

function loadCameraPosition() {
    camera.position.set(beforeCameraPosition.x, beforeCameraPosition.y, beforeCameraPosition.z)
    camera.lookAt(beforeCameraUp)
    camera.rotation.set(beforeCameraRotation.x, beforeCameraRotation.y, beforeCameraRotation.z)

    beforeCameraPosition = null
    beforeCameraUp = null
    beforeCameraRotation = null
}

function clickSearchInput() {
    imgShakeFlag.value = false
    proxy.$refs.shopopeePhone.goSearchView()
}

function click2dSearch(){

  proxy.$router.push({name: `main`})
}

function clickMaterialSearch(){
  proxy.$refs.shopopeePhone.goSearchView("material")
}

function changeCameraPerspective() {
    let distance = cameraOptionObj.currCameraDistance

    if (userInfoRef.value.CameraPerspective === "1"){
        distance = cameraOptionObj.defaultFirstCameraDistance
        meshGroup.visible = false
    }else{
        distance = cameraOptionObj.defaultThirdCameraDistance
        meshGroup.visible = true
    }

    cameraOptionObj.defaultCameraDistance = distance
    cameraOptionObj.currCameraDistance = distance

    calcCameraPosition()
}

function changePersonModel() {
    renderFlag = false

    model.parent.remove(model)
    headGroup.parent.remove(headGroup)
    disposeMesh(model)

    testBox = null

    // let fileName = process.env.BASE_URL + "mymodels/fbx/town2/boy21.fbx"
    let fileName = process.env.BASE_URL + "mymodels/gltf/town2/aman.gltf"

    if ( userInfoRef.value.modelSex === 1 ){
        // fileName = process.env.BASE_URL + "mymodels/fbx/town2/woman.fbx"
        fileName = process.env.BASE_URL + "mymodels/gltf/town2/agirl.gltf"
    }

    loadLeadModel(fileName)
}

function selectCountryCallback(obj){
    // getShopList()
    // userInfoRef.value.selectCountry = code
    userInfoRef.value.selectCountry = obj.countrycode
    userInfoRef.value.selectCountryName = obj.zh
    userInfoRef.value.selectCountryName2 = obj.en

    selectCountryVisible.value = false
    // islandSelectVisible.value = true
    startViewVisible.value = false
}

function selectIslandCallback(obj) {
    userInfoRef.value.islandID = obj.id

    islandSelectVisible.value = false
    startViewVisible.value = false
}

function selectLoadCountryCallback(obj) {

    selectCountryVisible.value = false

    const code = obj.countrycode

    const flag = code != userInfoRef.value.selectCountry

    userInfoRef.value.selectCountry = obj.countrycode
    userInfoRef.value.selectCountryName = obj.zh
    userInfoRef.value.selectCountryName2 = obj.en
	
    if (flag) {
        islandSelectVisible.value = true
        userInfoRef.value.areacode = null
    }else{
        toggleSelectAreaBox()
    }

    // if (flag){
    //     // myUtil.confirmWarning(i18n.tkey("lang_change_region_confirm"), () => {
    //         // location.reload()
    //         userInfoRef.value.currPage = 1
    //         reload()
    //     // })
    // }else{
    //     // regionMap.currPage = userInfoRef.value.currPage - 1
    //     regionMap.currPage = 0
    //     goNextRegion()
    // }

}

function selectChangeIslandCallback(obj){
    // userInfoRef.value.currPage = 1

    proxy.$router.push({path: `/${obj.id}/index`})
    reload()
}

function clickGoHall(obj){
    controlFlag = true
    moveFlag = true
    hallVisible.value = false
    savePersonPosition()

    proxy.$router.push({path: `/hall/${obj.id}`})
}

function closeHallDialog(){
    controlFlag = true
}

function return3DOperatorFlag(){
    return true
}

function call3DOperator(){
    hideShopopeeChatBox()
    ReportAnimation()
}

function loadHallDoorAdvImg(){
    hallDoorAdvList.forEach((item, index) => {
        shopopeeSubHallMeshList.push(item)

        if (regionMap.currPage != 1){
            item.visible = false
        }

        const imgIndex = item.name.replaceAll("shopopee_ads_door_vertical_", "")

        const imgUrl = `${process.env.BASE_URL}mytextures/cityAdv/city_adv_${imgIndex}.jpg?r=${proxy.$versionNum}`
        const map = texLoader.load(imgUrl)

        const material = new THREE.MeshBasicMaterial({
            map: map,
            lightMap: map,
        })

        createAdvPad(item, material)

        // item.children.forEach((v, i) => {
        //     if (v.name.indexOf("shopopee_ads_door_vertical_") != -1){
        //         v.material = material
        //     }else{
                interactionObj[item.uuid] = [{
                    distance: 5,
                    icon: "fa-solid fa-magnifying-glass",
                    name: i18n.tkey("lang_check"),
                    mesh: item,
                    displayFlag: () => {
                        return regionMap.currPage == 1
                    },
                    callback: () => {
                        proxy.$refs.shopopeePhone.goDisplayImgView(imgUrl)
                    }
                }]
        //     }
        // })

        //上下浮动
        item.position.y += 100
        const key = `animation_${item.uuid}`
        const withAIObj = {
            model: item,
            positionY: item.position.y,
            rotationY: 0,
            offset: 0.66,
            rotationOffset: 0.001,
            sum: 0,
            AI: (obj) => {
                if (obj.sum > 65){
                    obj.offset = -0.66
                }

                if (obj.sum <= -65){
                    obj.offset = 0.66
                }

                obj.sum += obj.offset
                obj.model.position.y = obj.positionY + obj.sum


                if (obj.rotationY > Math.PI / 180 * 10){
                    obj.rotationOffset = -0.001
                }

                if (obj.rotationY <= Math.PI / 180 * -10){
                    obj.rotationOffset = 0.001
                }

                obj.rotationY += obj.rotationOffset
                obj.model.rotation.y = obj.rotationY
            }
        }
        WithAIObjSet[key] = withAIObj

    })

}

function createHallDoorPerson(meshGroup){
    const targetPositionList = []

    meshGroup.children.forEach((v, i) => {
        const vec3 = new THREE.Vector3()
        v.getWorldPosition(vec3)

        vec3.x = vec3.x / 100
        vec3.z = vec3.z / 100

        targetPositionList.push(vec3)
    })

    for (let i=0; i<4; i++){
        const withAIObj = getEmptyWithAIObj()

        withAIObj.login = ""
        withAIObj.name = ""
        withAIObj.memMale = ""
        withAIObj.whatsshopsbcataList = ""
        withAIObj.companyName = ""
        withAIObj.targetPositionList = []

        if (i < 2){
            withAIObj.targetPositionList.push(targetPositionList[0])
            withAIObj.targetPositionList.push(targetPositionList[1])
        }else{
            withAIObj.targetPositionList.push(targetPositionList[3])
            withAIObj.targetPositionList.push(targetPositionList[2])
        }

        withAIObj.nextTargetPosition = withAIObj.targetPositionList[1]
        withAIObj.targetIndex = 1
        withAIObj.offset = -1 + i % 2 * 2

        const promise = new Promise((resolve, reject) => {
            let fileName = "town2/aman.gltf"
            let scaleY = 0.48
            // if (withAIObj.memMale != 0){
            //     fileName = "town2/woman.fbx"
            // }

            if (Math.random() < 0.5){
                fileName = "town2/agirl.gltf"
                scaleY = 0.4
            }

            loadGlbModel(fileName, {
                scaleY: scaleY,
                // castShadow: true,
                loadCallback: (gltf, model) => {
                    withAIObj.model = model
                    //动作
                    const mixer = new THREE.AnimationMixer( model );
                    mixerObj[model.uuid] = mixer

                    withAIObj.allActions = {};

                    let animations = gltf.animations;

                    //遍歷所有動作
                    for ( let i = 0; i !== animations.length; ++ i ) {
                        //動作
                        const clip = animations[ i ];
                        const action = mixer.clipAction( clip );
                        withAIObj.allActions[clip.name ] = action;

                    }

                    withAIObj.activeAction = withAIObj.allActions['idle'];
                    withAIObj.activeAction.play();

                    withAIObj.action = 'idle'

                    resolve()
                },
                callback: (group) => {
                    WithAIObjSet[group.uuid] = withAIObj
                    withAIObj.group = group
                    scene.add(group)

                    group.position.copy(withAIObj.targetPositionList[0])
                    group.position.x += withAIObj.offset * 1

                    withAIObj.model.lookAt(withAIObj.targetPositionList[0])

                    //加载店员的ai
                    withAIObj.AI = hallDoorManAI

                    if (withAIObj.offset > 0){
                        withAIObj.timer_1 = 2.9
                    }

                    shopopeeSubHallMeshList.push(group)

                    if (regionMap.currPage != 1){
                        group.visible = false
                    }

                    // if (null != withAIObj.nextTargetPosition){
                    //     withAIObj.model.lookAt(withAIObj.nextTargetPosition)
                    //     createShopManAnimation(withAIObj)
                    // }

                }
            })

        })

        promise.then(() => {

        })

    }

}

function hallDoorManAI(withAIObj){
    withAIObj.timer_1 += mixerUpdateDelta

    if (withAIObj.action === 'idle'){
        if (withAIObj.timer_1 > 3){
            withAIObj.action = 'waving'
            withAIObj.timer_1 = 0
            toggleActiveMotionObj(withAIObj, "waving")
        }
    }else if(withAIObj.action === 'waving'){
        if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
            withAIObj.action = 'idle_wait'
            withAIObj.timer_1 = 0
            toggleActiveMotionObj(withAIObj, "idle")
        }
    }else if(withAIObj.action === 'idle_wait'){
        if (withAIObj.timer_1 > 3){
            withAIObj.action = 'chating'
            withAIObj.timer_1 = 0

            const randomNum = Math.random()

            if (randomNum < 0.33){
                toggleActiveMotionObj(withAIObj, "talk")
            }else if(randomNum > 0.33 && randomNum < 0.66){
                toggleActiveMotionObj(withAIObj, "clapping")
            }else{
                toggleActiveMotionObj(withAIObj, "talk2")
            }

        }
    }else if(withAIObj.action === 'chating'){
        if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
            withAIObj.action = 'idle_wait'
            withAIObj.timer_1 = 0
            withAIObj.timer_1 += Math.random() - 0.5

            toggleActiveMotionObj(withAIObj, "idle")
        }
    }
}

function getOperateMode(){
    return operateMode
}

function setOperateMode(name){
    rotationNumY = 0
    operateMode = name
    calcCameraPosition()
}

function insertViewRecord(){
    const request = record12Api.insertViewNumAdditionalrecord12
    const params = request.getParams()

    request.send(params, () => {}, () => {}, () => {})

}

function skipAnimation() {
    renderFlag = false

    delete animationObjGroup['Plane01_1']
    delete animationObjGroup['Plane01_2']
    delete animationObjGroup['Plane01_4']

    delete animationObjGroup['Plane01_6']
    delete animationObjGroup['Plane01_7']
    delete animationObjGroup['Plane01_8']
    delete animationObjGroup['Plane01_9']
    delete animationObjGroup['Plane01_10']

    delete animationObjGroup['Plane02_1']
    delete animationObjGroup['Plane02_3']
    delete animationObjGroup['Plane02_3_1']

    delete animationObjGroup['Plane01_walk_1']
    delete animationObjGroup['Plane01_walk_2']
    delete animationObjGroup['Plane01_walk_3']

    delete animationObjGroup['Plane01_car_1']
    startObj2.position.x = 21700
    startObj2.position.y = -19.5
    startObj2.position.z = -5246

    removeWelcomeReporter()
    startInitValue()

    savePersonPosition(217, -5)
    meshGroup.position.x = 217
    meshGroup.position.z = -5
    calcCameraPosition()
    upperRightUiVisibleForAnimation.value = false

    setTimeout(() => {
        renderFlag = true
        regionMap.airShipAdvVisible = true

        if (regionMap.guideFlag) {
            regionMap.guideFlag = false

            if (myUtil.isNotEmpty(props.did)){
                movePersonToShopPosition(props.did)
            }
        }

    }, 150)
}

function startInitValue() {
    audioManager.playbgAudio()

    meshGroup.position.x = userInfoRef.value.positionX
    meshGroup.position.z = userInfoRef.value.positionZ

    camera.far = 150
    camera.updateProjectionMatrix()

    startObj.position.x = 20022
    startObj.position.y = 0
    startObj.position.z = -5440
    startObj.rotation.x = 0
    startObj.rotation.y = Math.PI / 2
    startObj.rotation.z = 0

    // startObj2.position.z = 5000
    startObj2.visible = true

    toggleActiveMotion("idle")
    // rotationNum = camera.rotation.y
    rotationNum = 4.69
    scene.remove(camera)
    meshGroup.add(camera)
    // 将世界坐标转换为局部坐标
    meshGroup.worldToLocal(camera.position);

    const positionX = 0
    const positionY = cameraOptionObj.defalutCameraPositionY
    const positionZ = - cameraOptionObj.defaultCameraDistance

    const rotationX = 0 - Math.PI
    const rotationY = 0
    const rotationZ = Math.PI

    // const rotationX = 0
    // const rotationY = 0
    // const rotationZ = 0

    moveGuideManPoint()

    camera.position.x = positionX
    camera.position.y = positionY
    camera.position.z = positionZ

    camera.rotation.x = rotationX
    camera.rotation.y = rotationY
    camera.rotation.z = rotationZ

    controlFlag = true
    bottomInteractionUiVisible.value = true
    upperRightUiVisible.value = true
    nippleViewVisible.value = true
    proxy.$refs.operationNipple.style.display = "block"

    regionMap.airShipAdvVisible = true
}

function generateGoIslandPad(object, text) {
    if (null == text){
        text = i18n.tkey("lang_go_other_island")
    }

    let fontsize = 360 / text.length
    let xLeft

    if (fontsize > 80){
        fontsize = 80
    }

    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d')
    canvas.width = 400
    canvas.height = 300
    //制作矩形
    // ctx.fillStyle = "transparent";
    ctx.fillStyle = "#ff0000";
    // ctx.drawImage(shopSignTexture, 0, 0, 1200, 200)
    ctx.fillRect(0, 0, 400, 300)
    //设置文字
    ctx.fillStyle = "#ffffff";
    // ctx.fillStyle = "#000000";
    ctx.font = `normal ${fontsize}px "楷体"`
    const textWidth = ctx.measureText(text).width;
    xLeft = 20 + (360 - textWidth) / 2
    ctx.fillText(text, xLeft, 150 + fontsize / 2)

    //生成图片
    let url = canvas.toDataURL('image/png');
    canvas.remove()

    let map = texLoader.load(url)
    map.center.set(0.5, 0.5)
     map.rotation = Math.PI
     map.flipY = false

    const material = new THREE.MeshBasicMaterial({
        map: map,
        lightmap: map,
        // side: THREE.DoubleSide,
        // opacity: 1,
        // transparent: true
    })

    object.material = material
}

//創建迎賓人員
function createUsher(positionGroup) {
    const withAIObj = getEmptyWithAIObj()

    withAIObj.login = ""
    withAIObj.name = ""
    withAIObj.memMale = ""
    withAIObj.whatsshopsbcataList = ""
    withAIObj.companyName = ""

    // let scaleY = 1

    // loadFbxModel("town2/boy21.fbx", {
    loadGlbModel("town2/agirl.gltf",{
        // positionX: -12,
        // positionY: 0,
        // positionZ: -30,
        scaleY: 0.48,
        loadCallback: (gltf,model) => {
            withAIObj.model = model

            const mixer = new THREE.AnimationMixer( model );
            mixerObj[model.uuid] = mixer

            withAIObj.allActions = {};

            let animations = gltf.animations;

            for ( let i = 0; i !== animations.length; ++ i ) {
                //動作
                const clip = animations[ i ];
                const action = mixer.clipAction( clip );
                withAIObj.allActions[clip.name ] = action;

            }

            withAIObj.activeAction = withAIObj.allActions['waving'];
            withAIObj.activeAction.play();

            withAIObj.action = 'waving'

            model.traverse( function ( object ) {
                if ( object.isMesh ) {
                    object.material.emissive = null;
                    object.material.emissiveIntensity = 0;
                    object.material.emissiveMap = null;
                }
            });

        },
        callback: (group) => {

            WithAIObjSet[group.uuid] = withAIObj
            withAIObj.group = group

            // 加载店员的ai
            withAIObj.AI = usherAI

            const vec3 = new THREE.Vector3()
            positionGroup.getWorldPosition(vec3)

            scene.add(group)
            group.position.x = vec3.x
            group.position.z = vec3.z
            group.rotation.y = Math.PI / 2 + Math.PI / 4

        }
    })
}

//店员的ai
function usherAI(withAIObj) {
    const vec3 = new THREE.Vector3()

    withAIObj.group.getWorldPosition(vec3)

    // const distance = meshGroup.position.distanceTo(withAIObj.group.position)
    const distance = meshGroup.position.distanceTo(vec3)

    withAIObj.timer_1 += mixerUpdateDelta

    if (distance < 6 ){

        if (null != animationObjGroup[withAIObj.group.uuid]){
            animationObjGroup[withAIObj.group.uuid].pause()
        }

        if (withAIObj.action === 'idle' || withAIObj.action === 'walk_normal'){
            if (withAIObj.action !== 'waving'){
                withAIObj.action = 'waving'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "waving")
            }
        }else if(withAIObj.action === 'waving'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if (withAIObj.action === 'idle_wait'){
            if (withAIObj.timer_1 > 6){
                withAIObj.action = 'waving'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "waving")
            }
        }else if(withAIObj.action === 'deliver_card_wait'){
            withAIObj.action = 'deliver_card'
            withAIObj.timer_1 = 0
            toggleActiveMotionObj(withAIObj, "talk2")
        }else if(withAIObj.action === 'deliver_card'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'chat_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if(withAIObj.action === 'chat_wait'){
            if (withAIObj.timer_1 > 4){
                withAIObj.action = 'chatting'
                withAIObj.timer_1 = 0

                const randomNum = Math.random()

                if (randomNum < 0.5){
                    toggleActiveMotionObj(withAIObj, "talk")
                }else{
                    toggleActiveMotionObj(withAIObj, "clapping")
                }

            }
        }else if(withAIObj.action === 'chatting'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'chat_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if(withAIObj.action === 'chat_complete'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }


        withAIObj.model.lookAt(meshGroup.position)
    }else{
        if (withAIObj.action === 'waving'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }
    }

}

//獲取島嶼列表
function getIslandList(callback){
    const request = record14Api.getIslandInfoList
    const params = request.getParams()

    params.recordno = -1
    params.addinfo17 = "-1"

    request.send(params, (res) => {
        if (res.code == 200){
            let list = res.detail

            for (let i=0; i<list.length; i++){
                const obj = list[i]

                if (obj.companycode === "ZZ"){
                    const temp = list[0]
                    list[0] = obj
                    list[i] = temp
                }

                if (null == userInfoRef.value.islandID && obj.companycode === "ZZ"){
                    currIsland = obj
                }else if(obj.id == userInfoRef.value.islandID){
                    currIsland = obj
                }

            }

            islandDataList = res.detail

            if (null != callback && typeof callback === "function"){
                callback()
            }

        }else{
            myUtil.alertError(res.msg)
        }

    })
}

//創建島嶼招牌
// function generateIslandNameMesh() {
//     if (islandDataList.length > 0){
//         const vec3 = new THREE.Vector3()
//         const padGeometry = new THREE.PlaneGeometry(5.5, 3);
//         const backMaterial = new THREE.MeshBasicMaterial({
//             color: 0xff0000,
//             // side: THREE.DoubleSide
//         })
//         let positionY = 0
//         const eventList = []
//
//         islandNamePadMesh.getWorldPosition(vec3)
//         vec3.x /= 100
//         vec3.z /= 100
//         positionY = 1.5
//
//         islandDataList.forEach((v, i) => {
//             if (v.id == userInfoRef.value.islandID || (null == userInfoRef.value.islandID && v.companycode == "ZZ")){
//                 return
//             }
//
//             let islandName = v.addinfo6
//             let imgUrl = v.addinfo12
//             const mesh = new THREE.Mesh(padGeometry, null)
//             const backMesh = new THREE.Mesh(padGeometry, backMaterial)
//
//             if(userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(islandName)){
//                 islandName = v.recordname
//             }
//
//             if(userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(imgUrl)){
//                 imgUrl = v.addinfo11
//             }
//
//             if (myUtil.isEmpty(imgUrl)){
//                 generateGoIslandPad(mesh, islandName)
//             }else{
//                 const map = texLoader.load(imgUrl, (texture) => {
//                     texture.colorSpace = THREE.SRGBColorSpace
//                     // texture.flipY = false
//                     texture.generateMipmaps = false
//                     texture.center.set(0.5, 0.5)
//                     texture.rotation = Math.PI
//                 });
//
//                 const material = new THREE.MeshBasicMaterial({ //普通材质
//                     // color: 0xffffff,
//                     map: map,
//                 });
//
//                 mesh.material = material
//
//             }
//
//             // mesh.material.side = THREE.DoubleSide
//             scene.add(mesh)
//             scene.add(backMesh)
//             mesh.position.copy(vec3)
//             backMesh.position.copy(vec3)
//             backMesh.position.y = positionY
//             backMesh.rotation.y = 2.6 - Math.PI
//             backMesh.rotation.z = Math.PI
//
//
//             mesh.position.y = positionY
//             mesh.rotation.y = 2.6
//             mesh.rotation.z = Math.PI
//             positionY += 3.2
//
//             if (v.id != userInfoRef.value.islandID){
//                 if (!(userInfoRef.value.islandID == null && v.companycode == "ZZ")){
//                     eventList.push({
//                         distance: 8,
//                         icon: "fa-solid fa-plane-departure",
//                         name: islandName,
//                         // mesh: shopList[index].children[0],
//                         mesh: islandNamePadMesh,
//                         callback: () => {
//                             myUtil.confirmWarning(i18n.tkey("lang_select_region_confirm") + `?` , () => {
//                                 userInfoRef.value.currPage = 1
//
//                                 if (v.companycode == "ZZ"){
//                                     proxy.$router.push({path: `/index`})
//                                 }else{
//                                     proxy.$router.push({path: `/${v.id}/index`})
//                                 }
//
//                                 if (proxy.$route.path.indexOf("/index") != -1){
//                                     reload()
//                                 }
//                             })
//                         }
//                     })
//                 }
//
//             }
//
//         })
//
//         if (eventList.length > 0){
//             interactionObj[`island_namepad_host`] = eventList
//         }
//
//     }
// }

//創建島嶼招牌
function generateIslandNameMesh() {
    if (islandDataList.length > 0){
        const vec3 = new THREE.Vector3()
        let positionY = 0
        const eventList = []

        islandNamePadMesh.getWorldPosition(vec3)
        vec3.x /= 100
        vec3.z /= 100
        positionY = 1.5

        islandDataList.forEach((v, i) => {
            if (v.id == userInfoRef.value.islandID || (null == userInfoRef.value.islandID && v.companycode == "ZZ") || v.addinfo21 == "-1"){
                return
            }

            let islandName = v.addinfo6
            let imgUrl = v.addinfo12

            if(userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(islandName)){
                islandName = v.recordname
            }

            if(userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh" || myUtil.isEmpty(imgUrl)){
                imgUrl = v.addinfo11
            }

            loadGlbModel("island/landsign.gltf",{
                scaleY: 3,
                loadCallback: (gltf, model) => {
                    model.traverse( (object) => {
                        if (object.name === "land_sign_imge"){
                            if (myUtil.isEmpty(imgUrl)){
                                generateGoIslandPad(object, islandName)
                            }else{
                                const map = texLoader.load(imgUrl, (texture) => {
                                    texture.colorSpace = THREE.SRGBColorSpace
                                    texture.flipY = false
                                    texture.generateMipmaps = false
                                    texture.center.set(0.5, 0.5)
                                    texture.rotation = Math.PI
                                });

                                const material = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: map,
                                });

                                object.material = material

                            }
                        }
                    })
                },
                callback: (group) => {
                    scene.add(group)
                    group.position.copy(vec3)

                    group.position.y = positionY
                    group.rotation.y = 2.6
                    group.rotation.z = Math.PI
                    positionY += 3.2
                }
            })


            if (v.id != userInfoRef.value.islandID){
                if (!(userInfoRef.value.islandID == null && v.companycode == "ZZ")){
                    eventList.push({
                        distance: 8,
                        icon: "fa-solid fa-plane-departure",
                        name: islandName,
                        // mesh: shopList[index].children[0],
                        mesh: islandNamePadMesh,
                        callback: () => {
                            myUtil.confirmWarning(i18n.tkey("lang_select_region_confirm") + `?` , () => {
                                userInfoRef.value.currPage = 1
                                userInfoRef.value.areacode = null
                                if (v.companycode == "ZZ"){
                                    proxy.$router.push({path: `/index`})
                                }else{
                                    proxy.$router.push({path: `/${v.id}/index`})
                                }

                                if (proxy.$route.path.indexOf("/index") != -1){
                                    reload()
                                }
                            })
                        }
                    })
                }

            }

        })

        if (eventList.length > 0){
            interactionObj[`island_namepad_host`] = eventList
        }

    }
}

//創建島嶼地圖
function generateIslandMapMesh() {
    // return;

    if (userInfoRef.value.selectCountry != "HK"){
        return
    }

    const vec3 = new THREE.Vector3()
    let positionY = 0

    islandNamePadMesh.getWorldPosition(vec3)
    vec3.x /= 100
    vec3.z /= 100
    // positionY = 0.1

    loadGlbModel("island/landsign.gltf",{
        scaleY: 3,
        loadCallback: (gltf, model) => {
            model.traverse( (object) => {
                if (object.name === "land_sign_imge"){
                    const map = texLoader.load(`${publicPath}static/images/hkMap.png`, (texture) => {
                        texture.colorSpace = THREE.SRGBColorSpace
                        texture.flipY = false
                        texture.generateMipmaps = false
                        texture.center.set(0.5, 0.5)
                        texture.rotation = Math.PI
                    });

                    const material = new THREE.MeshBasicMaterial({ //普通材质
                        // color: 0xffffff,
                        map: map,
                    });

                    object.material = material

                }
            })
        },
        callback: (group) => {
            scene.add(group)
            group.position.copy(vec3)

            group.position.y = positionY
            group.rotation.y = 2.6
            group.rotation.z = Math.PI
            // positionY += 3.2

            group.position.x += 5
            // group.position.y += 3.2
            group.position.y += 1.6
            group.position.z += 3

            interactionObj[group.uuid] = [{
                distance: 10,
                icon: "fa-solid fa-map",
                name: i18n.tkey("lang_hongkong_map"),
                // mesh: shopList[index].children[0],
                mesh: group,
                callback: () => {
                    mapSelectorVisible.value = true
                }
            }]
        }
    })
}

function clickInteractionCallback(value){
    if(null != value && null != value.callback && typeof value.callback === "function"){
        value.callback()
    }
}

function createHallRoadSign(){
    const text = `← ${i18n.tkey("lang_hall_2")}`
    const text2 = `${i18n.tkey("lang_hall_2")} →`

    let planeGeo = new THREE.PlaneGeometry(4, 3)
    const material = createRoadSignMaterial(text)

    const material2 = createRoadSignMaterial(text2)

    const mesh = new THREE.Mesh(planeGeo, material)
    const mesh2 = new THREE.Mesh(planeGeo, material2)
    scene.add(mesh)
    scene.add(mesh2)


    mesh.position.x = 421
    mesh.position.y = 4
    mesh.position.z = 38

    mesh2.position.x = 421
    mesh2.position.y = 4
    mesh2.position.z = 37.9
    mesh2.rotation.y = Math.PI


}
//指示路牌
function createRoadSignMaterial(text){
    let fontsize = 360 / text.length
    let xLeft

    if (fontsize > 230){
        fontsize = 230
    }

    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d')
    canvas.width = 400
    canvas.height = 300
    //制作矩形
    ctx.fillStyle = "transparent";
    // ctx.fillStyle = "#ff0000";
    // ctx.drawImage(shopSignTexture, 0, 0, 1200, 200)
    ctx.fillRect(0, 0, 400, 300)
    //设置文字
    // ctx.fillStyle = "#ffffff";
    ctx.fillStyle = "#ff0000";
    ctx.font = `normal ${fontsize}px "楷体"`
    const textWidth = ctx.measureText(text).width;
    xLeft = 20 + (360 - textWidth) / 2
    ctx.fillText(text, xLeft, 140 + fontsize / 2)

    //生成图片
    let url = canvas.toDataURL('image/png');

    let map = texLoader.load(url)
    // map.flipY = false

    canvas.remove()

    const material = new THREE.MeshBasicMaterial({
        map: map,
        // side: THREE.DoubleSide,
        opacity: 1,
        transparent: true
    })

    return material
}

function createAdvPad(parentGroup, advMaterial) {
    loadGlbModel("island/ban.gltf",{
        loadCallback: (gltf,model) => {
            model.traverse( (object) => {
                if (object.name.indexOf("shopopee_ads_door_vertical_") != -1){
                    object.material = advMaterial
                    object.visible = false
                    let boxGeometry = new THREE.PlaneGeometry(0.8, 1.2)
                    const mesh = new THREE.Mesh(boxGeometry, advMaterial)
                    const mesh2 = new THREE.Mesh(boxGeometry, advMaterial)
                    object.parent.add(mesh)
                    object.parent.add(mesh2)
                    mesh.position.x = object.position.x
                    mesh.position.y = object.position.y
                    mesh.position.z = object.position.z - 0.06
                    mesh.rotation.y = - Math.PI

                    mesh2.position.x = object.position.x
                    mesh2.position.y = object.position.y
                    mesh2.position.z = object.position.z + 0.06
                }
            })
        },
        callback: (group) => {
            // const vec3 = new THREE.Vector3()
            // parentGroup.getWorldPosition(vec3)

            parentGroup.add(group)
            // group.position.x = vec3.x
            group.position.y = 300
            // group.position.z = vec3.z

            group.scale.x = 500
            group.scale.y = 500
            group.scale.z = 500
        }
    })
}

function closeIslandCallback(){
    // reload()
}

function createSightseeingCar(pointList) {
    // let boxGeometry = new THREE.BoxGeometry(1, 1, 1)
    // let lambertMaterial = new THREE.MeshBasicMaterial({
    //     color: 0xff0000
    // })
    //
    // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
    // scene.add(mesh)
    //
    // const vec3 = pointList[2000]
    // mesh.position.x = vec3.x
    // mesh.position.y = vec3.y
    // mesh.position.z = vec3.z


    const withAIObj = getEmptyWithAIObj()
    // const randomNum = Math.floor(Math.random() * 400) + 200 + i * 200
    const randomNum = 3450
    // const randomNum = i * 40
    const currPosition = pointList[randomNum]

    withAIObj.speed = 4
    // withAIObj.group = null
    // withAIObj.model = null
    // withAIObj.model.rotation.y = Math.PI / 180 * 180
    withAIObj.action = "wait"
    withAIObj.name = "SightseeingCar"
    // withAIObj.targetPositionList = pointList
    // withAIObj.targetIndex = randomNum + 1
    // withAIObj.nextTargetPosition = pointList[withAIObj.targetIndex]
    withAIObj.wheelList = []
    withAIObj.speed = 0.024
    withAIObj.direction = null
    // WithAIObjSet[v.uuid] = withAIObj


    //創建觀光路徑1
    let SightseePath = []
    SightseePath.push(new THREE.Vector3(228, 0, 47))
    SightseePath.push(new THREE.Vector3(286, 0, 42))
    SightseePath.push(new THREE.Vector3(303, 0, 42))
    SightseePath.push(new THREE.Vector3(413, 0, 42))
    SightseePath.push(new THREE.Vector3(545, 0, 42))

    SightseePath.push(new THREE.Vector3(565, 0, 38))
    SightseePath.push(new THREE.Vector3(545, 0, 34))
    SightseePath.push(new THREE.Vector3(413, 0, 34))
    SightseePath.push(new THREE.Vector3(303, 0, 34))
    SightseePath.push(new THREE.Vector3(286, 0, 34))

    let pathCurve = new THREE.CatmullRomCurve3(SightseePath, false);
    SightseePath = pathCurve.getPoints(1000)

    //创建观光路径2
    let SightseePath2 = []
    SightseePath2.push(new THREE.Vector3(286, 0, 34))
    SightseePath2.push(new THREE.Vector3(278, 0, 33))
    SightseePath2.push(new THREE.Vector3(278, 0, 18))
    SightseePath2.push(new THREE.Vector3(278, 0, 7))
    SightseePath2.push(new THREE.Vector3(278, 0, -54))
    // SightseePath2.push(new THREE.Vector3(278, 0, -54))
    SightseePath2.push(new THREE.Vector3(285, 0, -64))
    SightseePath2.push(new THREE.Vector3(316, 0, -64))
    SightseePath2.push(new THREE.Vector3(520, 0, -63))
    SightseePath2.push(new THREE.Vector3(554, 0, -64))
    SightseePath2.push(new THREE.Vector3(564, 0, -56))

    SightseePath2.push(new THREE.Vector3(563, 0, -9))
    SightseePath2.push(new THREE.Vector3(563, 0, 130))
    SightseePath2.push(new THREE.Vector3(557, 0, 140))
    SightseePath2.push(new THREE.Vector3(521, 0, 140))
    SightseePath2.push(new THREE.Vector3(290, 0, 140))
    SightseePath2.push(new THREE.Vector3(279, 0, 133))
    SightseePath2.push(new THREE.Vector3(279, 0, 91))
    SightseePath2.push(new THREE.Vector3(279, 0, 56))
    SightseePath2.push(new THREE.Vector3(285, 0, 42))
    SightseePath2.push(new THREE.Vector3(303, 0, 42))

    pathCurve = new THREE.CatmullRomCurve3(SightseePath2, false);
    SightseePath2 = pathCurve.getPoints(2000)

    // SightseePath.push(new THREE.Vector3(pointList[randomNum].x, 0, pointList[randomNum].z))
    // SightseePath.push(new THREE.Vector3(pointList[randomNum + 100].x, 0, pointList[randomNum + 100].z))



    // let boxGeometry = new THREE.BoxGeometry(1, 1, 1)
    // let lambertMaterial = new THREE.MeshBasicMaterial({
    //     color: 0xff0000
    // })
    //
    // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
    // scene.add(mesh)
    //
    // mesh.position.x = 286
    // mesh.position.z = 34
    //
    // const gui = new GUI()
    // gui.add(mesh.position, "x").step(1)
    // gui.add(mesh.position, "z").step(1)

    withAIObj.currPathKey = "SightseePath"
    withAIObj.normalPath = SightseePath2
    withAIObj.SightseePath = SightseePath
    withAIObj.targetPositionList = SightseePath
    withAIObj.targetIndex = 0
    withAIObj.nextTargetPosition = SightseePath[1]
    withAIObj.cycleCount = 0
    // withAIObj.action = "wait"

    loadFbxModel("island/SM_Veh_Convertable_02.fbx", {
        scaleY: 2,
        loadCallback: (model) => {
            model.rotation.y = Math.PI / 2
            model.traverse( function ( object ) {
                if (object.name === "SM_Veh_Convertable_Glass"){
                    object.visible = false
                }

                if (object.name.indexOf("SM_Veh_Convertable_Wheel") != -1){
                    withAIObj.wheelList.push(object)
                }
            })

            withAIObj.model = model

            setTimeout(() => {
                withAIObj.AI = SightseeingTaxiAI
                WithAIObjSet[model.uuid] = withAIObj
                taxiObj.value = withAIObj
            }, 1000)

        },
        callback: (group) => {
            scene.add(group)

            withAIObj.group = group
            withAIObj.withPerson = false
            // group.position.x = currPosition.x
            // group.position.y = currPosition.y
            // group.position.z = currPosition.z

            group.position.x = 228
            group.position.y = 0
            group.position.z = 47

            interactionObj[group.uuid] = [
                {
                    distance: 8,
                    icon: "fa-solid fa-taxi",
                    name: i18n.tkey("lang_ride"),
                    mesh: group,
                    callback: () => {
                        goTaxi()
                    }
                },
            ]
        }
    })
}

function goTaxi() {
    taxiObj.value.withPerson = true
    taxiObj.value.action = "ride_init"
    bottomUIObj.value = {}

    // const vec3 = new THREE.Vector3()
    // taxiObj.value.model.getWorldDirection(vec3)
    // console.log(vec3)

    rotationNum = Math.PI
    calcCameraPosition()
}

function createWelcomeReporter() {
    loadGlbModel("town2/welcome.glb", {
        scaleY: 3,
        loadCallback: (gltf, modelData) => {

        },
        callback: (group) => {
            scene.add(group)

            group.visble = false
            group.position.x = 217
            group.position.z = -8
            group.rotation.y = - Math.PI

            regionMap.reporterObj = group

            loadingPercent.value += 1

            setTimeout(() => {
                removeWelcomeReporter()
            }, 60000)
        }
    })
}

//创建飞艇
function createAirShip() {
    loadGlbModel("island/airship.gltf", {
        loadCallback: (gltf, modelData) => {
            modelData.traverse( (object) => {
                if (object.name === "Airship_ad"){
                    object.visible = false
                    regionMap.airShipAdvPad = object
                }
            })
        },
        callback: (group) => {
            scene.add(group)

            regionMap.airShipObj = group

            group.visble = false
            group.position.x = -1000
            group.position.y = -1000
            group.position.z = 0

            // const gui = new GUI()
            // gui.add(group.position, "x").step(1)
            // gui.add(group.position, "y").step(1)
            // gui.add(group.position, "z").step(1)
            // gui.add(group.rotation, "y").step(1)

            loadingPercent.value += 1
        }
    })
}

function removeWelcomeReporter(){
    try {
        disposeMesh(regionMap.reporterObj)
        regionMap.reporterObj = null
    }catch (e){
        console.log(e)
    }
}

//播放飞艇广告动画
function showAirShipAnimation(){
    const orgRotationNumY = rotationNumY
    regionMap.airShipAdvVisible = false
    regionMap.airAdvPlayFlag = true
    regionMap.airShipAdvTimer = 0
    controlFlag = false
    moveFlag = false
    speed = 0
    bottomInteractionUiVisible.value = false
    upperRightUiVisible.value = false
    nippleViewVisible.value = false

    //移动飞艇
    regionMap.airShipObj.visible = true
    regionMap.airShipObj.position.x = meshGroup.position.x + 70
    regionMap.airShipObj.position.y = 60
    regionMap.airShipObj.position.z = meshGroup.position.z - 70

    //獲取當前廣告數據
    const advDataObj = advList[regionMap.airAdvIndex]

    regionMap.airAdvIndex += 1

    if (regionMap.airAdvIndex >= advList.length){
        regionMap.airAdvIndex = 0
    }

    let object = new THREE.Group()
    let div = null
    let iframe = null

    if (false && myUtil.isNotEmpty(advDataObj.addinfo2) && myUtil.isEmpty(advDataObj.addinfo3)){
        //隱藏原來的廣告牌
        regionMap.airShipAdvPad.visible = false

        //創建廣告的css3dObject對象
        const div = document.createElement( 'div' );
        div.style.width = '480px';
        div.style.height = '360px';
        div.style.position = 'relative';
        div.style.backgroundColor = '#00ff00';

        const imgDom = document.createElement( 'img' );
        imgDom.style.width = '480px';
        imgDom.style.height = '360px';
        imgDom.style.left = '0';
        imgDom.style.top = '0';
        imgDom.style.position = 'absolute';
        imgDom.style["z-index"] = '-1';
        imgDom.setAttribute("src", proxy.$ShopopeeUrl + advDataObj.addinfo5)
        div.appendChild( imgDom );


        const iframe = document.createElement( 'iframe' );
        iframe.style.width = '480px';
        iframe.style.height = '360px';
        iframe.style.border = '0px';
        imgDom.style.left = '0';
        imgDom.style.top = '0';
        imgDom.style.position = 'absolute';
        imgDom.style["z-index"] = '3';
        iframe.src = [ advDataObj.addinfo2, '?rel=0&autoplay=1' ].join( '' );
        // iframe.src = [ "https://player.youku.com/embed/XNTIwMDAwNTkzMg==", '?rel=0' ].join( '' );
        iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share")
        iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin")
        div.appendChild( iframe );

        object = new CSS3DObject( div );
        object.rotation.y = Math.PI / -2;
        object.scale.set(0.05, 0.04, 0.05);

        scene.add(object)
    }else{
        //加載視頻
        // const videoDom = document.createElement( 'video' );
        // videoDom.style.width = '480px';
        // videoDom.style.height = '360px';
        // // videoDom.style.display = 'none';
        // videoDom.setAttribute("src", advDataObj.addinfo3)
        //
        // setTimeout(() => {
        //     videoDom.play()
        // }, 500)
        //
        // const shopopeeAdsPlaneTex = new THREE.VideoTexture(videoDom);
        // shopopeeAdsPlaneTex.center.set(0.5, 0.5)
        // shopopeeAdsPlaneTex.rotation = 90 * Math.PI / 180
        //
        // const videoMaterial = new THREE.MeshBasicMaterial({ //普通材质
        //     color: 0xffffff,
        //     map: shopopeeAdsPlaneTex,
        //     // side: THREE.DoubleSide
        // });
        //
        // regionMap.airShipAdvPad.material = videoMaterial

        //加載封面
        const map = texLoader.load(advDataObj.addinfo5, (texture) => {
            texture.colorSpace = THREE.SRGBColorSpace
            texture.flipY = false
            regionMap.airShipAdvPad.material.map = texture
            // texture.generateMipmaps = false
            // texture.center.set(0.5, 0.5)
            // texture.rotation = Math.PI

            const videoMaterial = new THREE.MeshBasicMaterial({ //普通材质
                color: 0xffffff,
                map: texture,
                // side: THREE.DoubleSide
            });

            regionMap.airShipAdvPad.material = videoMaterial
        });

        //顯示原來的廣告牌
        regionMap.airShipAdvPad.visible = true
    }


    const obj = {
        num: rotationNum,
        numY: rotationNumY
    }

    const tween = new TWEEN.Tween(obj)
        .to({num: Math.PI - Math.PI / 180 * 40, numY: 0.05}, 1000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.InOut)
        .onComplete(() => {
            delete animationObjGroup["changeCamera_airship_1"]

            const tween3 = new TWEEN.Tween(obj)
                .to({num: Math.PI + Math.PI / 180 * 40}, 10000)
                .start()
                .easing(TWEEN.Easing.Sinusoidal.InOut)
                .onComplete(() => {
                    delete animationObjGroup["animation_airship_2"]

                    controlFlag = true
                    bottomInteractionUiVisible.value = true
                    upperRightUiVisible.value = true
                    nippleViewVisible.value = true

                    regionMap.airShipObj.position.x = -1000
                    regionMap.airShipObj.position.y = -1000
                    regionMap.airShipObj.position.z = 0
                    regionMap.airShipObj.visible = false

                    regionMap.airAdvPlayFlag = false

                    regionMap.airShipAdvPad.visible = false
                    regionMap.airShipAdvPad.material.map = null

                    rotationNumY = orgRotationNumY
                    calcCameraPosition()

                    object.visible = false
                    scene.remove(object)

                    try {
                        if(null != iframe){
                            iframe.remove()
                        }

                        if(null != div){
                            div.remove()
                        }

                        disposeMesh(object)
                    }catch (e){
                        console.log(e)
                    }

                    //十分钟触发一次
                    setTimeout(() => {
                        regionMap.airShipAdvVisible = true
                    }, 60000*60*24)
                })
                .onUpdate(() => {
                    rotationNum = obj.num
                    calcCameraPosition()
                })

            animationObjGroup["animation_airship_2"] = tween3
        })
        .onUpdate(() => {
            rotationNum = obj.num
            rotationNumY = obj.numY
            calcCameraPosition()
        })

    animationObjGroup["changeCamera_airship_1"] = tween

    const tween2 = new TWEEN.Tween(regionMap.airShipObj.position)
        .delay(1000)
        .to({z: meshGroup.position.z + 70}, 11000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.InOut)
        .onComplete(() => {
            delete animationObjGroup["animation_airship_1"]
        })
        .onUpdate(() => {
            const vec3 = new THREE.Vector3()

            regionMap.airShipAdvPad.getWorldPosition(vec3)
            object.position.copy(vec3)

        })

    animationObjGroup["animation_airship_1"] = tween2
}

function checkAdvVisble(){
    if (regionMap.airShipAdvVisible && process.env.NODE_ENV === 'production'){
        // console.log("shopopeeChatVisible: " + shopopeeChatVisible.value)
        // console.log("confirmVisible: " + confirmVisible.value)
        // console.log("chatVisible: " + chatVisible.value)
        // console.log("cardVisible: " + cardVisible.value)
        // console.log("selectAreaVisible: " + selectAreaVisible.value)
        // console.log("reportVisible: " + reportVisible.value)
        // console.log("hallVisible: " + hallVisible.value)
        // console.log("langSelectVisible: " + langSelectVisible.value)
        // console.log("selectCountryVisible: " + selectCountryVisible.value)
        // console.log("islandSelectVisible: " + islandSelectVisible.value)
        // console.log("shareUrlVisible: " + shareUrlVisible.value)
        // console.log(regionMap.airShipAdvTimer)
        // console.log("=========================================================")

        if (moveFlag || shopopeeChatVisible.value || confirmVisible.value || chatVisible.value || cardVisible.value
            || selectAreaVisible.value || reportVisible.value || hallVisible.value || langSelectVisible.value
            || selectCountryVisible.value || islandSelectVisible.value || shareUrlVisible.value || advVideoVisible.value || mousedownFlag){
            regionMap.airShipAdvTimer = 0
        }else{
            regionMap.airShipAdvTimer += mixerUpdateDelta

            if (regionMap.airShipAdvTimer > 6){
              var dmt=util.formatDate(new Date(), 'yyyy/MM/dd')
              if(dmt>userInfoRef.value.airShipAdvTimer){
                userInfoRef.value.airShipAdvTimer = dmt
                showAirShipAnimation()
              }
            }
        }

    }
}

function selectHkDistrictCallback(obj){
    mapSelectorVisible.value = false

    let isDifferent = false

    if(userInfoRef.value.areacode != obj.code ){
        userInfoRef.value.areacode = obj.code
        userInfoRef.value.currPage = 1
        isDifferent = true
    }

    if(myUtil.isNotEmpty(userInfoRef.value.areacode)){
        proxy.$router.push({path: `/islandArea`})
    }else{
        // if(isDifferent){
        //     reload()
        // }else{
            toggleSelectAreaBox(true)
            proxy.$router.push({path: `/index`})
        // }
    }

    setTimeout(() => {
        reload()
    }, 100)

	// userInfoRef.value.areacode = obj.code
	// userInfoRef.value.currPage = 1
	// // reload()
    //
    // proxy.$router.push({path: `/islandArea`})

}

function playMoveToShopAnimation(shopData){
    const orgRotationNumY = rotationNumY

    controlFlag = false
    const obj = {
        y: rotationNumY
    }

    const tween = new TWEEN.Tween(obj)
        .to({y: 0.1}, 1000)
        .delay(1000)
        .start()
        .easing(TWEEN.Easing.Sinusoidal.InOut)
        .onUpdate(() => {
            rotationNumY = obj.y
            calcCameraPosition()
        })
        .onComplete(() => {
            delete animationObjGroup["move_to_shop_animation_1"]

            advRecord.value = generateAdvObj(shopData)
            advVideoVisible.value = true

            setTimeout(() => {
                // rotationNumY = orgRotationNumY
                // calcCameraPosition()
                controlFlag = true
            }, 1000)

        })

    animationObjGroup["move_to_shop_animation_1"] = tween
}

function generateAdvObj(shopData){
    const obj = {
        companycode: shopData.companyCode,
        advId: shopData.advId,
        advTitle: shopData.advTitle,
        advDes: shopData.advDes,
        advImg: shopData.advImg,
        advUrl: shopData.advUrl,
        advVideoPath: shopData.advVideoPath,
        fbUrl: shopData.fbUrl,
        redUrl: shopData.redUrl,
        titokUrl: shopData.titokUrl,
        ytbUrl: shopData.ytbUrl,
    }

    return obj
}

function goChatCallback(obj) {
    chatCardId.value = null
    chatSelectorVisible.value = false
  var dlangStr=""
  if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
       dlangStr="&lang=HK"
  }
  var url = `${baseUrl.SSL}://${baseUrl.eshopopee}/AIPage/AISales.asp?ChatCom=CCA5C1B4_${obj.accCompanyCode}${dlangStr}`
  window.open(url, 'AIChat','resizable,height=680,width=370')
/*
   打開shopopee的聊天
    openNewChat(obj.login)
    bottomInteractionUiVisible.value = false
    upperRightUiVisible.value = false
    nippleViewVisible.value = false

    controlFlag = false*/
}

function gostoreWebsiteCallBack(obj){
  seleteStor.value = null
  companySelectorVisible.value = false

  bottomInteractionUiVisible.value = false
  upperRightUiVisible.value = false
  nippleViewVisible.value = false

  controlFlag = false
   openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyName} ${i18n.tkey("lang_go_shop_confirm_3")}`, () => {

               savePersonPosition()

               const url = myUtil.generateEshopopeeLoginAndJumpUrl(
                   "/three",
                   myUtil.isEmpty(userInfoRef.value.login) ? "" : userInfoRef.value.login,
                   myUtil.isEmpty(userInfoRef.value.password) ? "" : userInfoRef.value.password,
                   [obj.accCompanyCode]
               )

               myUtil.goURLNewWindow(url, "eshopopee")
               // proxy.$router.push({path: `/pe/${obj.companyHallId}`})
           })
}
//生成岛屿标题
function generateIslandTitle(object, text) {
    if (null == text){
        text = i18n.tkey("lang_go_other_island")
    }

    let fontsize = 500 / text.length
    let xLeft

    if (fontsize > 40){
        fontsize = 40
    }

    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d')
    canvas.width = 500
    canvas.height = 100
    //制作矩形
    // ctx.fillStyle = "transparent";
    ctx.fillStyle = "#004664";
    // ctx.drawImage(shopSignTexture, 0, 0, 1200, 200)
    ctx.fillRect(0, 0, 500, 100)
    //设置文字
    ctx.fillStyle = "#ffffff";
    // ctx.fillStyle = "#000000";
    ctx.font = `normal ${fontsize}px "楷体"`
    const textWidth = ctx.measureText(text).width;
    xLeft = 20 + (500 - textWidth) / 2
    ctx.fillText(text, xLeft, 40 + fontsize / 2)

    //生成图片
    let url = canvas.toDataURL('image/png');
    canvas.remove()

    let map = texLoader.load(url)
    map.center.set(0.5, 0.5)
    // map.rotation.z = Math.PI
    // map.rotation.y = Math.PI
    // map.flipY = false

    const material = new THREE.MeshBasicMaterial({
        map: map,
        lightmap: map,
        // side: THREE.DoubleSide,
        // opacity: 1,
        // transparent: true
    })

    object.material = material
}

function generateWalker(){
    const texture = texLoader.load(process.env.BASE_URL + 'mytextures/dummy.png', (texture) => {
        texture.colorSpace = THREE.SRGBColorSpace
        // texture.flipY = false
        // texture.generateMipmaps = false
        // texture.center.set(0.5, 0.5)
        // texture.rotation = Math.PI
    })
    const texture2 = texLoader.load(process.env.BASE_URL + 'mytextures/dummy2.png', (texture) => {
        texture.colorSpace = THREE.SRGBColorSpace
        // texture.flipY = false
        // texture.generateMipmaps = false
        // texture.center.set(0.5, 0.5)
        // texture.rotation = Math.PI
    })
    const padGeometry = new THREE.PlaneGeometry(0.4, 1.2)
    const material = new THREE.MeshBasicMaterial({
        map: texture,
        // color: 0xff0000,
        side: THREE.DoubleSide,
        opacity: 1,
        transparent: true
    })

    const material2 = new THREE.MeshBasicMaterial({
        map: texture2,
        // color: 0xff0000,
        side: THREE.DoubleSide,
        opacity: 1,
        transparent: true
    })

    const x = 297
    const y = 0.6

    const list = []

    for (let i = 0; i < 25; i++){
        for (let n = 0; n < 4; n++){
            const mesh = new THREE.Mesh(padGeometry, material)

            mesh.position.x = x + 10 * i
            mesh.position.y = y

            scene.add(mesh)
            list.push(mesh)

            switch (n) {
                case 0:
                    mesh.position.z = 30
                    break;

                case 1:
                    mesh.position.z = 34
                    break;

                case 2:
                    mesh.position.z = 41
                    break;

                case 3:
                    mesh.position.z = 45
                    break;
            }

            const offsetZ = -3 + Math.random() * 6
            mesh.position.z += offsetZ

            const v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
            v3.normalize()

            const key = `walker_${mesh.uuid}`
            const withAIObj = {
                model: mesh,
                positionY: mesh.position.y,
                offsetX: 0,
                offsetY: 0.5 * Math.random(),
                offsetZ: offsetZ,
                startX: mesh.position.x,
                startY: mesh.position.y,
                startZ: mesh.position.z,
                YDirect: 1,
                YSet: 0,
                v3: v3,
                AI: (obj) => {
                    obj.model.lookAt(meshGroup.position)

                    const distance = meshGroup.position.distanceTo(obj.model.position)

                    if (distance > 80 || distance < 2.5){
                        obj.model.visible = false
                    }else{
                        obj.model.visible = true
                    }

                    const moveDistance = mixerUpdateDelta * 1
                    const moveDistanceY = mixerUpdateDelta * 0.2

                    obj.offsetX += moveDistance * obj.v3.x
                    obj.offsetY += moveDistanceY * obj.YDirect
                    obj.offsetZ += moveDistance * obj.v3.z

                    let flag = false

                    if (obj.offsetX >= 2.5){
                        obj.offsetX = 2.5
                        flag = true
                    }else if(obj.offsetX <= -2.5){
                        obj.offsetX = -2.5
                        flag = true
                    }

                    if (obj.offsetY >= 0.15){
                        obj.offsetY = 0.15
                        obj.YDirect = -1
                    }else if(obj.offsetY <= 0){
                        obj.offsetY = 0
                        obj.YDirect = 1
                    }

                    if (obj.offsetZ >= 3){
                        obj.offsetZ = 3
                        flag = true
                    }else if(obj.offsetZ <= -3){
                        obj.offsetZ = -3
                        flag = true
                    }

                    obj.model.position.x = obj.startX + obj.offsetX

                    if (userInfoRef.value.vp){
                        obj.model.position.y = obj.startY + obj.offsetY
                    }else{
                        obj.model.position.y = -999
                    }

                    obj.model.position.z = obj.startZ + obj.offsetZ

                    if (flag){
                        obj.v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
                        obj.v3.normalize()
                    }
                }
            }

            WithAIObjSet[key] = withAIObj

            if (allCardList.length > 0){
                const dataIndex = (i * 5 + n) % allCardList.length
                createWalkerNamePad(mesh, dataIndex)

                const data = allCardList[dataIndex]

                if (data.memmale != 0){
                    mesh.material = material2
                }

                clickVisibleList.push(mesh)
                interactionObj[mesh.uuid] = [{
                    callback: () => {
                        personCardObj.value = data
                    }
                }]
            }

        }
    }

}

function getCardListFunc() {
    const request = cardApi.queryMemberworkAll
    const params = request.getParams()

    request.send(params, (res) => {
        if (res.code == 200){
            allCardList = res.detail
            generateWalker()
        }
    })

}
//人牌名
function createWalkerNamePad(mesh, index){
    const data = allCardList[index]

    if(null == data.name || "" === data.name){
        return
    }
    Promise.all([
        loadImage(process.env.BASE_URL + "mytextures/name_pad.png")
    ]).then((images) => {
        const regex = /[A-Za-z0-9]/g;

        //创建名牌
        let text2 = data.name

        if (myUtil.isNotEmpty(data.country)){
            const obj = getCountryObj(data.country)

            text2 = `${obj[userInfoRef.value.lang]} ${text2}`
        }

        let fontsize = 110 / (text2.length - (text2.match(regex) || []).length * 0.5);
        let xLeft

        if (fontsize > 40){
            fontsize = 40
        }

        // xLeft = 5 + (110 - fontsize * text.length) / 2

        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d')

        canvas.width = 120
        canvas.height = 40
        //制作矩形
        // ctx.fillStyle = "transparent";
        // ctx.fillRect(0, 0, 120, 60)
        ctx.drawImage(images[0], 0, 0, 120, 40)
        //设置文字
        ctx.fillStyle = "white";
        ctx.font = `normal ${fontsize}px "楷体"`
        var textWidth = ctx.measureText(text2).width;
        xLeft = 5 + (110 - textWidth) / 2
        ctx.fillText(text2, xLeft, (34 + fontsize) / 2)

        //生成图片
        let url = canvas.toDataURL('image/png');
        //将图片构建到纹理中
        const material = new THREE.SpriteMaterial({
            map: texLoader.load(url),
            // side: THREE.DoubleSide,
            opacity: 1,
            transparent: true
        })

        const sprite = new THREE.Sprite(material)
        sprite.position.y = 1.65

        sprite.scale.x = 1.5
        sprite.scale.y = 0.5

        sprite.name = "shopman_name_sprite"

        mesh.add(sprite)
        canvas.remove()

        clickVisibleList.push(sprite)
        interactionObj[sprite.uuid] = [{
            callback: () => {
                personCardObj.value = data
            }
        }]
    })
}

function closePersonCardCallback(){
    personCardObj.value = null
}

function personCardGoLoginCallback() {
    personCardObj.value = null
    goLogin()
}

function personCardGoChatCallback(login){
    personCardObj.value = null
    openNewChat(login)
}

function personCardGoMaterialChatCallback(login, url){
    personCardObj.value = null
    proxy.$refs.shopopeePhone.goMaterialChat(login, url)
}

provide('threeCityFunc', {
    changeCameraPerspective,
    changePersonModel,
    return3DOperatorFlag,
    call3DOperator,
    getOperateMode,
    setOperateMode
})
</script>

<style scoped>

ul{
    list-style: none;
    padding-left: 0;
    margin: 0;
}

.select-area-box {
    position: absolute;
    z-index: 400;
    width: 100%;
    height: 100%;
    background: #00000091;
    display: flex;
    left: 0;
    top: 0;
    align-items: center;
    justify-content: center;
}

@media screen and (min-width: 520px) {
    .select-area-box .select-area-div {
        width: 50%;
        height: 50%;
        padding: 20px;
        border-radius: 15px;
        background: #fefefe;
        font-size: 18px;
        color: #4e486d;
        font-weight: 800;
        user-select: none;

        box-sizing: border-box;
    }
}

@media screen and (max-width: 520px) {
    .select-area-box .select-area-div {
        width: 85%;
        height: 35%;
        padding: 20px;
        border-radius: 15px;
        background: #fefefe;
        font-size: 18px;
        color: #4e486d;
        font-weight: 800;
        user-select: none;

        box-sizing: border-box;
    }
}

.select-area-box .select-area-div .select-ul {
    width: 100%;
    height: 100%
}

.select-area-box .select-area-div .select-ul .title-part {
    height: 30px;
}

.select-area-box .select-area-div .select-ul .content-part {
    height: calc(70% - 30px);
    display: flex;
    align-items: center;
}

.select-area-box .select-area-div .select-ul .btns-part {
    height: 30%;
    display: flex;
    align-items: flex-end;
}

.select-area-box .select-input-part {
    display: flex;
    justify-content: center;
    /*margin-top: 20%;*/
    width: 100%;
}

.select-area-box .operation-box{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 30px;
    /*margin-top: 20%;*/
    user-select: none;

    width: 100%;
}

@media screen and (min-width: 520px) {
    .interaction-ui-upperRight {
        position: absolute;
        top: 20px;
        width: 100%;
        /*padding-right: 20px;*/
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: center;
        box-sizing: border-box;
        font-size: 12px;
        user-select: none;

    }

    /*.interaction-ui-upperRight {*/
    /*    position: absolute;*/
    /*    top: 20px;*/
    /*    right: 10px;*/
    /*    width: 40px;*/
    /*    !*padding-right: 20px;*!*/
    /*    display: flex;*/
    /*    justify-content: flex-end;*/
    /*    align-items: center;*/
    /*    text-align: center;*/
    /*    box-sizing: border-box;*/
    /*    font-size: 12px;*/
    /*    user-select: none;*/
    /*    flex-wrap: wrap;*/
    /*}*/
}

@media screen and (max-width: 520px) {
    .interaction-ui-upperRight {
        position: absolute;
        top: 20px;
        right: 10px;
        width: 40px;
        /*padding-right: 20px;*/
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: center;
        box-sizing: border-box;
        font-size: 12px;
        user-select: none;
        flex-wrap: wrap;
    }
}

@media screen and (min-width: 520px) {
    .interaction-ui-upperLeft {
        width: 30%;
        justify-content: flex-start;
        padding-left: 10px;
    }
}

@media screen and (max-width: 520px) {
    .interaction-ui-upperLeft {
        left: 10px;
    }
}


@media screen and (min-width: 520px) {
    /*.interaction-ui-upperRight .icon-part {*/
    /*    width: 60px;*/
    /*    height: 60px;*/
    /*    background: #ffffff;*/
    /*    border-radius: 50%;*/
    /*    border: #2c3e50;*/
    /*    margin-right: 20px;*/
    /*}*/

    /*.interaction-ui-upperRight .icon-part .icon-text {*/
    /*    margin-top: 10px;*/
    /*    font-size: 20px;*/
    /*    pointer-events: none;*/
    /*}*/

    /*.interaction-ui-upperRight .icon-part .icon-span {*/
    /*    pointer-events: none;*/
    /*}*/

    .interaction-ui-upperRight .icon-part {
        width: 40px;
        height: 40px;
        background: #ffffff;
        border-radius: 50%;
        border: #2c3e50;
        margin-right: 10px;
        /*margin-bottom: 10px;*/
    }

    .interaction-ui-upperRight .icon-part .icon-text {
        margin-top: 10px;
        font-size: 20px;
        pointer-events: none;
    }

    .interaction-ui-upperRight .icon-part .icon-span {
        display: none;
        pointer-events: none;
    }

    .interaction-ui-upperRight .icon-part .over-width-btn {
        position: absolute;
        height: 100%;
        background: #fff;
        top: 0;
        left: 0;
        width: max-content;
        box-sizing: border-box;
        padding: 5px;
        font-size: 12px;
        display: flex;
        align-items: center;
        border-radius: 5px;
    }
}

@media screen and (max-width: 520px) {
    .interaction-ui-upperRight .icon-part {
        width: 40px;
        height: 40px;
        background: #ffffff;
        border-radius: 50%;
        border: #2c3e50;
        /*margin-right: 10px;*/
        margin-bottom: 10px;
    }

    .interaction-ui-upperRight .icon-part .icon-text {
        margin-top: 10px;
        font-size: 20px;
        pointer-events: none;
    }

    .interaction-ui-upperRight .icon-part .over-width-btn {
        position: absolute;
        height: 100%;
        background: #fff;
        top: 0;
        left: 0;
        width: max-content;
        box-sizing: border-box;
        padding: 5px;
        font-size: 12px;
        display: flex;
        align-items: center;
        border-radius: 5px;
    }

    .interaction-ui-upperRight .icon-part .icon-span {
        display: none;
        pointer-events: none;
    }
}


@media screen and (min-width: 520px) {
    .show-material-ui-upper {
        position: absolute;
        top: 80px;
        width: 400px;
        height: 168px;
        z-index: 20;
        left: calc(50% - 200px);
        text-align: center;
        box-sizing: border-box;
        user-select: none;
        animation: show-top-material-animation 1s ease;
    }
}

@media screen and (max-width: 520px) {
    .show-material-ui-upper {
        position: absolute;
        top: 80px;
        width: 88%;
        height: 168px;
        z-index: 20;
        left: 5%;
        text-align: center;
        box-sizing: border-box;
        user-select: none;
        animation: show-top-material-animation 1s ease;
    }
}


@keyframes show-top-material-animation {

    0% {
        opacity: 0.5;
        top: -80px;
    }

    100% {
        opacity: 1;
        top: 80px;
    }

}

.loading_point_small{
    width: 2000px;
    height: 2000px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 50%;
    margin: auto;
    background-color: aliceblue;
    position: absolute;
    /* transition: all 1s ease; */
}
.loading_point_big{
    width: 50px;
    height: 50px;
    position: absolute;
    margin: auto;
    border-radius: 50%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: aliceblue;
    transform: scale(0.05);
    transition: all 2s ease;
    /* animation: point_big_ball 5s ease; */
}
@keyframes point_big_ball {
    0% {
        width: 100%;
        height: 100%;
    }
    100% {
        width: 100px;
        height: 100px;
    }
}

@media screen and (min-width: 520px) {
    .interaction-searchInput-upperRight {
        position: absolute;
        top: 10px;
        left: calc(50% - 150px);
        width: 300px;
        display: inline-block;
    }

    .top-search-input {
        display: inline-block;
        /*margin-right: 20px;*/
        opacity: 0.7;
    }

}

@media screen and (max-width: 520px) {
    .interaction-searchInput-upperRight {
        position: absolute;
        left: calc(50% - 100px);
        /*left: 0;*/
        top: 10px;
        width: calc(100% - 200px);
        text-align: center;
        //padding-left: 20px;
        display: inline-block;
    }

    .top-search-input {
        display: inline-block;
        /*width: 50%;*/
        margin-right: 25px;
        margin-top: 5px;
        opacity: 0.7;
    }

}

@media screen and (max-width: 800px) {
    /*input[type=text],textarea,.ivu-select{*/
    /*  font-size: 18px !important;*/
    /*  text-size-adjust: none;*/
    /*  -webkit-appearance: none;*/
    /*}*/

    input,textarea,.ivu-select{
        font-size: 18px !important;
        text-size-adjust: none;
        -webkit-appearance: none;
    }
}

.shop-man-name-div {
    position: relative;
    z-index: 200;
    /*width: 400px;*/
    /*height: 200px;*/
    padding: 15px 30px;
    border: 1px solid #55A3A3;
    /*left: 50px;*/
    /*top: 50px;*/
    background: #00000042;
    text-align: center;
    color: #fff;
    display: inline-block;
    user-select: none;

}

.shop-man-name-div span:nth-child(1){
    position: absolute;
    left: -3px;
    top: -3px;
    padding: 8px;
    border-style: solid;
    border-color: #28ffff;
    border-width: 3px 0 0 3px;
}
/*.shop-man-name-div span:nth-child(2){*/
/*    position: absolute;*/
/*    right: -5px;*/
/*    top: -5px;*/
/*    padding: 15px;*/
/*    border-style: solid;*/
/*    border-color: #28ffff;*/
/*    border-width: 5px 5px 0 0;*/
/*}*/
.shop-man-name-div span:nth-child(2){
    position: absolute;
    right: -3px;
    bottom: -3px;
    padding: 8px;
    border-style: solid;
    border-color: #28ffff;
    border-width: 0 3px 3px 0;
}
/*.shop-man-name-div span:nth-child(4){*/
/*    position: absolute;*/
/*    left: -5px;*/
/*    bottom: -5px;*/
/*    padding: 15px;*/
/*    border-style: solid;*/
/*    border-color: #28ffff;*/
/*    border-width: 0 0 5px 5px;*/
/*}*/

.hide-phone {
    margin-top: 0;
}

@media screen and (min-width: 520px) {
    .show-phone {
        /*margin-top: -420px;*/
        /*margin-top: -40vmin;*/
        margin-top: 0;
        //top: 10% !important;
    }
}

@media screen and (max-width: 520px) {
    .show-phone {
        /*margin-top: calc(-100% + 120px )*/
        margin-top: 0;
        //top: 5% !important;
    }
}

.shopopee-chat-view {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 1.5s ease;
    overflow: hidden;
    z-index: 1001;
}

@media screen and (min-width: 520px) {
    .shopopee-chat-view .close-div {
        display: inline-block;
        font-size: 24px;
        line-height: 50px;
        color: white;
        position: absolute;
        /*left: 50%;*/
        top:  -25px;
        right:0;
        /*margin-top: -400px;*/
        /*margin-left: 275px;*/
        border-radius: 50%;
        width: 50px;
        height: 50px;
        text-shadow: 0 1px 0 #484f58;
      border: 1px solid #734e4e;
      background-color: red;
        //border: 1px solid #734e4e;
        //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
        //background: -webkit-linear-gradient(top, #e92323, #551d1d);
        /*transition: all 1.5s ease;*/
        z-index: 100;
    }
}

@media screen and (max-width: 520px) {
    .shopopee-chat-view .close-div {
        display: inline-block;
        font-size: 30px;
        line-height: 40px;
        color: white;
        position: absolute;
        right: 3px;
        top: -20px;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        text-shadow: 0 1px 0 #484f58;
      border: 1px solid #734e4e;
      background-color: red;
        //border: 1px solid #734e4e;
        //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
        //background: -webkit-linear-gradient(top, #e92323, #551d1d);
        /*transition: all 1.5s ease;*/
        z-index: 100;
    }
}

.shopopee-chat-view .close-div-hide {
    opacity: 0;
    transform: scale(0.5);
    animation: hide-shopopee-chat-close-div 0.5s ease;
}

@keyframes hide-shopopee-chat-close-div {

    0% {
        opacity: 1;
        transform: scale(1);
    }

    100% {
        opacity: 0;
        transform: scale(0.5);
    }

}

.shopopee-chat-view .close-div-show {
    opacity: 1;
    transform: scale(1);
    animation: show-shopopee-chat-close-div 0.5s ease;
}

@keyframes show-shopopee-chat-close-div {

    0% {
        opacity: 0;
        transform: scale(0.5);
    }

    75% {
        opacity: 0;
        transform: scale(0.5);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }

}

.shopopee-chat-view-extend {
    background: #00000050;
}

.shopopee-chat-view-retract {
    background: #ffffff00;
}

.close-material-box-btn {
    display: inline-block;
    position: absolute;
    top: -20px;
    right: -20px;
    font-size: 20px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    text-shadow: 0 1px 0 #484f58;
    border: 1px solid #734e4e;
    box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
    background: -webkit-linear-gradient(top, #e92323, #551d1d);
    color: #ffffff;
    line-height: 30px;
}

.coutry-select-render {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
}

.map-select-box {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1200;
    left: 0;
    top: 0;
}

@media screen and (min-width: 768px) {
    .person-editor-box {
        position: absolute;
        width: 100%;
        height: 100%;
        //padding: 5%;
        border-radius: 5px;
        box-sizing: border-box;
        top: 0;
        left: 0;
        background: #0000003d;
        z-index: 2000;
    }
}

@media screen and (max-width: 768px) {
    .person-editor-box {
        position: absolute;
        width: 100%;
        height: 100%;
        //padding: 5%;
        //padding-top: 25%;
        //padding-bottom: 25%;
        //border-radius: 5px;
        box-sizing: border-box;
        top: 0;
        left: 0;
        background: #0000003d;
        z-index: 2000;
    }
}


</style>

<style>
body {
    margin: 0;
}

* {
    -webkit-touch-callout:none;
    -moz-touch-callout:none;
    -ms-touch-callout:none;
    touch-callout:none;

    -webkit-touch-callout: none;
    /*pointer-events: none;*/
    -webkit-user-select: none;
}

@media screen and (min-width: 520px) {
    .small-scrollbar::-webkit-scrollbar {
        width: 6px;
    }

    /*定义滚动条的轨道颜色、内阴影及圆角*/
    .small-scrollbar::-webkit-scrollbar-track {
        border-radius: 4px;
        /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
        /* background-color: rosybrown; */
    }

    /*定义滑块颜色、内阴影及圆角*/
    .small-scrollbar::-webkit-scrollbar-thumb {
        border-radius: 8px;
        background-color: #dddee0;
        /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
    }

    /*定义滑块悬停变化颜色、内阴影及圆角*/
    .small-scrollbar::-webkit-scrollbar-thumb:hover {
        background-color: #c7c9cc;
    }

    /*定义两端按钮的样式*/
    .small-scrollbar::-webkit-scrollbar-button {
        /* background-color: cyan; */
        display: none;
    }

    /*定义右下角汇合处的样式*/
    .small-scrollbar::-webkit-scrollbar-corner {
        /* background: khaki; */
    }
}

</style>